import type { Dictionary } from "@/lib/i18n/dictionaries/en";

const vi: Dictionary = {
  // ---- /citation-styles/alphabetical/<letter> ----
  styleDirectory: {
    notFoundTitle: "Không tìm thấy danh mục kiểu trích dẫn",
    metaTitle: "Các kiểu trích dẫn bắt đầu bằng {label}",
    metaDescription:
      "Duyệt {count} kiểu Citation Style Language bắt đầu bằng {label}. Mở bất kỳ kiểu nào để xem ví dụ trích dẫn thực tế và trình tạo miễn phí.",
    ogSubtitle: "{count} kiểu với ví dụ và trình tạo riêng.",
    ogKind: "Danh mục A–Z",
    schemaName: "Các kiểu trích dẫn bắt đầu bằng {label}",
    schemaDescription:
      "Danh mục theo bảng chữ cái gồm {count} kiểu Citation Style Language bắt đầu bằng {label}.",
    breadcrumbStyles: "Kiểu trích dẫn",
    heading: "Các kiểu trích dẫn bắt đầu bằng {label}",
    intro:
      "Duyệt tất cả {count} kiểu trong phần này của danh mục CSL. Mỗi trang gồm các ví dụ đã định dạng của kiểu đó và một trình tạo trích dẫn miễn phí.",
    navLabel: "Kiểu trích dẫn từ A đến Z",
    listHeading: "Tất cả kiểu bắt đầu bằng {label}",
  },
  nav: {
    tools: "Công cụ",
    guides: "Hướng dẫn",
    styles: "Tất cả kiểu trích dẫn",
    bibliography: "Thư mục của tôi",
    search: "Tìm kiếm",
    glossary: "Thuật ngữ",
    home: "Trang chủ",
    menu: "Menu",
  },

  home: {
    title: "Công cụ tạo trích dẫn miễn phí",
    subtitle: "Cập nhật cho năm 2026",
    intro:
      "Dán một DOI, đường dẫn hoặc mục BibTeX — hoặc tìm một cuốn sách — và nhận ngay tài liệu tham khảo được định dạng đúng theo APA, MLA, Chicago, Vancouver, Harvard cùng hàng nghìn kiểu khác. Hoàn toàn miễn phí, không cần gói thuê bao trả phí, không cần đăng ký.",
    browseAllStyles: "Xem toàn bộ {count} kiểu trích dẫn →",
    featuresHeading: "Mọi thứ bạn cần để trích dẫn",
    featureStyles: "{count} kiểu",
    featureStylesDetail: "APA, MLA, Chicago và nhiều kiểu khác",
    featureBibliographies: "Nhiều thư mục",
    featureBibliographiesDetail: "Sắp xếp theo từng bài",
    featureBookSearch: "Tìm sách",
    featureBookSearchDetail: "Theo tên sách hoặc tác giả",
    featureExport: "Xuất đi bất cứ đâu",
    featureExportDetail: "BibTeX, Word, RIS, CSV",
    featureDarkMode: "Chế độ tối",
    featureDarkModeDetail: "Dịu mắt",
    featureNoSignup: "Không cần đăng ký",
    featureNoSignupDetail: "Miễn phí mãi mãi, không cần gói thuê bao trả phí",
    aboutHeading:
      "Công cụ tạo trích dẫn miễn phí cho sinh viên và nhà nghiên cứu",
    aboutBody:
      "CitationEasy hỗ trợ hơn 10.000 kiểu trích dẫn học thuật. Dù bạn cần APA cho tâm lý học, MLA cho văn học, Chicago cho lịch sử hay Vancouver cho tạp chí y khoa, cách định dạng đều lấy từ định nghĩa chính thức của chính kiểu đó, không phải từ một bản mô phỏng gần đúng.",
    howItWorksHeading: "Cách hoạt động",
    howItWorksStep1:
      "Dán một DOI, đường dẫn, ISBN, mã PubMed hoặc arXiv, hay một mục BibTeX; bạn cũng có thể tìm sách theo tên.",
    howItWorksStep2:
      "Chọn kiểu trích dẫn. Gõ để tìm trong toàn bộ {count} kiểu.",
    howItWorksStep3:
      "Sao chép tài liệu tham khảo đã hoàn chỉnh, hoặc lưu vào thư mục rồi xuất ra Word, BibTeX hay RIS.",
    privacyNote:
      "Thư mục của bạn được lưu ngay trong trình duyệt của bạn. Không cần tài khoản và không có gì được tải lên máy chủ.",
  },

  hubs: {
    toolsTitle: "Công cụ viết và trích dẫn miễn phí",
    toolsIntro:
      "{count} công cụ chạy ngay trong trình duyệt để viết và trích dẫn: bộ tạo trích dẫn cho mọi loại nguồn, bộ đếm từ và ký tự, chấm điểm dễ đọc, công cụ định dạng và chuyển đổi. Tất cả đều miễn phí và cho kết quả tức thì.",
    stylesTitle: "Duyệt mọi kiểu trích dẫn",
    stylesIntro:
      "Toàn bộ {count} kiểu từ dự án Citation Style Language, có thể tìm kiếm và lọc theo quốc gia, chủ đề và lĩnh vực học thuật.",
    guidesTitle: "Hướng dẫn trích dẫn và viết học thuật",
    guidesIntro:
      "Hướng dẫn chuyên sâu về cách trích dẫn từng loại nguồn, đánh giá tài liệu tìm được và viết tốt hơn.",
    howToCiteTitle: "Cách trích dẫn mọi loại nguồn",
    howToCiteIntro:
      "Các trang hướng dẫn từng bước, ghép mỗi loại nguồn thường gặp với những kiểu trích dẫn chính, mỗi trang đều có ví dụ thực tế.",
    faqTitle: "Hỏi đáp về trích dẫn",
    faqIntro:
      "Câu trả lời ngắn gọn và chính xác cho những thắc mắc sinh viên thực sự gặp khi trích dẫn.",
    glossaryTitle: "Thuật ngữ trích dẫn",
    glossaryIntro:
      "Định nghĩa dễ hiểu cho những thuật ngữ xuất hiện trong sổ tay kiểu trích dẫn và đề bài.",
    openHub: "Mở",
  },

  styleLanding: {
    metaTitle: "Công cụ tạo trích dẫn {style} miễn phí",
    metaDescription:
      "Tạo trích dẫn {style} miễn phí. Dán DOI, đường dẫn, ISBN hoặc BibTeX để nhận mục tài liệu tham khảo và trích dẫn trong bài đúng định dạng {style}.",
    heading: "Công cụ tạo trích dẫn {style}",
    intro:
      "Tạo trích dẫn {style} chính xác cho sách, bài báo khoa học và trang web chỉ với một cú nhấp. Miễn phí và không cần đăng ký.",
    aboutHeading: "Về kiểu {style}",
    whenToUseHeading: "Khi nào dùng {style}",
    factsHeading: "Tổng quan về {style}",
    factEdition: "Phiên bản",
    factSystem: "Hệ thống trích dẫn",
    factInText: "Dạng trong bài",
    factReferenceList: "Tên danh mục",
    factFields: "Phổ biến trong",
    systemAuthorDate: "Tác giả–năm",
    systemNumbered: "Đánh số",
    systemFootnotes: "Chú thích chân trang",
    howToHeading: "Cách dùng công cụ {style} này",
    howToStep1:
      "Dán đường dẫn, DOI, ISBN hoặc mục BibTeX vào ô phía trên, hoặc tìm sách theo tên.",
    howToStep2:
      "{style} đã được chọn sẵn trên trang này, nên bạn có thể tạo trích dẫn ngay.",
    howToStep3:
      "Sao chép kết quả vào bài viết, hoặc lưu lại rồi xuất toàn bộ danh mục sau.",
    relatedHeading: "Thêm tài nguyên về {style}",
    englishOnlyNote:
      "Hướng dẫn chi tiết về {style} và ví dụ theo từng loại nguồn hiện có bằng tiếng Anh.",
  },

  // The per-style pages at `/<locale>/citation-style/<slug>` — one per catalog style.
  //
  // The formatted examples the page is built around (the style's own output for a
  // fixed journal article, book and website) and the style's own name stay in
  // `src/data/citation-styles.ts` and `src/data/style-examples-generated.json`. They
  // are language-neutral: a citation rendered by the style's own CSL definition looks
  // the same whatever language the reader speaks, and "translating" one would make the
  // page wrong.
  //
  // The rest of what `src/data/**` supplies to these pages is NOT like that — see the
  // `generic*`, `discipline*` and `internationalLabel` keys below.
  citationStylePage: {
    notFoundTitle: "Không tìm thấy kiểu trích dẫn",
    metaTitle: "Công cụ tạo trích dẫn {style} - Định dạng {style} miễn phí",
    metaFormatAndFields: "{style} là kiểu {format}, được dùng trong {fields}.",
    metaFormatOnly: "{style} là kiểu {format}.",
    metaFieldsOnly: "{style} được dùng trong {fields}.",
    metaPromiseNote:
      "Xem một chú thích chân trang {style} thật và tự tạo miễn phí.",
    metaPromiseExamples:
      "Xem ví dụ trích dẫn {style} thật cho bài báo khoa học, sách và trang web, rồi tự tạo miễn phí.",
    ogKindFormat: "Kiểu {format}",
    ogKindDefault: "Kiểu trích dẫn",
    // Joins the style's discipline list: "psychology, education and nursing".
    disciplineConjunction: "và",
    // ---- Data-derived facts that are nonetheless mail-merged prose ----
    //
    // Every entry in `src/data/citation-styles-generated.ts` carries exactly the
    // two sentences below with their own name spliced in, exactly one region value
    // ("International" — that is `internationalLabel` above, reused rather than
    // duplicated), and discipline tokens drawn from a closed 26-word vocabulary. None
    // of that is a citation, so none of it is language-neutral the way the formatted
    // examples are. Left in `src/data/**` it renders English facts inside translated
    // chrome, which is precisely the hybrid page this tree exists to avoid.
    //
    // The page substitutes the two templates ONLY when a style's stored text is
    // byte-identical to the English template with its own name interpolated, so the
    // ~100 hand-curated styles keep their bespoke English descriptions instead of
    // being flattened into a generic sentence. `{name}` is the style's full name.
    genericDescription:
      "Kiểu trích dẫn dành cho {name}. Từ kho lưu trữ Citation Style Language.",
    genericWhenUsed:
      "Dùng khi nộp bài hoặc trích dẫn trong các ấn phẩm sử dụng kiểu {name}.",

    // The 26 discipline tokens `style-examples-generated.json` uses. Each English
    // value is the exact string the page printed before these keys existed — the raw
    // token with hyphens turned into spaces — so `generic-base` reads "generic base"
    // and `political_science` keeps its underscore. An unknown token (a new one from
    // upstream CSL) falls back to that same prettified form rather than to a key name.
    disciplineAnthropology: "nhân học",
    disciplineAstronomy: "thiên văn học",
    disciplineBiology: "sinh học",
    disciplineBotany: "thực vật học",
    disciplineChemistry: "hóa học",
    disciplineCommunications: "truyền thông",
    disciplineEngineering: "kỹ thuật",
    disciplineGenericBase: "tổng quát",
    disciplineGeography: "địa lý học",
    disciplineGeology: "địa chất học",
    disciplineHistory: "lịch sử",
    disciplineHumanities: "nhân văn",
    disciplineLaw: "luật",
    disciplineLinguistics: "ngôn ngữ học",
    disciplineLiterature: "văn học",
    disciplineMath: "toán học",
    disciplineMedicine: "y học",
    disciplinePhilosophy: "triết học",
    disciplinePhysics: "vật lý học",
    disciplinePoliticalScience: "chính trị học",
    disciplinePsychology: "tâm lý học",
    disciplineScience: "khoa học",
    disciplineSocialScience: "khoa học xã hội",
    disciplineSociology: "xã hội học",
    disciplineTheology: "thần học",
    disciplineZoology: "động vật học",

    // Plain-language descriptions of the citation-format classes the CSL definitions
    // declare. `{format}` in the fallback is the raw class name from the data.
    formatClassAuthorDate:
      "kiểu tác giả–năm: trích dẫn trong bài nêu tên tác giả và năm, còn danh mục tài liệu tham khảo được xếp theo thứ tự chữ cái của tác giả",
    formatClassNumeric:
      "kiểu đánh số: các nguồn được đánh số theo thứ tự được trích dẫn lần đầu, và trích dẫn trong bài dùng chính những con số đó",
    formatClassNote:
      "kiểu dùng chú thích: trích dẫn xuất hiện trong chú thích chân trang hoặc chú thích cuối bài thay vì trong ngoặc đơn ở phần văn bản",
    formatClassLabel:
      "kiểu dùng nhãn: trích dẫn trong bài dùng một nhãn ngắn gọn tạo từ tên tác giả và năm",
    formatClassAuthor:
      "kiểu chỉ nêu tác giả: trích dẫn trong bài chỉ nêu tên tác giả, còn chi tiết đầy đủ nằm trong danh mục tài liệu tham khảo",
    formatClassOther: "kiểu {format}",
    breadcrumbStyles: "Kiểu trích dẫn",
    internationalLabel: "Quốc tế",
    heading: "Công cụ tạo trích dẫn {style}",
    intro:
      "Tạo trích dẫn {style} chính xác cho sách, bài báo và trang web chỉ với một cú nhấp.",
    examplesHeading: "Ví dụ trích dẫn {style}",
    examplesIntro: "Cùng ba nguồn này được định dạng theo {style}:",
    examplesIntroWithFormat:
      "Cùng ba nguồn này được định dạng theo {style} — {format}:",
    examplesNoteOnlyIntro:
      "{style} là kiểu dùng chú thích: không có danh mục tài liệu tham khảo, và mọi trích dẫn đều là chú thích chân trang. Dưới đây là bài báo khoa học mẫu được trích dẫn theo {style}:",
    labelJournalArticle: "Bài báo khoa học",
    labelBook: "Sách",
    labelWebsite: "Trang web",
    labelFootnote: "Chú thích chân trang (bài báo khoa học)",
    labelInText: "Trích dẫn trong bài (cho bài báo khoa học)",
    aboutHeading: "Về kiểu {style}",
    whenToUseLabel: "Khi nào dùng {style}:",
    commonInLabel: "Phổ biến trong:",
    subjectAreasLabel: "Lĩnh vực:",
    formattingRulesLabel: "Quy tắc định dạng:",
    parentStylePrefix: "{style} tuân theo cách định dạng của",
    parentStyleSuffix: ", kiểu gốc mà nó dựa theo.",
    howToHeading: "Cách dùng công cụ {style} này",
    howToBody:
      'Dán một DOI, đường dẫn tới bài báo hoặc trang web, hoặc mã BibTeX thô vào ô phía trên. Bạn cũng có thể tìm sách theo nhan đề hoặc tác giả và trích dẫn bằng ISBN. Chọn "{style}" trong danh sách kiểu trích dẫn (đã được chọn sẵn trên trang này), rồi nhấn "Tạo trích dẫn". Sao chép kết quả vào danh mục tài liệu tham khảo hoặc thư mục của bạn. Bạn có thể sửa mục vừa tạo (ví dụ: sửa nhan đề hoặc thêm ngày) trước khi sao chép.',
    faqHeading: "Câu hỏi thường gặp về {style}",
    faqWhatIsQ: "{style} là gì?",
    faqWhenQ: "Khi nào nên dùng {style}?",
    faqInTextQ: "Trích dẫn trong bài theo {style} trông như thế nào?",
    faqInTextA:
      "{style} là {format}. Trích dẫn bài báo khoa học mẫu của chúng tôi trong bài viết trông như sau: {example}",
    faqReferenceQ:
      "Một mục trong danh mục tài liệu tham khảo theo {style} trông như thế nào?",
    faqReferenceA:
      "Một bài báo khoa học được định dạng theo {style} trông như sau: {example}",
    faqWhereQ: "{style} thường được dùng ở đâu?",
    faqWhereA: "{style} được dùng {region}. {whenUsed}",
    faqRegionDefault: "trên toàn thế giới",
    faqGenerateQ: "Làm thế nào để tạo trích dẫn {style}?",
    faqGenerateA:
      "Dùng công cụ miễn phí ngay trên trang này: dán một DOI, URL (ví dụ: bài báo) hoặc BibTeX, hoặc tìm sách theo nhan đề hoặc tác giả. Chọn {style} làm kiểu trích dẫn rồi nhấn Tạo để nhận tài liệu tham khảo đã định dạng, có thể sao chép vào bài viết hoặc thư mục của bạn.",
    footerSupports:
      "hỗ trợ nhiều kiểu trích dẫn từ khắp nơi trên thế giới. Công cụ tạo trích dẫn của chúng tôi sử dụng các kiểu Citation Style Language (CSL) từ",
    footerRepoLink: "kho lưu trữ CSL chính thức",
  },

  // The source × style pages at `/<locale>/how-to-cite/<slug>` — 1,290 combinations.
  //
  // Same division as above: the citation templates, the worked examples generated from
  // each style's own CSL definition, the in-text samples and the hand-checked
  // formatting rules stay in the page module and in
  // `src/data/how-to-cite-examples-generated.json`. They are the citations themselves,
  // not prose about them. Source names, style names and editions come from
  // `src/data/how-to-cite.ts` and arrive here as placeholder values.
  crossLinks: {
    generateHeading: "Tạo trích dẫn này",
    generateBody:
      "Dán URL, DOI, ISBN hoặc thông tin nguồn và nhận ngay trích dẫn {style} hoàn chỉnh cho {source}.",
    generateCta: "Mở {tool} →",
    guideHeading: "Tìm hiểu thêm",
    guideCta: "Đọc hướng dẫn đầy đủ: {guide}",
    howToCiteHeading: "Cách trích dẫn {source} theo từng kiểu",
    howToCiteBody:
      "Quy tắc định dạng, mẫu và ví dụ minh họa cho các kiểu trích dẫn được yêu cầu nhiều nhất.",
    howToCiteMore: "Tất cả loại nguồn và kiểu trích dẫn →",
    citeNowHeading: "Trích dẫn {source} theo {style} ngay",
    citeNowHowTo: "Quy tắc định dạng và ví dụ minh họa",
    citeNowTool: "Tạo bằng {tool}",
    citeNowHub: "Trình tạo trích dẫn {style}",
    hubSourcesHeading: "Cách trích dẫn các nguồn phổ biến theo {style}",
    hubGuidesHeading: "Hướng dẫn {style}",
    hubCompareHeading: "So sánh {style} với các kiểu khác",
    moreInCollection: "Thêm trong {collection}",
    seeAllInCollection: "Xem tất cả trong {collection}",
  },

  howToCitePage: {
    notFoundTitle: "Không tìm thấy trang",
    title: "Cách trích dẫn {source} theo {style} ({edition})",
    metaTitle:
      "Cách trích dẫn {source} theo {style} [{edition}, Cập nhật 2026]",
    metaDescription:
      "Tìm hiểu cách trích dẫn {description} theo định dạng {style} ({edition}). Ví dụ, mẫu và hướng dẫn trích dẫn trong bài miễn phí.",
    keywordCite: "trích dẫn {source} {style}",
    keywordCitation: "trích dẫn {source} theo {style}",
    keywordHowTo: "cách trích dẫn {source}",
    keywordExample: "ví dụ trích dẫn {style}",
    keywordReference: "tài liệu tham khảo {source} {style}",
    // What each style calls the list at the back of the paper, in the two casings the
    // prose needs. MLA says "Works Cited", Chicago and the legal styles "Bibliography".
    refListWorksCited: "Danh mục Tài liệu Trích dẫn",
    refListWorksCitedPage: "trang Danh mục Tài liệu Trích dẫn",
    refListBibliography: "Thư mục Tham khảo",
    refListBibliographyLower: "thư mục tham khảo",
    refListReferenceList: "Danh mục Tài liệu Tham khảo",
    refListReferenceListLower: "danh mục tài liệu tham khảo",
    backLink: "← Tất cả hướng dẫn trích dẫn",
    lead: "Tìm hiểu cách trích dẫn {description} theo định dạng {style} ({edition}). Hướng dẫn này bao gồm định dạng danh mục tài liệu tham khảo, ví dụ trích dẫn trong bài và các quy tắc định dạng quan trọng.",
    referenceFormatHeading: "Định dạng {list} theo {style}",
    referenceFormatIntro:
      "Dưới đây là định dạng chuẩn của {style} để trích dẫn {source} trong {list} của bạn:",
    noTemplateNote: "Hãy làm theo mẫu chuẩn của {style} cho loại nguồn này.",
    workedHeading: "Ví dụ trích dẫn {source} theo {style}",
    workedIntro:
      "Một tài liệu tham khảo {style} hoàn chỉnh cho {source}, được định dạng theo định nghĩa kiểu CSL {style} chính thức — chính công cụ vận hành trình tạo trích dẫn trên trang này:",
    workedNoteOnlyIntro:
      "{style} không đưa {source} vào {list} — nguồn này chỉ được trích dẫn trong chú thích. Dưới đây là chú thích đó, được định dạng theo định nghĩa kiểu CSL {style} chính thức:",
    workedOscolaNote:
      "Kết quả OSCOLA do trang này tạo ra theo kiểu CSL của ấn bản thứ 4, vì kho Citation Style Language chưa phát hành kiểu CSL cho ấn bản thứ 5. Hãy chỉnh bằng tay: thay mỗi ibid bằng tên rút gọn và (n X), dùng định danh tòa án của ấn bản thứ 5, đặt dạng rút gọn của đạo luật trong dấu nháy đơn và ưu tiên liên kết cố định hoặc DOI hơn ngày truy cập",
    workedCheckedIntro:
      "Một tài liệu tham khảo {style} hoàn chỉnh cho {source}, được viết thủ công và đối chiếu với hướng dẫn chính thức của {style} cho loại nguồn này:",
    workedCheckedNoteOnlyIntro:
      "{style} không đưa {source} vào {list} — nguồn này chỉ được trích dẫn trong chú thích. Dưới đây là chú thích đó, được viết thủ công và đối chiếu với hướng dẫn chính thức của {style}:",
    workedInTextLabel: "Trích dẫn trong bài tương ứng:",
    inTextHeading: "Trích dẫn trong bài theo {style}",
    inTextIntro:
      "Dùng một trong các định dạng sau khi nhắc đến nguồn này trong bài viết của bạn:",
    inTextParenthetical: "Trong ngoặc",
    inTextNarrative: "Tường thuật",
    rulesHeading: "Quy tắc định dạng quan trọng của {style}",
    stepsHeading: "Hướng dẫn từng bước",
    step1Label: "Thu thập thông tin nguồn:",
    step1Body:
      "Thu thập tên tác giả, nhan đề, ngày xuất bản và URL hoặc DOI cần thiết để trích dẫn {source}.",
    step2Label: "Định dạng tài liệu tham khảo:",
    step2Body:
      "Sắp xếp các thành phần theo mẫu {style} ({edition}) đã trình bày ở trên.",
    step3Label: "Tạo trích dẫn trong bài:",
    step3Body:
      "Thêm trích dẫn trong ngoặc hoặc tường thuật vào bài viết ở chỗ bạn nhắc đến nguồn này.",
    step4Label: "Thêm vào {list} của bạn:",
    step4Body: "Đưa trích dẫn đã định dạng đầy đủ vào cuối bài viết của bạn.",
    step5Label: "Kiểm tra lại định dạng:",
    step5Body:
      "Kiểm tra chữ nghiêng, dấu câu, viết hoa và thụt lề treo có đúng theo yêu cầu của {style} hay không.",
    ctaHeading: "Tự động tạo trích dẫn này",
    ctaBody:
      "Bỏ qua việc định dạng thủ công. Dán một DOI, URL hoặc ISBN vào CitationEasy để có ngay trích dẫn {style} được định dạng hoàn hảo chỉ trong vài giây.",
    ctaButton: "Trích dẫn theo {style} ngay →",
    otherStylesHeading: "Trích dẫn {source} theo kiểu khác",
    comboLink: "{source} theo {style}",
    otherSourcesHeading: "Trích dẫn nguồn khác theo {style}",
    resourcesHeading: "Tài nguyên khác",
    resourceGenerator: "Công cụ tạo trích dẫn miễn phí ({count} kiểu)",
    resourceTools: "Công cụ viết miễn phí",
    resourceCompare: "So sánh các kiểu trích dẫn",
    resourceGuides: "Tất cả hướng dẫn trích dẫn",
    resourceCheatSheets: "Bảng tra nhanh (APA, MLA, Chicago)",
    resourceGlossary: "Thuật ngữ trích dẫn (et al., ibid., DOI, thụt lề treo)",
    // HowTo structured data. Deliberately worded differently from the visible steps
    // above: the schema describes the task generically, the page walks the reader
    // through this particular source and style.
    schemaStep1Name: "Thu thập thông tin nguồn",
    schemaStep1Text:
      "Thu thập đầy đủ thông tin cần thiết để trích dẫn {source}, gồm tác giả, nhan đề, ngày tháng và URL hoặc DOI.",
    schemaStep2Name: "Định dạng theo {style}",
    schemaStep2Text:
      "Làm theo quy tắc định dạng của {style} ({edition}) để sắp xếp các thành phần trích dẫn đúng thứ tự.",
    schemaStep3Name: "Tạo trích dẫn trong bài",
    schemaStep3Text:
      "Thêm trích dẫn trong bài tương ứng vào bài viết của bạn theo định dạng {style}.",
    schemaStep4Name: "Thêm vào danh mục tài liệu tham khảo",
    schemaStep4Text: "Đưa trích dẫn đầy đủ vào {list} ở cuối bài viết của bạn.",
    faqHowQ: "Làm thế nào để trích dẫn {source} theo {style}?",
    faqHowA:
      "Để trích dẫn {source} theo {style} ({edition}), hãy nêu tác giả, nhan đề, ngày tháng và vị trí nguồn. Dùng công cụ tạo trích dẫn miễn phí của chúng tôi để định dạng tự động.",
    faqFormatQ: "Định dạng {style} cho trích dẫn {source} là gì?",
    faqFormatA: "Định dạng {style} cho {source} là: {example}",
    faqFormatFallback:
      "Định dạng {style} yêu cầu các thành phần cụ thể như tác giả, nhan đề, ngày tháng và vị trí nguồn được sắp xếp theo một thứ tự nhất định.",
    faqInTextQ:
      "Trích dẫn trong bài cho {source} theo {style} trông như thế nào?",
    faqInTextA: "Theo {style}, trích dẫn trong bài cho ví dụ trên là {example}",
  },

  // The 43 source types the how-to-cite pages are built from (`SOURCE_TYPES` in
  // `src/data/how-to-cite.ts`), in the five forms those pages print. Each form is a whole
  // phrase, never an article and a noun joined in code: an article agrees with its noun
  // in gender, number and case, elides in French and Italian, and has no counterpart
  // at all in Polish, Russian or Japanese.
  //
  // - `…Name` ("Book") is the type on its own, as a label: `howToCitePage.comboLink`.
  //   English also lower-cases it into the `keyword*` templates.
  // - `…Title` ("a Book") is the type as the object of "cite" in a title or heading:
  //   `title`, `metaTitle`, `workedHeading` and `otherStylesHeading`, plus
  //   `crossLinks.generateBody`, `howToCiteHeading` and `citeNowHeading`. Through
  //   `title` it is also the HowTo name, the OG card and every link to the page.
  // - `…Phrase` ("a book") is the same inside a sentence: `referenceFormatIntro`,
  //   `workedIntro`, `workedNoteOnlyIntro` and the five `faq*` questions and answers.
  // - `…Noun` ("book") is the bare noun inside a sentence, where English puts "your" in
  //   front of it: `step1Body` and `schemaStep1Text`. A translation also uses it in the
  //   `keyword*` templates, which read as search queries.
  // - `…Description` is what the type covers: `{description}` in `lead` and
  //   `metaDescription`.
  //
  // A language with case picks one case per form and words every template above around
  // it — German writes Title and Phrase in the accusative, Polish and Russian write Name
  // and Noun in the nominative. Changing a form's case means re-reading every template
  // that receives it. A key missing here falls back to the English data
  // (`howToCiteSourceForms`), so a new source type renders in English, not as a key.
  // Vietnamese: no articles, case or classifiers; Name is sentence-cased, Title, Phrase and Noun are lower-case.
  howToCiteSources: {
    websiteName: "Trang web",
    websiteTitle: "trang web",
    websitePhrase: "trang web",
    websiteNoun: "trang web",
    websiteDescription: "trang web, bài viết trực tuyến và nội dung web",

    bookName: "Sách",
    bookTitle: "sách",
    bookPhrase: "sách",
    bookNoun: "sách",
    bookDescription: "sách in và sách điện tử",

    journalArticleName: "Bài báo tạp chí học thuật",
    journalArticleTitle: "bài báo tạp chí học thuật",
    journalArticlePhrase: "bài báo tạp chí học thuật",
    journalArticleNoun: "bài báo tạp chí học thuật",
    journalArticleDescription:
      "bài báo tạp chí học thuật và bài báo đã qua bình duyệt",

    youtubeVideoName: "Video YouTube",
    youtubeVideoTitle: "video YouTube",
    youtubeVideoPhrase: "video YouTube",
    youtubeVideoNoun: "video YouTube",
    youtubeVideoDescription: "video YouTube và video trực tuyến",

    podcastName: "Podcast",
    podcastTitle: "podcast",
    podcastPhrase: "podcast",
    podcastNoun: "podcast",
    podcastDescription: "từng tập podcast và toàn bộ chương trình podcast",

    newspaperArticleName: "Bài báo trên báo",
    newspaperArticleTitle: "bài báo trên báo",
    newspaperArticlePhrase: "bài báo trên báo",
    newspaperArticleNoun: "bài báo trên báo",
    newspaperArticleDescription: "bài báo trên báo in và báo điện tử",

    magazineArticleName: "Bài viết trên tạp chí",
    magazineArticleTitle: "bài viết trên tạp chí",
    magazineArticlePhrase: "bài viết trên tạp chí",
    magazineArticleNoun: "bài viết trên tạp chí",
    magazineArticleDescription:
      "bài viết trên tạp chí in và tạp chí trực tuyến",

    blogPostName: "Bài đăng blog",
    blogPostTitle: "bài đăng blog",
    blogPostPhrase: "bài đăng blog",
    blogPostNoun: "bài đăng blog",
    blogPostDescription: "bài đăng blog và bài bình luận trực tuyến",

    wikipediaName: "Wikipedia",
    wikipediaTitle: "Wikipedia",
    wikipediaPhrase: "Wikipedia",
    wikipediaNoun: "Wikipedia",
    wikipediaDescription: "bài viết Wikipedia và các mục từ wiki",

    pdfName: "Tài liệu PDF",
    pdfTitle: "tài liệu PDF",
    pdfPhrase: "tài liệu PDF",
    pdfNoun: "PDF",
    pdfDescription: "tài liệu và báo cáo dạng PDF",

    interviewName: "Phỏng vấn",
    interviewTitle: "phỏng vấn",
    interviewPhrase: "phỏng vấn",
    interviewNoun: "phỏng vấn",
    interviewDescription:
      "các cuộc phỏng vấn cá nhân, đã xuất bản và được phát sóng",

    socialMediaName: "Bài đăng mạng xã hội",
    socialMediaTitle: "bài đăng mạng xã hội",
    socialMediaPhrase: "bài đăng mạng xã hội",
    socialMediaNoun: "bài đăng mạng xã hội",
    socialMediaDescription:
      "bài đăng trên X (Twitter), Instagram, Facebook và video TikTok",

    governmentDocumentName: "Văn bản chính phủ",
    governmentDocumentTitle: "văn bản chính phủ",
    governmentDocumentPhrase: "văn bản chính phủ",
    governmentDocumentNoun: "văn bản chính phủ",
    governmentDocumentDescription:
      "báo cáo của chính phủ, văn bản pháp luật và tài liệu chính thức",

    dissertationName: "Luận án hoặc luận văn",
    dissertationTitle: "luận án hoặc luận văn",
    dissertationPhrase: "luận án hoặc luận văn",
    dissertationNoun: "luận án hoặc luận văn",
    dissertationDescription: "luận án tiến sĩ và luận văn thạc sĩ",

    conferencePaperName: "Bài báo hội nghị",
    conferencePaperTitle: "bài báo hội nghị",
    conferencePaperPhrase: "bài báo hội nghị",
    conferencePaperNoun: "bài báo hội nghị",
    conferencePaperDescription: "kỷ yếu hội nghị và bài trình bày tại hội nghị",

    lectureNotesName: "Bài giảng hoặc PowerPoint",
    lectureNotesTitle: "bài giảng hoặc PowerPoint",
    lectureNotesPhrase: "bài giảng hoặc PowerPoint",
    lectureNotesNoun: "bài giảng hoặc PowerPoint",
    lectureNotesDescription:
      "bài giảng trên lớp, bản trình chiếu và tài liệu khóa học",

    webinarName: "Hội thảo trực tuyến",
    webinarTitle: "hội thảo trực tuyến",
    webinarPhrase: "hội thảo trực tuyến",
    webinarNoun: "hội thảo trực tuyến",
    webinarDescription:
      "các buổi hội thảo trực tuyến (webinar) phát trực tiếp hoặc đã ghi hình",

    onlineCourseName: "Khóa học trực tuyến",
    onlineCourseTitle: "khóa học trực tuyến",
    onlineCoursePhrase: "khóa học trực tuyến",
    onlineCourseNoun: "khóa học trực tuyến",
    onlineCourseDescription:
      "khóa học trực tuyến và MOOC (Coursera, edX, Udemy, FutureLearn)",

    presentationSlidesName: "Bài thuyết trình PowerPoint",
    presentationSlidesTitle: "bài thuyết trình PowerPoint",
    presentationSlidesPhrase: "bài thuyết trình PowerPoint",
    presentationSlidesNoun: "bài thuyết trình PowerPoint",
    presentationSlidesDescription:
      "bài thuyết trình PowerPoint và các bộ trang chiếu",

    imageName: "Hình ảnh hoặc ảnh chụp",
    imageTitle: "hình ảnh hoặc ảnh chụp",
    imagePhrase: "hình ảnh hoặc ảnh chụp",
    imageNoun: "hình ảnh hoặc ảnh chụp",
    imageDescription:
      "ảnh chụp, tác phẩm nghệ thuật, biểu đồ và hình ảnh trực tuyến",

    movieName: "Phim",
    movieTitle: "phim",
    moviePhrase: "phim",
    movieNoun: "phim",
    movieDescription: "một bộ phim",

    documentaryName: "Phim tài liệu",
    documentaryTitle: "phim tài liệu",
    documentaryPhrase: "phim tài liệu",
    documentaryNoun: "phim tài liệu",
    documentaryDescription: "phim tài liệu và phim phi hư cấu",

    tvShowName: "Chương trình truyền hình",
    tvShowTitle: "chương trình truyền hình",
    tvShowPhrase: "chương trình truyền hình",
    tvShowNoun: "chương trình truyền hình",
    tvShowDescription:
      "một chương trình truyền hình hoặc phim truyền hình dài tập",

    songName: "Bài hát hoặc bản nhạc",
    songTitle: "bài hát hoặc bản nhạc",
    songPhrase: "bài hát hoặc bản nhạc",
    songNoun: "bài hát hoặc bản nhạc",
    songDescription: "một bài hát hoặc bản thu âm",

    poemName: "Bài thơ",
    poemTitle: "bài thơ",
    poemPhrase: "bài thơ",
    poemNoun: "bài thơ",
    poemDescription: "bài thơ, đoạn thơ và thơ ca trong tuyển tập hoặc tập thơ",

    courtCaseName: "Vụ án tòa án",
    courtCaseTitle: "vụ án tòa án",
    courtCasePhrase: "vụ án tòa án",
    courtCaseNoun: "vụ án tòa án",
    courtCaseDescription: "một vụ án hoặc phán quyết của tòa án",

    patentName: "Bằng sáng chế",
    patentTitle: "bằng sáng chế",
    patentPhrase: "bằng sáng chế",
    patentNoun: "bằng sáng chế",
    patentDescription: "một bằng sáng chế hoặc hồ sơ đăng ký sở hữu trí tuệ",

    encyclopediaName: "Mục từ bách khoa toàn thư",
    encyclopediaTitle: "mục từ bách khoa toàn thư",
    encyclopediaPhrase: "mục từ bách khoa toàn thư",
    encyclopediaNoun: "mục từ bách khoa toàn thư",
    encyclopediaDescription:
      "một bài viết hoặc mục từ trong bách khoa toàn thư",

    dictionaryName: "Mục từ điển",
    dictionaryTitle: "mục từ điển",
    dictionaryPhrase: "mục từ điển",
    dictionaryNoun: "mục từ điển",
    dictionaryDescription: "một định nghĩa hoặc mục từ trong từ điển",

    datasetName: "Bộ dữ liệu",
    datasetTitle: "bộ dữ liệu",
    datasetPhrase: "bộ dữ liệu",
    datasetNoun: "bộ dữ liệu",
    datasetDescription: "một bộ dữ liệu hoặc cơ sở dữ liệu",

    softwareName: "Phần mềm hoặc ứng dụng",
    softwareTitle: "phần mềm hoặc ứng dụng",
    softwarePhrase: "phần mềm hoặc ứng dụng",
    softwareNoun: "phần mềm hoặc ứng dụng",
    softwareDescription: "phần mềm, ứng dụng hoặc chương trình máy tính",

    videoGameName: "Trò chơi điện tử",
    videoGameTitle: "trò chơi điện tử",
    videoGamePhrase: "trò chơi điện tử",
    videoGameNoun: "trò chơi điện tử",
    videoGameDescription: "trò chơi điện tử và phần mềm trò chơi tương tác",

    pressReleaseName: "Thông cáo báo chí",
    pressReleaseTitle: "thông cáo báo chí",
    pressReleasePhrase: "thông cáo báo chí",
    pressReleaseNoun: "thông cáo báo chí",
    pressReleaseDescription: "một thông cáo báo chí hoặc bản tin chính thức",

    reportName: "Báo cáo",
    reportTitle: "báo cáo",
    reportPhrase: "báo cáo",
    reportNoun: "báo cáo",
    reportDescription: "một báo cáo hoặc sách trắng",

    preprintName: "Bản thảo trước xuất bản",
    preprintTitle: "bản thảo trước xuất bản",
    preprintPhrase: "bản thảo trước xuất bản",
    preprintNoun: "bản thảo trước xuất bản",
    preprintDescription:
      "bài báo trên arXiv, bioRxiv và các kho bản thảo trước xuất bản khác",

    bookChapterName: "Chương sách",
    bookChapterTitle: "chương sách",
    bookChapterPhrase: "chương sách",
    bookChapterNoun: "chương sách",
    bookChapterDescription:
      "chương sách và bài tiểu luận trong sách có chủ biên",

    chatgptName: "ChatGPT",
    chatgptTitle: "ChatGPT",
    chatgptPhrase: "ChatGPT",
    chatgptNoun: "ChatGPT",
    chatgptDescription: "ChatGPT và các công cụ AI tạo sinh khác",

    bibleName: "Kinh Thánh",
    bibleTitle: "Kinh Thánh",
    biblePhrase: "Kinh Thánh",
    bibleNoun: "Kinh Thánh",
    bibleDescription: "Kinh Thánh, kinh sách và các văn bản thiêng liêng khác",

    tedTalkName: "Bài nói chuyện TED",
    tedTalkTitle: "bài nói chuyện TED",
    tedTalkPhrase: "bài nói chuyện TED",
    tedTalkNoun: "bài nói chuyện TED",
    tedTalkDescription:
      "bài nói chuyện TED và bài phát biểu hội nghị được ghi hình",

    emailName: "Email",
    emailTitle: "email",
    emailPhrase: "email",
    emailNoun: "email",
    emailDescription: "email, thư từ và các hình thức giao tiếp cá nhân",

    redditName: "Bài đăng trên Reddit hoặc diễn đàn",
    redditTitle: "bài đăng trên Reddit hoặc diễn đàn",
    redditPhrase: "bài đăng trên Reddit",
    redditNoun: "bài đăng trên Reddit",
    redditDescription:
      "chuỗi thảo luận Reddit, phiên hỏi đáp AMA và bài đăng trên diễn đàn hoặc bảng thảo luận trực tuyến",

    tweetName: "Bài đăng trên X (Twitter)",
    tweetTitle: "bài đăng trên X (Twitter)",
    tweetPhrase: "bài đăng trên X",
    tweetNoun: "bài đăng trên X",
    tweetDescription: "tweet và bài đăng trên X (trước đây là Twitter)",

    mapName: "Bản đồ",
    mapTitle: "bản đồ",
    mapPhrase: "bản đồ",
    mapNoun: "bản đồ",
    mapDescription: "bản đồ in, tập bản đồ và bản đồ động như Google Maps",

    claudeName: "Claude",
    claudeTitle: "Claude",
    claudePhrase: "Claude",
    claudeNoun: "Claude",
    claudeDescription:
      "các cuộc trò chuyện với Claude và nội dung AI khác của Anthropic",

    geminiName: "Gemini",
    geminiTitle: "Gemini",
    geminiPhrase: "Gemini",
    geminiNoun: "Gemini",
    geminiDescription:
      "các cuộc trò chuyện với Google Gemini và nội dung do AI tạo ra",

    copilotName: "Microsoft Copilot",
    copilotTitle: "Microsoft Copilot",
    copilotPhrase: "Microsoft Copilot",
    copilotNoun: "Microsoft Copilot",
    copilotDescription:
      "các cuộc trò chuyện và câu trả lời AI của Microsoft Copilot",

    perplexityName: "Perplexity",
    perplexityTitle: "Perplexity",
    perplexityPhrase: "Perplexity",
    perplexityNoun: "Perplexity",
    perplexityDescription:
      "câu trả lời AI, chuỗi hội thoại của Perplexity và các nguồn được trích dẫn trong đó",

    aiImageName: "Hình ảnh do AI tạo ra",
    aiImageTitle: "hình ảnh do AI tạo ra",
    aiImagePhrase: "hình ảnh do AI tạo ra",
    aiImageNoun: "hình ảnh do AI tạo ra",
    aiImageDescription:
      "hình ảnh được tạo bằng DALL·E, Midjourney, Gemini và các công cụ AI khác",

    tiktokName: "Video TikTok",
    tiktokTitle: "video TikTok",
    tiktokPhrase: "video TikTok",
    tiktokNoun: "video TikTok",
    tiktokDescription: "video TikTok và bài đăng của nhà sáng tạo nội dung",

    instagramName: "Bài đăng trên Instagram",
    instagramTitle: "bài đăng trên Instagram",
    instagramPhrase: "bài đăng trên Instagram",
    instagramNoun: "bài đăng trên Instagram",
    instagramDescription: "bài đăng, thước phim (Reels) và tin trên Instagram",

    statuteName: "Luật hoặc đạo luật",
    statuteTitle: "luật hoặc đạo luật",
    statutePhrase: "luật hoặc đạo luật",
    statuteNoun: "luật hoặc đạo luật",
    statuteDescription:
      "các đạo luật của cơ quan lập pháp, luật thành văn và bộ luật đã được pháp điển hóa",

    isoStandardName: "Tiêu chuẩn ISO",
    isoStandardTitle: "tiêu chuẩn ISO",
    isoStandardPhrase: "tiêu chuẩn ISO",
    isoStandardNoun: "tiêu chuẩn ISO",
    isoStandardDescription:
      "tiêu chuẩn ISO, IEC và các tiêu chuẩn kỹ thuật đã công bố khác",

    quranName: "Kinh Qur'an",
    quranTitle: "Kinh Qur'an",
    quranPhrase: "Kinh Qur'an",
    quranNoun: "Kinh Qur'an",
    quranDescription: "Kinh Qur'an, bằng tiếng Ả Rập hoặc bản dịch",

    ebookNoPageNumbersName: "Sách điện tử không có số trang",
    ebookNoPageNumbersTitle: "sách điện tử không có số trang",
    ebookNoPageNumbersPhrase: "sách điện tử không có số trang",
    ebookNoPageNumbersNoun: "sách điện tử không có số trang",
    ebookNoPageNumbersDescription:
      "sách điện tử Kindle, EPUB và sách điện tử trực tuyến không có số trang cố định",

    speechName: "Bài phát biểu",
    speechTitle: "bài phát biểu",
    speechPhrase: "bài phát biểu",
    speechNoun: "bài phát biểu",
    speechDescription:
      "bài phát biểu, diễn văn và bài giảng đạo, trực tiếp hoặc được ghi lại",

    letterName: "Thư",
    letterTitle: "thư",
    letterPhrase: "thư",
    letterNoun: "thư",
    letterDescription: "thư đã xuất bản, thư lưu trữ và thư ngỏ",

    secondarySourceName: "Nguồn thứ cấp",
    secondarySourceTitle: "nguồn thứ cấp",
    secondarySourcePhrase: "nguồn thứ cấp",
    secondarySourceNoun: "nguồn thứ cấp",
    secondarySourceDescription:
      "nguồn bạn tìm thấy được trích dẫn trong một tác phẩm khác",
  },

  // ---------------------------------------------------------------------------
  // STRINGS TRANSLATED; PAGE TYPES NOT YET ENABLED. These sections' string
  // values are now translated, but the page types they cover (`taxonomy`,
  // `compare`, `convert`) are still deliberately absent from
  // TRANSLATED_PAGE_TYPES — enabling them is a separate step that also needs
  // the data-derived facts and a real-render check (see CLAUDE.md's
  // "translating a page type takes two passes" note), not just this string pass.
  // ---------------------------------------------------------------------------
  // The three browse-by-facet pages under `/<locale>/citation-styles/…` — 32 academic
  // fields, 68 countries and 39 subject categories, 139 pages in one section because
  // they share a shell, a breadcrumb trail and a styles browser.
  //
  // The style NAMES, slugs and the CSL catalog itself stay in `src/data/**`: those are
  // subject matter. What the facets themselves are called is not — "Political Science",
  // "United Kingdom" and "Film & Media" are ordinary nouns that every reader expects in
  // their own language, and there are only 139 of them in total (see the `academicFields`,
  // `regions` and `styleCategories` sections below).
  taxonomyPage: {
    // ---- /citation-styles/field/<slug> ----
    fieldNotFoundTitle: "Không tìm thấy",
    fieldMetaTitle:
      "Kiểu Trích Dẫn Cho {field} - Kiểu Tham Khảo Tốt Nhất [2026]",
    fieldMetaDescription:
      "Khám phá các kiểu trích dẫn phổ biến nhất trong {field}. Tìm định dạng tham khảo phù hợp cho bài luận, luận văn hoặc bài nộp tạp chí ngành {fieldLower} của bạn.",
    fieldOgTitle: "Kiểu trích dẫn cho {field}",
    fieldOgSubtitle: "Thường được yêu cầu: {styles}.",
    fieldOgKind: "Theo lĩnh vực học thuật",
    fieldKeywordStyle: "kiểu trích dẫn {field}",
    fieldKeywordReferencing: "{field} và cách tham khảo",
    fieldKeywordBest: "kiểu trích dẫn tốt nhất cho {fieldLower}",
    fieldKeywordBibliography: "định dạng thư mục {fieldLower}",
    fieldKeywordDiscipline: "kiểu trích dẫn theo lĩnh vực",
    fieldBackLink: "← Tất cả kiểu trích dẫn",
    fieldHeading: "Kiểu Trích Dẫn Cho {field}",
    fieldRecommendedHeading: "Kiểu Trích Dẫn Được Khuyến Nghị",
    fieldRecommendedIntro:
      "Các kiểu trích dẫn sau thường được dùng trong nghiên cứu, tạp chí và bài tập của ngành {field}. Chọn một kiểu để tìm hiểu thêm và bắt đầu tạo trích dẫn.",
    fieldStyleFallback:
      "Một kiểu trích dẫn được dùng trong {field} và các ngành liên quan.",
    fieldRelatedHeading: "Các Lĩnh Vực Liên Quan",
    fieldRelatedIntro:
      "Khám phá các kiểu trích dẫn được dùng trong những ngành học liên quan:",
    fieldCtaHeading: "Khám Phá Tất Cả Kiểu Trích Dẫn",
    fieldCtaBody:
      "CitationEasy hỗ trợ {count} kiểu trích dẫn trên mọi ngành học thuật. Duyệt toàn bộ bộ sưu tập để tìm đúng định dạng bạn cần.",
    fieldCtaButton: "Xem Tất Cả Kiểu →",
    fieldFaqWhichQ: "Ngành {field} dùng kiểu trích dẫn nào?",
    fieldFaqWhichA:
      "Kiểu trích dẫn dùng trong {field} tùy thuộc vào yêu cầu cụ thể của tạp chí, cơ sở đào tạo hoặc giảng viên. Các kiểu phổ biến gồm {styles}. Hãy luôn kiểm tra hướng dẫn bài tập hoặc tạp chí mục tiêu để biết định dạng bắt buộc.",
    fieldFaqSameQ: "Mọi tạp chí ngành {field} có dùng chung một kiểu không?",
    fieldFaqSameA:
      "Không, các tạp chí ngành {field} không dùng chung một kiểu trích dẫn. Dù một số kiểu phổ biến hơn trong ngành, từng tạp chí vẫn có thể có yêu cầu định dạng riêng. Hãy luôn kiểm tra hướng dẫn nộp bài của tạp chí trước khi chuẩn bị bản thảo.",
    fieldFaqChooseQ:
      "Làm sao để chọn kiểu trích dẫn cho bài luận ngành {field} của tôi?",
    fieldFaqChooseA:
      "Để chọn kiểu trích dẫn cho bài luận ngành {field}, trước tiên hãy kiểm tra xem giảng viên hoặc tạp chí mục tiêu có yêu cầu kiểu cụ thể không. Nếu không, hãy dùng một trong các kiểu thường được khuyến nghị cho {field} ở trên. CitationEasy hỗ trợ hơn {count} kiểu và có thể tạo trích dẫn theo bất kỳ kiểu nào trong số đó, hoàn toàn miễn phí.",

    // ---- /citation-styles/country/<slug> ----
    countryNotFoundTitle: "Không tìm thấy quốc gia",
    countryMetaTitle: "Kiểu trích dẫn {country} - APA, MLA và hơn thế",
    countryMetaDescription:
      "Duyệt các kiểu trích dẫn được dùng tại {country}. Công cụ tạo trích dẫn miễn phí cho các định dạng của {country}.",
    countryOgTitle: "Kiểu trích dẫn dùng tại {country}",
    countryOgKind: "Theo quốc gia",
    countryHeading: "Kiểu trích dẫn {country}",
    countryIntroOne:
      "{count} kiểu trích dẫn thường được dùng tại hoặc gắn liền với {country}. Chọn một kiểu để mở công cụ tạo trích dẫn riêng.",
    countryIntroMany:
      "{count} kiểu trích dẫn thường được dùng tại hoặc gắn liền với {country}. Chọn một kiểu để mở công cụ tạo trích dẫn riêng.",
    countryBrowserTitle: "Kiểu Trích Dẫn {country}",

    // ---- /citation-styles/type/<slug> ----
    typeNotFoundTitle: "Không tìm thấy loại",
    typeMetaTitle: "Kiểu trích dẫn {type} - Công cụ miễn phí",
    typeMetaDescription:
      "Kiểu trích dẫn cho {typeLower}. APA, MLA, Vancouver và nhiều kiểu khác. Công cụ tạo trích dẫn miễn phí.",
    typeOgTitle: "Kiểu trích dẫn {type}",
    typeOgKind: "Theo chủ đề",
    typeHeading: "Kiểu trích dẫn {type}",
    typeIntroOne:
      "{count} kiểu trích dẫn cho {typeLower}. Chọn một kiểu để mở công cụ tạo trích dẫn riêng kèm câu hỏi thường gặp.",
    typeIntroMany:
      "{count} kiểu trích dẫn cho {typeLower}. Chọn một kiểu để mở công cụ tạo trích dẫn riêng kèm câu hỏi thường gặp.",
    typeBrowserTitle: "Kiểu Trích Dẫn {type}",

    // ---- Shared chrome ----
    breadcrumbStyles: "Kiểu trích dẫn",
    // Title case, because the BreadcrumbList markup says "Citation Styles" while the
    // visible trail says "Citation styles". Two keys rather than one so translating
    // either does not silently change the other.
    breadcrumbStylesSchema: "Kiểu Trích Dẫn",
    breadcrumbByCountry: "Theo quốc gia",
    breadcrumbByDiscipline: "Theo ngành học",
    allStylesLink: "← Tất cả kiểu trích dẫn",
    internationalLabel: "Quốc tế",
  },

  // The 32 academic fields (`ACADEMIC_FIELDS` in src/data/style-pages.ts), keyed by
  // slug. Their one-sentence `description` is next door in `academicFieldDescriptions`.
  academicFields: {
    psychology: "Tâm lý học",
    education: "Giáo dục học",
    sociology: "Xã hội học",
    anthropology: "Nhân học",
    politicalScience: "Khoa học chính trị",
    economics: "Kinh tế học",
    business: "Kinh doanh & Quản trị",
    literature: "Văn học & Ngôn ngữ",
    history: "Lịch sử",
    philosophy: "Triết học",
    law: "Luật & Nghiên cứu pháp lý",
    medicine: "Y học & Khoa học lâm sàng",
    nursing: "Điều dưỡng & Hộ sinh",
    publicHealth: "Y tế công cộng & Dịch tễ học",
    pharmacy: "Dược học",
    biology: "Sinh học & Khoa học sự sống",
    chemistry: "Hóa học",
    physics: "Vật lý học",
    engineering: "Kỹ thuật",
    computerScience: "Khoa học máy tính",
    mathematics: "Toán học & Thống kê",
    environmentalScience: "Khoa học môi trường",
    earthScience: "Khoa học trái đất & Địa chất",
    artHistory: "Lịch sử nghệ thuật & Nghệ thuật thị giác",
    music: "Âm nhạc & Âm nhạc học",
    theology: "Thần học & Nghiên cứu tôn giáo",
    socialWork: "Công tác xã hội",
    linguistics: "Ngôn ngữ học",
    architecture: "Kiến trúc & Quy hoạch đô thị",
    filmMedia: "Điện ảnh & Truyền thông học",
    journalism: "Báo chí & Truyền thông",
    criminology: "Tội phạm học & Tư pháp hình sự",
  },

  // The same 32 fields' one-sentence ledes — the opening paragraph of every
  // `/citation-styles/field/<slug>` page.
  //
  // Unlike everything above, these are hand-written per field rather than mail-merged
  // from a template, which is why the extraction pass left them in
  // `src/data/style-pages.ts`: translating them is a content job, not a string swap.
  // But "hand-written" describes how they were produced, not where they belong. With
  // the chrome translated and the lede still English, the page is the hybrid CLAUDE.md
  // calls worse than an honest redirect — translated furniture around an English core.
  // `academicFieldDescription()` (src/lib/i18n/data-labels.ts) falls back to the data
  // file's own value, so a field added upstream is untranslated rather than blank.
  academicFieldDescriptions: {
    psychology:
      "Các kiểu trích dẫn thường dùng trong tâm lý học, khoa học hành vi và nghiên cứu nhận thức.",
    education:
      "Các kiểu trích dẫn cho nghiên cứu giáo dục, sư phạm và nghiên cứu chương trình học.",
    sociology:
      "Các kiểu trích dẫn dùng trong nghiên cứu xã hội học và lý thuyết xã hội.",
    anthropology: "Các kiểu trích dẫn cho nghiên cứu nhân học và dân tộc học.",
    politicalScience:
      "Các kiểu trích dẫn cho nghiên cứu khoa học chính trị, chính phủ và chính sách công.",
    economics:
      "Các kiểu trích dẫn dùng trong nghiên cứu kinh tế học và kinh tế lượng.",
    business:
      "Các kiểu trích dẫn cho nghiên cứu kinh doanh, quản trị, tiếp thị và tài chính.",
    literature:
      "Các kiểu trích dẫn cho nghiên cứu văn học, ngôn ngữ học và ngôn ngữ.",
    history:
      "Các kiểu trích dẫn cho nghiên cứu lịch sử, sử học và nghiên cứu lưu trữ.",
    philosophy:
      "Các kiểu trích dẫn cho các bài viết triết học và nghiên cứu đạo đức học.",
    law: "Các kiểu trích dẫn pháp lý cho văn bản tòa án, tạp chí luật và nghiên cứu học thuật về luật.",
    medicine:
      "Các kiểu trích dẫn cho nghiên cứu y học, nghiên cứu lâm sàng và chăm sóc sức khỏe.",
    nursing:
      "Các kiểu trích dẫn cho nghiên cứu điều dưỡng và thực hành chăm sóc sức khỏe.",
    publicHealth:
      "Các kiểu trích dẫn cho nghiên cứu y tế công cộng và nghiên cứu dịch tễ học.",
    pharmacy: "Các kiểu trích dẫn cho nghiên cứu dược phẩm và dược lý học.",
    biology:
      "Các kiểu trích dẫn cho nghiên cứu sinh học, sinh thái học và di truyền học.",
    chemistry:
      "Các kiểu trích dẫn cho nghiên cứu hóa học, hóa sinh và khoa học vật liệu.",
    physics:
      "Các kiểu trích dẫn cho nghiên cứu vật lý học, vật lý thiên văn và vật lý ứng dụng.",
    engineering:
      "Các kiểu trích dẫn cho nghiên cứu kỹ thuật và công nghệ ứng dụng.",
    computerScience:
      "Các kiểu trích dẫn cho nghiên cứu khoa học máy tính, AI và kỹ thuật phần mềm.",
    mathematics:
      "Các kiểu trích dẫn cho nghiên cứu toán học, toán ứng dụng và thống kê.",
    environmentalScience:
      "Các kiểu trích dẫn cho nghiên cứu môi trường và nghiên cứu phát triển bền vững.",
    earthScience:
      "Các kiểu trích dẫn cho nghiên cứu địa chất học, địa vật lý và khoa học trái đất.",
    artHistory:
      "Các kiểu trích dẫn cho lịch sử nghệ thuật, nghiên cứu văn hóa thị giác và bảo tàng học.",
    music:
      "Các kiểu trích dẫn cho nghiên cứu âm nhạc, lý thuyết âm nhạc và nghiên cứu biểu diễn.",
    theology:
      "Các kiểu trích dẫn cho các công trình học thuật về thần học và tôn giáo.",
    socialWork:
      "Các kiểu trích dẫn cho nghiên cứu và thực hành công tác xã hội.",
    linguistics:
      "Các kiểu trích dẫn cho ngôn ngữ học, ngữ âm học và khoa học ngôn ngữ.",
    architecture:
      "Các kiểu trích dẫn cho nghiên cứu kiến trúc, thiết kế đô thị và quy hoạch.",
    filmMedia:
      "Các kiểu trích dẫn cho nghiên cứu điện ảnh, truyền hình, truyền thông và giao tiếp.",
    journalism:
      "Các kiểu trích dẫn cho nghiên cứu báo chí, nghiên cứu truyền thông và giao tiếp.",
    criminology:
      "Các kiểu trích dẫn cho nghiên cứu tội phạm học và tư pháp hình sự.",
  },

  // The 68 country/region facets (`REGIONS` in src/data/citation-styles.ts), keyed by
  // slug. `getRegionCountryCode` still keys off the English data value, so translating these
  // moves the label without moving the flag.
  regions: {
    unitedStates: "Hoa Kỳ",
    unitedKingdom: "Vương quốc Anh",
    australia: "Úc",
    canada: "Canada",
    newZealand: "New Zealand",
    ireland: "Ireland",
    southAfrica: "Nam Phi",
    germany: "Đức",
    france: "Pháp",
    spain: "Tây Ban Nha",
    italy: "Ý",
    netherlands: "Hà Lan",
    belgium: "Bỉ",
    switzerland: "Thụy Sĩ",
    austria: "Áo",
    portugal: "Bồ Đào Nha",
    luxembourg: "Luxembourg",
    sweden: "Thụy Điển",
    norway: "Na Uy",
    denmark: "Đan Mạch",
    finland: "Phần Lan",
    iceland: "Iceland",
    poland: "Ba Lan",
    czechRepublic: "Cộng hòa Séc",
    hungary: "Hungary",
    romania: "Romania",
    russia: "Nga",
    ukraine: "Ukraine",
    greece: "Hy Lạp",
    turkey: "Thổ Nhĩ Kỳ",
    croatia: "Croatia",
    slovenia: "Slovenia",
    slovakia: "Slovakia",
    serbia: "Serbia",
    bulgaria: "Bulgaria",
    lithuania: "Lithuania",
    latvia: "Latvia",
    estonia: "Estonia",
    japan: "Nhật Bản",
    china: "Trung Quốc",
    southKorea: "Hàn Quốc",
    india: "Ấn Độ",
    singapore: "Singapore",
    hongKong: "Hồng Kông",
    taiwan: "Đài Loan",
    malaysia: "Malaysia",
    indonesia: "Indonesia",
    thailand: "Thái Lan",
    vietnam: "Việt Nam",
    philippines: "Philippines",
    pakistan: "Pakistan",
    bangladesh: "Bangladesh",
    sriLanka: "Sri Lanka",
    israel: "Israel",
    saudiArabia: "Ả Rập Xê Út",
    unitedArabEmirates: "Các Tiểu vương quốc Ả Rập Thống nhất",
    brazil: "Brazil",
    mexico: "Mexico",
    argentina: "Argentina",
    chile: "Chile",
    colombia: "Colombia",
    peru: "Peru",
    venezuela: "Venezuela",
    egypt: "Ai Cập",
    nigeria: "Nigeria",
    kenya: "Kenya",
    morocco: "Morocco",
    international: "Quốc tế",
  },

  // The 39 subject categories (`CATEGORIES` in src/data/citation-styles.ts), keyed by
  // slug. The emoji beside each one stays in the data — it is language-neutral.
  styleCategories: {
    medicine: "Y học",
    nursing: "Điều dưỡng",
    publicHealth: "Y tế công cộng",
    pharmacy: "Dược học",
    dentistry: "Nha khoa",
    veterinary: "Thú y",
    psychology: "Tâm lý học",
    sociology: "Xã hội học",
    anthropology: "Nhân học",
    politicalScience: "Khoa học chính trị",
    economics: "Kinh tế học",
    education: "Giáo dục học",
    socialWork: "Công tác xã hội",
    biology: "Sinh học",
    chemistry: "Hóa học",
    physics: "Vật lý học",
    environmentalScience: "Khoa học môi trường",
    earthScience: "Khoa học trái đất & Địa chất",
    agriculture: "Nông nghiệp",
    ecology: "Sinh thái học",
    engineering: "Kỹ thuật",
    computerScience: "Khoa học máy tính",
    mathematics: "Toán học",
    statistics: "Thống kê",
    history: "Lịch sử",
    literature: "Văn học",
    philosophy: "Triết học",
    linguistics: "Ngôn ngữ học",
    artHistory: "Lịch sử nghệ thuật",
    music: "Âm nhạc",
    filmMedia: "Điện ảnh & Truyền thông",
    archaeology: "Khảo cổ học",
    law: "Luật",
    business: "Kinh doanh",
    architecture: "Kiến trúc",
    religion: "Tôn giáo & Thần học",
    geography: "Địa lý học",
    general: "Tổng hợp / Đa ngành",
    other: "Khác",
  },

  // The closed vocabularies `STYLE_LANDING_PAGES` (src/data/style-pages.ts) draws on for
  // the 30 major styles: what each style calls its end-of-paper list, the shape of its
  // in-text citation, its edition, and the disciplines that require it. The comparison
  // pages print all four in a table and the field pages print two of them under every
  // style card, so leaving them in the data means a translated page with an English
  // table in the middle of it.
  //
  // Style NAMES (`name`, `fullName`) are NOT here: a style's official name is what it
  // is called everywhere. The 30 hand-written taglines are, in `styleTaglines` below.
  styleFacts: {
    // `referenceListName` — 6 distinct values across the 30 styles.
    listReferenceList: "Danh mục Tài liệu Tham khảo",
    listWorksCited: "Danh mục Tài liệu Trích dẫn",
    listReferences: "Tài liệu Tham khảo",
    listBibliography: "Thư mục Tham khảo",
    listTableOfAuthorities: "Bảng Trích dẫn Pháp lý",
    listReferencesCited: "Tài liệu Được Trích dẫn",
    listLowerReferenceList: "danh mục tài liệu tham khảo",
    listLowerWorksCited: "danh mục tài liệu trích dẫn",
    listLowerReferences: "tài liệu tham khảo",
    listLowerBibliography: "thư mục tham khảo",
    listLowerTableOfAuthorities: "bảng trích dẫn pháp lý",
    listLowerReferencesCited: "tài liệu được trích dẫn",

    // `inTextFormat` — 14 distinct values. "Author", "Year" and "Page" are slot names,
    // not part of the citation, so they read as English words on a Spanish page.
    inTextAuthorCommaYear: "(Tác giả, Năm)",
    inTextAuthorPage: "(Tác giả Trang)",
    inTextAuthorYear: "(Tác giả Năm)",
    inTextSuperscriptOrBracketed: "Số mũ hoặc số trong ngoặc (1)",
    inTextBracketedNumbers: "Số trong ngoặc vuông [1]",
    inTextSuperscriptNumbers: "Số mũ¹",
    inTextSuperscriptOrAuthorYear: "Số mũ hoặc (Tác giả Năm)",
    inTextKeyBased: "Trích dẫn theo khóa tham chiếu",
    inTextSuperscriptOrAuthorCommaYear: "Số mũ hoặc (Tác giả, Năm)",
    inTextFootnotesCaseLegislation:
      "Chú thích chân trang với trích dẫn án lệ và văn bản pháp luật",
    inTextFootnotesSignals: "Chú thích chân trang với các từ viết tắt tín hiệu",
    inTextFootnotesPinpoint: "Chú thích chân trang với vị trí trích dẫn cụ thể",
    inTextParenNumbers: "Số trong ngoặc đơn (1)",
    inTextItalicNumbers: "Số in nghiêng (1)",

    // `edition` — 12 distinct values. The ordinal and the word "edition" translate; the
    // handbook name inside "Cite Them Right 11th edition" does not.
    edition4th: "Phiên bản thứ 4",
    edition5th: "Phiên bản thứ 5",
    edition7th: "Phiên bản thứ 7",
    edition8th: "Phiên bản thứ 8",
    edition9th: "Phiên bản thứ 9",
    edition11th: "Phiên bản thứ 11",
    edition18th: "Phiên bản thứ 18",
    edition22nd: "Phiên bản thứ 22",
    editionCiteThemRight11th: "Cite Them Right phiên bản thứ 11",
    editionIcmjeStandard: "Tiêu chuẩn ICMJE",
    editionStandard: "tiêu chuẩn",
    editionCurrent: "hiện hành",

    // `fields` — the 67 discipline names the 30 styles are tagged with.
    fieldAcoustics: "Âm học",
    fieldAnthropology: "Nhân học",
    fieldAppliedPhysics: "Vật lý ứng dụng",
    fieldArchaeology: "Khảo cổ học",
    fieldArts: "Nghệ thuật",
    fieldAstrophysics: "Vật lý thiên văn",
    fieldAustralianLaw: "Luật Úc",
    fieldBiochemistry: "Hóa sinh",
    fieldBiology: "Sinh học",
    fieldBiomedicalSciences: "Khoa học Y sinh",
    fieldBiotechnology: "Công nghệ sinh học",
    fieldBusiness: "Kinh doanh",
    fieldCellBiology: "Sinh học tế bào",
    fieldChemicalEngineering: "Kỹ thuật hóa học",
    fieldChemistry: "Hóa học",
    fieldClinicalResearch: "Nghiên cứu lâm sàng",
    fieldComputerScience: "Khoa học máy tính",
    fieldCondensedMatter: "Vật lý chất ngưng tụ",
    fieldCourtDocuments: "Văn bản tòa án",
    fieldCriminology: "Tội phạm học",
    fieldCulturalStudies: "Nghiên cứu văn hóa",
    fieldDemography: "Nhân khẩu học",
    fieldEcology: "Sinh thái học",
    fieldEducation: "Giáo dục học",
    fieldElectronics: "Điện tử học",
    fieldEngineering: "Kỹ thuật",
    fieldEnvironmentalScience: "Khoa học môi trường",
    fieldEpidemiology: "Dịch tễ học",
    fieldEthnography: "Dân tộc học",
    fieldGenetics: "Di truyền học",
    fieldGeology: "Địa chất học",
    fieldGlobalHealth: "Y tế toàn cầu",
    fieldHealthSciences: "Khoa học sức khỏe",
    fieldHistory: "Lịch sử",
    fieldHumanities: "Nhân văn",
    fieldInformationSystems: "Hệ thống thông tin",
    fieldInformationTechnology: "Công nghệ thông tin",
    fieldInternationalRelations: "Quan hệ quốc tế",
    fieldJurisprudence: "Lý luận pháp luật",
    fieldLanguages: "Ngôn ngữ",
    fieldLaw: "Luật",
    fieldLawReview: "Tạp chí Luật học",
    fieldLegalStudies: "Nghiên cứu pháp lý",
    fieldLifeSciences: "Khoa học sự sống",
    fieldLiterature: "Văn học",
    fieldMaterialsScience: "Khoa học vật liệu",
    fieldMathematics: "Toán học",
    fieldMedicine: "Y học",
    fieldMolecularBiology: "Sinh học phân tử",
    fieldMultidisciplinary: "Đa ngành",
    fieldMultidisciplinaryScience: "Khoa học đa ngành",
    fieldNaturalSciences: "Khoa học tự nhiên",
    fieldNursing: "Điều dưỡng",
    fieldPharmacy: "Dược học",
    fieldPhysics: "Vật lý học",
    fieldPoliticalScience: "Khoa học chính trị",
    fieldPsychology: "Tâm lý học",
    fieldPublicHealth: "Y tế công cộng",
    fieldPublicPolicy: "Chính sách công",
    fieldPublishing: "Xuất bản",
    fieldScience: "Khoa học",
    fieldSciences: "Khoa học",
    fieldSocialSciences: "Khoa học xã hội",
    fieldSocialWork: "Công tác xã hội",
    fieldSociology: "Xã hội học",
    fieldSoftwareEngineering: "Kỹ thuật phần mềm",
    fieldTheology: "Thần học",
  },

  // The 30 major styles' hero taglines (`STYLE_LANDING_PAGES[].tagline`), keyed by
  // slug.
  //
  // Per-page hand-written copy, not a template — which is why they outlived the
  // extraction pass in `src/data/style-pages.ts`. Three page types print them: the
  // style landing page's hero, the card for each recommended style on a field
  // taxonomy page, and the lower-cased clause inside a comparison page's opening
  // sentence ("APA (…) is the most widely used citation style in the social
  // sciences"). Leaving them in the data means an English sentence in the first
  // paragraph of an otherwise translated page. `styleTagline()`
  // (src/lib/i18n/data-labels.ts) falls back to the data file's own value.
  styleTaglines: {
    apa: "Kiểu trích dẫn được dùng rộng rãi nhất trong khoa học xã hội",
    mla: "Kiểu trích dẫn chuẩn cho ngành nhân văn",
    chicago:
      "Sách hướng dẫn văn phong được tin cậy nhất nước Mỹ dành cho tác giả, biên tập viên và nhà xuất bản",
    harvard: "Kiểu trích dẫn phổ biến nhất tại các trường đại học Anh và Úc",
    vancouver: "Kiểu trích dẫn chuẩn cho các tạp chí y khoa và y sinh",
    ieee: "Kiểu trích dẫn hàng đầu cho ngành kỹ thuật và khoa học máy tính",
    ama: "Chuẩn trích dẫn cho các tạp chí y khoa Hoa Kỳ",
    turabian: "Phiên bản Chicago thân thiện với sinh viên",
    cse: "Kiểu trích dẫn được ưa chuộng cho khoa học tự nhiên và khoa học vật lý",
    bibtex:
      "Định dạng thư mục tham khảo cho người dùng LaTeX và dàn trang học thuật",
    nature: "Kiểu trích dẫn được dùng bởi tạp chí đa ngành hàng đầu thế giới",
    acs: "Chuẩn trích dẫn cho hóa học và các ngành khoa học hóa học",
    oscola:
      "Kiểu trích dẫn pháp lý chuẩn cho các trường luật và tạp chí luật ở Anh",
    bluebook:
      "Hệ thống trích dẫn pháp lý chính thức cho tòa án và tạp chí luật tại Hoa Kỳ",
    aglc: "Kiểu trích dẫn pháp lý chuẩn cho các trường luật và tòa án ở Úc",
    asa: "Kiểu trích dẫn chuẩn cho xã hội học và nghiên cứu xã hội",
    apsa: "Kiểu trích dẫn cho nghiên cứu và tạp chí khoa học chính trị",
    aaa: "Kiểu trích dẫn chuẩn cho nghiên cứu nhân học",
    nlm: "Chuẩn trích dẫn được PubMed và National Library of Medicine sử dụng",
    acm: "Kiểu trích dẫn cho các hội nghị ACM và nghiên cứu khoa học máy tính",
    aps: "Kiểu trích dẫn cho Physical Review và các tạp chí của APS",
    aip: "Kiểu trích dẫn cho AIP và các tạp chí vật lý",
    cell: "Kiểu trích dẫn cho Cell Press và các tạp chí sinh học hàng đầu",
    science: "Kiểu trích dẫn cho tạp chí Science và các ấn phẩm của AAAS",
    plos: "Kiểu trích dẫn cho các tạp chí truy cập mở của PLOS",
    bmj: "Kiểu trích dẫn cho BMJ và các tạp chí y khoa hàng đầu của Anh",
    lancet: "Kiểu trích dẫn cho nhóm tạp chí y khoa The Lancet",
    jama: "Kiểu trích dẫn cho JAMA và các tạp chí thuộc JAMA Network",
    elsevierHarvard:
      "Biến thể của kiểu Harvard được dùng trong các tạp chí Elsevier",
    springer: "Kiểu trích dẫn cho các tạp chí và sách của Springer Nature",
  },

  // The 105 style-versus-style pages at `/<locale>/compare/<slug>`.
  //
  // The two style names arrive as placeholder values and are never translated. The
  // facts in the table come from `styleFacts` above and the taglines from
  // `styleTaglines`; only `fullName` stays in `src/data/style-pages.ts`, because an
  // official name is the same in every language.
  comparePage: {
    notFoundTitle: "Không tìm thấy",
    metaTitle: "{a} vs {b} - Giải thích Khác biệt Chính [2026]",
    metaDescription:
      "So sánh trực tiếp hai kiểu trích dẫn {a} và {b}. Tìm hiểu những khác biệt chính trong định dạng, trích dẫn trong bài và danh mục tài liệu tham khảo để chọn đúng kiểu cho bài viết của bạn.",
    ogTitle: "{a} vs {b}",
    ogSubtitle:
      "Định dạng trong bài, mục tài liệu tham khảo, cách viết hoa và ngành học nào yêu cầu từng kiểu.",
    ogKind: "So sánh kiểu trích dẫn",
    keywordVs: "{a} vs {b}",
    keywordVersus: "{a} so với {b}",
    keywordDifference: "khác biệt giữa {a} và {b}",
    keywordOr: "{a} hay {b}",
    keywordComparison: "so sánh kiểu trích dẫn",
    breadcrumbCompare: "So sánh Kiểu",
    breadcrumbCurrent: "{a} vs {b}",
    backLink: "← Quay lại Công cụ So sánh",
    heading: "{a} vs {b}: Khác biệt Chính",
    intro:
      "{a} và {b} là hai trong số các kiểu trích dẫn được dùng rộng rãi nhất trong giới học thuật, nhưng chúng khác nhau ở những điểm quan trọng. {introA} {introB} Hiểu rõ những khác biệt này sẽ giúp bạn chọn đúng định dạng cho bài viết của mình.",
    styleIntro: "{style} ({fullName}) {tagline}.",
    styleIntroFallback:
      "{style} là một kiểu trích dẫn phổ biến, được dùng trong nhiều ngành học thuật.",
    tableHeading: "So sánh Song song",
    tableFeature: "Đặc điểm",
    tableCitationSystem: "Hệ thống Trích dẫn",
    tableInText: "Định dạng Trong bài",
    tableReferenceList: "Tên Danh mục Tham khảo",
    tableEdition: "Phiên bản",
    tableCommonFields: "Lĩnh vực Phổ biến",
    // Title case, for the table cell. `styleLanding.system*` says "Author–date" for the
    // fact list on the style landing pages; both spellings are deliberate.
    systemAuthorDate: "Tác giả-Năm",
    systemNumbered: "Đánh số",
    systemFootnotes: "Chú thích chân trang",
    // The same three systems inside a sentence ("uses a numbered citation system").
    describeAuthorDate: "tác giả-năm trong ngoặc đơn",
    describeNumbered: "đánh số",
    describeFootnotes: "dựa trên chú thích chân trang",
    whenToUseHeading: "Khi nào Dùng {style}",
    whenToUseBody:
      "{style} ({fullName}) dùng hệ thống trích dẫn {system} với trích dẫn trong bài dạng {inText} và {list} ở cuối bài viết. Kiểu này thường được dùng nhiều nhất trong {fields}{more}.",
    whenToUseMoreFields: ", và các lĩnh vực liên quan",
    whenToUseFallback:
      "{style} là một kiểu trích dẫn được công nhận rộng rãi. Hãy kiểm tra hướng dẫn bài tập hoặc tạp chí mục tiêu để xác nhận xem {style} có phải là định dạng bắt buộc hay không.",
    ctaHeading: "Xem Khác biệt trong Thực tế",
    ctaBodyBefore: "Hãy thử",
    ctaBodyLink: "công cụ so sánh tương tác",
    ctaBodyAfter:
      "của chúng tôi để so sánh trích dẫn {a} và {b} song song bằng chính nguồn của bạn.",
    ctaCiteIn: "Trích dẫn theo {style} →",
    faqDifferenceQ: "Khác biệt giữa {a} và {b} là gì?",
    faqDifferenceA:
      "{a} và {b} khác nhau về định dạng trích dẫn trong bài, cấu trúc danh mục tài liệu tham khảo và các ngành học thuật sử dụng chúng. {detail}",
    faqDifferenceDetail:
      "{a} dùng trích dẫn trong bài dạng {inTextA} với {listA}, trong khi {b} dùng {inTextB} với {listB}.",
    faqDifferenceDetailFallback:
      "Mỗi kiểu có quy tắc riêng để định dạng trích dẫn, sắp xếp thư mục tham khảo và xử lý các loại nguồn khác nhau.",
    faqBetterQ: "{a} hay {b} tốt hơn?",
    faqBetterA:
      "Không có kiểu nào trong {a} hay {b} vốn dĩ tốt hơn. Lựa chọn đúng phụ thuộc vào ngành học của bạn, yêu cầu của giảng viên hoặc tạp chí bạn định nộp bài. Hãy kiểm tra hướng dẫn bài tập hoặc ấn phẩm mục tiêu để xác định kiểu nào cần dùng.",
    faqSwitchQ: "Tôi có thể chuyển đổi giữa {a} và {b} không?",
    faqSwitchA:
      "Có, bạn có thể chuyển đổi giữa {a} và {b} bằng công cụ tạo trích dẫn miễn phí của CitationEasy. Chỉ cần chọn kiểu mong muốn, trích dẫn của bạn sẽ được định dạng lại tự động. Tuy nhiên, bạn chỉ nên dùng một kiểu cho mỗi bài viết, trừ khi giảng viên yêu cầu khác.",
  },

  // The ~21 converter-pair pages at `/<locale>/convert/<slug>`.
  //
  // Only the shell is here; each pair's own four strings are in `converterCopy` below.
  // The format names (DOI, ISBN, BibTeX, RIS, CSL-JSON, PubMed ID, arXiv ID, Word) are
  // identifiers, never translated.
  converterPage: {
    notFoundTitle: "Không tìm thấy công cụ chuyển đổi",
    metaTitle: "{title} - Miễn phí & Tức thì",
    ogTitle: "{title}",
    ogKind: "Công cụ chuyển đổi",
    breadcrumbConverters: "Công cụ chuyển đổi",
    breadcrumbLabel: "Đường dẫn điều hướng",
    whenHeading: "Khi nào bạn cần công cụ này",
    relatedHeading: "Công cụ chuyển đổi liên quan",
    allConverters: "Tất cả công cụ chuyển đổi",
    formatConverterTool: "Công cụ Chuyển đổi Định dạng Trích dẫn",
    faqHowQ: "Làm thế nào để chuyển {input} sang {output}?",
    faqHowA:
      "{intro} Mọi thứ đều miễn phí, không cần tài khoản và không giới hạn số lần chuyển đổi.",
    faqPrivacyQ: "Dữ liệu của tôi có được tải lên đâu không?",
    faqPrivacyIdentifier:
      "Mỗi {input} được tra cứu qua dịch vụ metadata công khai tương ứng (Crossref cho DOI, PubMed cho PMID, hồ sơ thư viện cho ISBN), và chỉ mã định danh đó được gửi đi — không bao giờ là tài liệu của bạn. Kết quả đã định dạng là của bạn để sao chép hoặc tải xuống; không có gì được lưu trữ.",
    faqPrivacyLocal:
      "Không — {input} bạn dán hoặc tải lên được phân tích hoàn toàn trong trình duyệt của bạn. {detail}",
    faqPrivacyDetailStyle:
      "Chỉ các trường tham khảo đã phân tích (tác giả, nhan đề, năm) được gửi đến bộ định dạng của chúng tôi để tạo trích dẫn; bản thân tệp của bạn không bao giờ rời khỏi thiết bị.",
    faqPrivacyDetailOffline:
      "Quá trình chuyển đổi chạy hoàn toàn ngoại tuyến ngay trên trang — không có gì được gửi đến bất kỳ máy chủ nào.",
    faqUsefulQ: "Khi nào việc chuyển từ {input} sang {output} hữu ích?",
    faqOtherQ: "Tôi có thể chuyển sang các kiểu và định dạng khác không?",
    faqOtherA:
      "Có. Công cụ tạo trích dẫn của CitationEasy định dạng mọi nguồn theo {count} kiểu trích dẫn, thư mục tham khảo có thể xuất ra Word, RTF, BibTeX, RIS và CSL-JSON, còn trang tổng hợp công cụ chuyển đổi liệt kê mọi cặp chuyển đổi trực tiếp. Nếu bạn cần viết lại văn bản đã định dạng từ kiểu này sang kiểu khác, hãy dùng công cụ Chuyển đổi Định dạng Trích dẫn thay thế.",
  },

  // The 21 converter pairs' own copy (`CONVERTER_PAIRS` in src/data/converters.ts),
  // keyed by slug: title, meta description, the intro paragraph under the H1, and the
  // "when you need this" paragraph.
  //
  // Four hand-written strings per pair, and `src/data/converters.ts` has a quality rule
  // saying they must stay hand-written — no mail-merged sentences, because mass-templated
  // pages are what earned the site a scaled-content penalty. That rule is about how the
  // copy is authored; it says nothing about which language a reader gets it in. Left in
  // the data file they are the entire body of an otherwise translated page.
  // `converterPairCopy()` (src/lib/i18n/data-labels.ts) returns all four at once and
  // falls back to the data file per field, so a converter added upstream ships English
  // copy rather than a blank page.
  converterCopy: {
    doiToApaTitle: "Công cụ chuyển đổi DOI sang APA",
    doiToApaMetaDescription:
      "Dán DOI (mỗi dòng một mã) để nhận trích dẫn APA 7 ngay lập tức, lấy từ dữ liệu Crossref chính thức của nhà xuất bản. Miễn phí, không cần tài khoản.",
    doiToApaIntro:
      "DOI vốn đã trỏ đến dữ liệu chính thức của nhà xuất bản, nên không cần phải tự gõ trích dẫn APA. Dán mỗi dòng một DOI, mỗi mã sẽ được chuyển thành trích dẫn APA 7 hoàn chỉnh — tên tác giả đảo ngược, tiêu đề viết hoa chữ cái đầu câu, tên tạp chí in nghiêng, và đường dẫn https://doi.org/ theo yêu cầu của APA.",
    doiToApaUseCase:
      "Tình huống thường gặp: giảng viên yêu cầu danh mục tài liệu tham khảo APA, còn bạn chỉ có một loạt DOI đã lưu lại trong lúc đọc. Dán cả loạt vào, rồi sao chép danh sách kết quả.",
    doiToMlaTitle: "Công cụ chuyển đổi DOI sang MLA",
    doiToMlaMetaDescription:
      "Tự động chuyển DOI thành mục works-cited theo MLA 9 bằng dữ liệu Crossref. Dán mỗi dòng một DOI — miễn phí, không cần cài đặt gì.",
    doiToMlaIntro:
      "MLA 9 xem một bài báo tạp chí như một chuỗi 'container' — tên bài trong ngoặc kép, tên tạp chí in nghiêng, tập, số, năm, số trang — vốn khá rắc rối nếu tự ghép thủ công. Tra cứu theo DOI sẽ điền đầy đủ mọi phần từ dữ liệu của nhà xuất bản, nên mục works-cited ra đúng ngay từ lần đầu.",
    doiToMlaUseCase:
      "Hữu ích khi môn học nhân văn yêu cầu MLA nhưng nguồn của bạn lại đến từ các cơ sở dữ liệu thiên về khoa học, vốn chỉ cho bạn DOI.",
    doiToBibtexTitle: "Công cụ chuyển đổi DOI sang BibTeX",
    doiToBibtexMetaDescription:
      "Chuyển DOI thành mục BibTeX cho LaTeX và Overleaf. Dán mỗi dòng một DOI, tải về file .bib sẵn dùng — miễn phí và không giới hạn.",
    doiToBibtexIntro:
      "Bài viết LaTeX nào rồi cũng cần file .bib. Dán DOI mỗi dòng một mã để nhận các mục @article gọn gàng kèm cite key được tạo sẵn, sẵn sàng dùng cho Overleaf, natbib hoặc biblatex — không cần chép tay từng trường dữ liệu từ trang của nhà xuất bản.",
    doiToBibtexUseCase:
      "Tình huống kinh điển: người phản biện gửi cho bạn ba bài cần trích dẫn, bạn có DOI của chúng, và hạn nộp là tối nay. Dán vào, tải xuống, rồi \\cite thoải mái.",
    doiToRisTitle: "Công cụ chuyển đổi DOI sang RIS",
    doiToRisMetaDescription:
      "Chuyển DOI thành file RIS mà Zotero, Mendeley và EndNote nhập trực tiếp được. Dán DOI mỗi dòng một mã — miễn phí, không cần đăng ký.",
    doiToRisIntro:
      "RIS là định dạng trao đổi mà mọi phần mềm quản lý tài liệu tham khảo đều nhập được. Dán DOI vào và tải về file .ris với các trường TY/AU/TI/T2 lấy thẳng từ Crossref — sau đó chọn File → Import vào Zotero, Mendeley hoặc EndNote là các mục sẽ xuất hiện có cấu trúc đầy đủ.",
    doiToRisUseCase:
      "Hoàn hảo để chuyển danh sách DOI thu thập thủ công sang một phần mềm quản lý tài liệu tham khảo thực thụ mà không cần gõ lại một tên tác giả nào.",
    isbnToApaTitle: "Công cụ chuyển đổi ISBN sang APA",
    isbnToApaMetaDescription:
      "Tự động chuyển ISBN thành trích dẫn sách theo APA 7. Dán mỗi dòng một ISBN và sao chép danh sách đã định dạng — miễn phí, không cần tài khoản.",
    isbnToApaIntro:
      "ISBN in ở trang bản quyền của sách là tất cả những gì bạn cần để tạo trích dẫn APA. Mỗi ISBN được tra cứu theo dữ liệu thư viện và định dạng theo kiểu APA 7 — tác giả, năm, tên sách in nghiêng và nhà xuất bản — kèm cả thông tin về lần xuất bản nếu dữ liệu có.",
    isbnToApaUseCase:
      "Cách nhanh nhất để trích dẫn cả chồng sách giấy mượn từ thư viện: mở trang bản quyền từng cuốn, gõ ISBN, rồi dán danh sách vào đây.",
    isbnToMlaTitle: "Công cụ chuyển đổi ISBN sang MLA",
    isbnToMlaMetaDescription:
      "Chuyển ISBN thành mục works-cited theo MLA 9 chỉ trong một lần dán. Tra cứu ISBN miễn phí với kết quả đã định dạng sẵn — không cần đăng ký.",
    isbnToMlaIntro:
      "Mục sách trong MLA 9 khá ngắn — tác giả, tên sách in nghiêng, nhà xuất bản, năm — nhưng việc đảo tên tác giả và đặt dấu câu đúng cách vẫn hay khiến người dùng lúng túng. Tra cứu ISBN trả về đúng dữ liệu danh mục của cuốn sách và định dạng theo khuôn mẫu các thành phần cốt lõi của MLA.",
    isbnToMlaUseCase:
      "Lý tưởng cho các bài luận văn học: trích dẫn mọi cuốn tiểu thuyết và chuyên khảo phê bình trên bàn chỉ bằng cách gõ các con số in ở bìa sau.",
    isbnToBibtexTitle: "Công cụ chuyển đổi ISBN sang BibTeX",
    isbnToBibtexMetaDescription:
      "Chuyển ISBN thành mục @book của BibTeX cho LaTeX. Dán mỗi dòng một ISBN, tải về file .bib — miễn phí và tức thì.",
    isbnToBibtexIntro:
      "Sách là phần rắc rối trong BibTeX — không có DOI để tra, và trang của nhà xuất bản hiếm khi cho xuất file .bib. Công cụ này tra từng ISBN theo dữ liệu thư viện và tạo ra mục @book với các trường tác giả, tên sách, nhà xuất bản và năm đã được điền sẵn.",
    isbnToBibtexUseCase:
      "Dành cho người viết luận văn: các chương phương pháp trích dẫn DOI của bài báo, còn chương lý thuyết lại trích dẫn mười hai cuốn sách. Công cụ này lo phần mười hai cuốn sách đó.",
    pmidToApaTitle: "Công cụ chuyển đổi PMID sang APA",
    pmidToApaMetaDescription:
      "Tự động chuyển PubMed ID thành trích dẫn APA 7. Dán PMID mỗi dòng một mã và nhận danh mục tài liệu tham khảo đã định dạng — miễn phí.",
    pmidToApaIntro:
      "Mọi bản ghi PubMed đều có PMID, và các chương trình tâm lý học hay điều dưỡng hầu như luôn yêu cầu APA. Dán PMID mỗi dòng một mã, mỗi mã sẽ được xử lý qua chính dữ liệu của PubMed để thành trích dẫn tạp chí APA 7 hoàn chỉnh, kèm đường dẫn DOI nếu bản ghi có.",
    pmidToApaUseCase:
      "Được thiết kế cho các bài tập thực hành dựa trên bằng chứng: chiến lược tìm kiếm của bạn kết thúc bằng một danh sách PMID, và bài viết cần chúng ở định dạng APA.",
    pmidToRisTitle: "Công cụ chuyển đổi PMID sang RIS",
    pmidToRisMetaDescription:
      "Chuyển PubMed ID thành file RIS cho Zotero, Mendeley hoặc EndNote. Dán PMID mỗi dòng một mã, tải về file .ris — miễn phí.",
    pmidToRisIntro:
      "Quy trình tổng quan hệ thống (systematic review) xoay quanh các file RIS. Dán PMID từ kết quả tìm kiếm PubMed của bạn và tải về file .ris sẵn sàng cho công cụ sàng lọc hoặc phần mềm quản lý tài liệu tham khảo — mỗi bản ghi được cấu trúc từ dữ liệu chuẩn của PubMed thay vì lấy từ văn bản cào lại.",
    pmidToRisUseCase:
      "Hữu ích giữa chừng khi làm tổng quan, lúc đồng nghiệp gửi email 'thêm luôn năm nghiên cứu này' chỉ kèm PMID trần trụi, trong khi thư viện của bạn nằm trong EndNote.",
    arxivToBibtexTitle: "Công cụ chuyển đổi arXiv sang BibTeX",
    arxivToBibtexMetaDescription:
      "Chuyển arXiv ID thành mục BibTeX cho bài viết LaTeX. Dán ID như 2301.12345, mỗi dòng một mã, rồi tải về file .bib — miễn phí.",
    arxivToBibtexIntro:
      "Bản thảo tiền công bố (preprint) được trích dẫn liên tục trong các lĩnh vực phát triển nhanh, và arXiv ID (như 2301.12345) chính là cách chúng lưu hành. Dán các ID vào để nhận mục BibTeX với tác giả, tên bài, năm và đường dẫn arXiv của bản thảo — sẵn sàng cho file .bib của bài viết bạn.",
    arxivToBibtexUseCase:
      "Dành cho người viết trong lĩnh vực ML và vật lý, nơi phần công trình liên quan chiếm tới 80% là nguồn từ arXiv: gom ID trong lúc đọc, rồi chuyển đổi tất cả một lần khi viết bài.",
    bibtexToApaTitle: "Công cụ chuyển đổi BibTeX sang APA",
    bibtexToApaMetaDescription:
      "Dán hoặc tải lên file .bib để nhận danh mục tài liệu tham khảo APA 7. Xử lý được file có nhiều mục — miễn phí, phân tích ngay trong trình duyệt.",
    bibtexToApaIntro:
      "Đôi khi bài viết phải rời khỏi LaTeX: tạp chí muốn nhận bản nộp bằng Word, hoặc hội đồng muốn danh mục tài liệu tham khảo dạng văn bản thuần. Dán BibTeX của bạn (hoặc tải lên file .bib) và mọi mục sẽ được phân tích ngay trong trình duyệt, rồi định dạng thành danh mục tài liệu tham khảo APA 7 mà bạn có thể chèn vào bất kỳ tài liệu nào.",
    bibtexToApaUseCase:
      "Đặc biệt hữu ích khi xin tài trợ: danh sách công bố của bạn nằm trong file .bib, còn mẫu đơn của nhà tài trợ lại muốn trích dẫn định dạng APA trong một ô văn bản.",
    bibtexToMlaTitle: "Công cụ chuyển đổi BibTeX sang MLA",
    bibtexToMlaMetaDescription:
      "Chuyển BibTeX thành mục works-cited theo MLA 9. Dán hoặc tải lên file .bib và sao chép danh sách đã định dạng — miễn phí, không cần tài khoản.",
    bibtexToMlaIntro:
      "BibTeX lưu trữ các trường dữ liệu thô; MLA quy định chính xác cách sắp xếp chúng. Công cụ này phân tích các mục .bib của bạn tại chỗ và trình bày từng mục theo khuôn mẫu MLA 9 — đảo tên tác giả, tên bài trong ngoặc kép, container in nghiêng và dấu câu đúng chuẩn giữa các thành phần.",
    bibtexToMlaUseCase:
      "Dành cho các học giả làm việc đa lĩnh vực: tài liệu tham khảo của bạn nằm trong BibTeX từ dự án LaTeX trước đó, nhưng tạp chí nhân văn bạn định nộp lại muốn MLA.",
    bibtexToRisTitle: "Công cụ chuyển đổi BibTeX sang RIS",
    bibtexToRisMetaDescription:
      "Chuyển file .bib sang RIS cho Zotero, Mendeley hoặc EndNote. Dán hoặc tải lên BibTeX, tải về file .ris — miễn phí và ngoại tuyến.",
    bibtexToRisIntro:
      "Chuyển từ công cụ LaTeX sang phần mềm quản lý tài liệu tham khảo nghĩa là dịch các mục @article/@book của BibTeX thành thẻ TY/AU/TI của RIS. Quá trình chuyển đổi diễn ra hoàn toàn trong trình duyệt của bạn — bao gồm cả ánh xạ trường dữ liệu — và cho ra file .ris mà phần mềm nào cũng nhập được.",
    bibtexToRisUseCase:
      "Nguyên nhân thường gặp: đồng tác giả mới dùng Zotero, tài liệu tham khảo chung của các bạn là file .bib trong kho lưu trữ, và ai đó phải nối nhịp cầu giữa hai bên.",
    bibtexToCslJsonTitle: "Công cụ chuyển đổi BibTeX sang CSL-JSON",
    bibtexToCslJsonMetaDescription:
      "Chuyển BibTeX sang CSL-JSON cho Pandoc và Quarto. Dán hoặc tải lên file .bib, tải về references.json — miễn phí, ngay trong trình duyệt.",
    bibtexToCslJsonIntro:
      "Pandoc và Quarto trích dẫn trực tiếp từ CSL-JSON, và việc chuyển đổi file .bib hiện có giúp loại bỏ một khâu trung gian khỏi quy trình build. Các mục được phân tích trong trình duyệt của bạn và cho ra một mảng CSL-JSON gọn gàng — đúng định dạng mà tham số --bibliography=references.json yêu cầu.",
    bibtexToCslJsonUseCase:
      "Dành cho các nhà nghiên cứu ưu tiên Markdown đang chuyển một dự án LaTeX cũ sang Quarto: mang theo cả thư mục tham khảo mà không cần chỉnh sửa JSON thủ công.",
    bibtexToWordTitle: "Công cụ chuyển đổi BibTeX sang Word",
    bibtexToWordMetaDescription:
      "Biến file .bib thành tài liệu Word với danh mục tài liệu tham khảo định dạng APA, thụt đầu dòng kiểu treo. Miễn phí — quá trình xử lý diễn ra trong trình duyệt.",
    bibtexToWordIntro:
      "Khi file .bib cần trở thành một tài liệu — chứ không phải một định dạng dữ liệu khác — công cụ này phân tích BibTeX của bạn tại chỗ, định dạng từng mục theo APA 7, rồi tải về file Word với danh mục tài liệu tham khảo đã được sắp theo thứ tự chữ cái và thụt đầu dòng kiểu treo.",
    bibtexToWordUseCase:
      "Bước cuối trong quy trình: tạp chí đã chấp nhận bài viết nhưng muốn danh mục tài liệu tham khảo cuối cùng ở dạng file Word có thể chỉnh sửa, trong khi nguồn dữ liệu gốc của bạn là BibTeX.",
    risToApaTitle: "Công cụ chuyển đổi RIS sang APA",
    risToApaMetaDescription:
      "Dán hoặc tải lên file xuất RIS để nhận danh mục tài liệu tham khảo APA 7. Hoạt động với dữ liệu xuất từ Zotero, Mendeley, EndNote và cơ sở dữ liệu — miễn phí.",
    risToApaIntro:
      "Nút Export ở bất kỳ cơ sở dữ liệu nào cũng cho ra RIS; còn bài tập lại cần APA. Dán nội dung xuất ra (hoặc tải lên file .ris) và mỗi bản ghi TY/AU/TI sẽ được phân tích trong trình duyệt rồi trình bày thành trích dẫn APA 7 — không cần cài đặt bất kỳ phần mềm quản lý tài liệu tham khảo nào.",
    risToApaUseCase:
      "Lối tắt từ cơ sở dữ liệu thư viện: xuất kết quả tìm kiếm của bạn dưới dạng RIS, chuyển đổi tại đây, và bỏ qua công đoạn thiết lập Zotero chỉ vì một bài viết duy nhất.",
    risToMlaTitle: "Công cụ chuyển đổi RIS sang MLA",
    risToMlaMetaDescription:
      "Chuyển dữ liệu RIS xuất từ cơ sở dữ liệu hoặc phần mềm quản lý tài liệu tham khảo thành mục works-cited theo MLA 9. Dán hoặc tải lên — miễn phí, không cần đăng ký.",
    risToMlaIntro:
      "JSTOR, ProQuest và EBSCO đều xuất ra RIS, còn các khoa tiếng Anh thì đều muốn MLA. Trang này lấp đầy khoảng cách đó: bản ghi được phân tích tại chỗ và trình bày theo khuôn mẫu các thành phần cốt lõi của MLA 9, sẵn sàng để dán vào trang works-cited của bạn.",
    risToMlaUseCase:
      "Dành cho đêm trước ngày nộp bài luận: mười nguồn được xuất từ JSTOR thành file citations.ris, và không hề muốn định dạng chúng bằng tay.",
    risToBibtexTitle: "Công cụ chuyển đổi RIS sang BibTeX",
    risToBibtexMetaDescription:
      "Chuyển RIS sang BibTeX cho LaTeX và Overleaf. Dán hoặc tải lên file .ris xuất ra, tải về file .bib sạch sẽ — miễn phí, ngay trong trình duyệt.",
    risToBibtexIntro:
      "Đi theo hướng LaTeX: phần mềm quản lý tài liệu tham khảo và cơ sở dữ liệu 'nói' RIS, còn quy trình build bài viết của bạn cần .bib. Bản ghi được chuyển đổi hoàn toàn trong trình duyệt — kiểu dữ liệu được ánh xạ từ thẻ TY, cite key được tạo tự động — thành một file mà Overleaf chấp nhận ngay.",
    risToBibtexUseCase:
      "Thường gặp khi cộng tác: người dùng Zotero xuất ra RIS, người dùng LaTeX chạy qua trang này, và cả hai vẫn giữ được công cụ quen thuộc của mình.",
    risToCslJsonTitle: "Công cụ chuyển đổi RIS sang CSL-JSON",
    risToCslJsonMetaDescription:
      "Chuyển dữ liệu xuất RIS sang CSL-JSON cho quy trình Pandoc và Quarto. Dán hoặc tải lên file .ris, tải về references.json — miễn phí.",
    risToCslJsonIntro:
      "Với người dùng Pandoc và Quarto, CSL-JSON là định dạng thư mục tham khảo gốc. Đưa vào trang này RIS mà cơ sở dữ liệu hay phần mềm quản lý của bạn đã xuất ra, và nhận lại một mảng JSON có cấu trúc — mọi bản ghi được phân tích tại chỗ, không có gì được tải lên bất kỳ đâu.",
    risToCslJsonUseCase:
      "Phù hợp với quy trình docs-as-code: người phản biện gửi tệp đính kèm RIS, file trích dẫn trong kho lưu trữ của bạn là references.json, và trang này chính là bộ chuyển đổi trung gian.",
    cslJsonToBibtexTitle: "Công cụ chuyển đổi CSL-JSON sang BibTeX",
    cslJsonToBibtexMetaDescription:
      "Chuyển CSL-JSON (xuất từ Pandoc/Quarto/Zotero) sang BibTeX. Dán hoặc tải lên file .json, tải về file .bib — miễn phí, ngay trong trình duyệt.",
    cslJsonToBibtexIntro:
      "Đôi khi quy trình lại đảo ngược: một thư mục tham khảo sinh ra từ pipeline Pandoc hay Zotero cần cấp dữ liệu cho quy trình build LaTeX. Công cụ này đọc mảng CSL-JSON trong trình duyệt của bạn và tạo ra các mục BibTeX với kiểu dữ liệu và trường được ánh xạ ngược lại từ mô hình CSL.",
    cslJsonToBibtexUseCase:
      "Dành cho tác giả dùng Quarto có đồng tác giả nhất quyết dùng Overleaf: giữ references.json làm nguồn chuẩn và tạo file .bib khi cần.",
    cslJsonToRisTitle: "Công cụ chuyển đổi CSL-JSON sang RIS",
    cslJsonToRisMetaDescription:
      "Chuyển CSL-JSON sang RIS để Zotero, Mendeley hoặc EndNote có thể nhập được. Dán hoặc tải lên file .json, tải về file .ris — miễn phí.",
    cslJsonToRisIntro:
      "CSL-JSON hoạt động tuyệt vời trong các pipeline Pandoc nhưng lại khó hiểu với hầu hết hộp thoại nhập của phần mềm quản lý tài liệu tham khảo. Chuyển sang RIS giúp cùng những bản ghi đó có thể nhập được ở khắp mọi nơi — mỗi mục được ánh xạ sang thẻ TY/AU/TI ngay trong trình duyệt, không có gì được gửi lên máy chủ.",
    cslJsonToRisUseCase:
      "Vấn đề bàn giao: thư mục tham khảo của bạn là file references.json trong kho git, còn người hướng dẫn của bạn muốn có bản 'trong EndNote' trước thứ Sáu.",
  },

  // The infinite-scroll style list shared by the country and subject pages and by the
  // /citation-styles hub. It is a client component, so these arrive as a prop rather
  // than through `getDictionary` — pulling all 17 dictionaries into the browser bundle
  // to label a search box is the thing `link-path.ts` exists to avoid.
  stylesBrowser: {
    defaultTitle: "Tất cả Kiểu Trích dẫn",
    styleSingular: "kiểu",
    stylePlural: "kiểu",
    found: "tìm thấy",
    filterPlaceholder: "Lọc kiểu trích dẫn...",
    noMatches: "Không có kiểu nào khớp với tìm kiếm của bạn.",
    loadingMore: "Đang tải thêm kiểu...",
    loadMore: "Tải thêm ({count} còn lại)",
    showingAll: "Đang hiển thị tất cả {count} kiểu",
    internationalLabel: "Quốc tế",
  },

  footer: {
    tagline:
      "Công cụ tạo trích dẫn miễn phí với {count} kiểu. Không tài khoản, không cần gói thuê bao trả phí, không giới hạn.",
    freeTools: "Công cụ miễn phí",
    resources: "Tài nguyên",
    legal: "Pháp lý",
    language: "Ngôn ngữ",
    languageLabel: "Chọn ngôn ngữ của bạn",
    rights:
      "Trích dẫn được định dạng theo các định nghĩa chính thức của Citation Style Language.",
    popularStyles: "Kiểu phổ biến",
    about: "Giới thiệu",
    privacy: "Quyền riêng tư",
    terms: "Điều khoản",
    contact: "Liên hệ",
    copyright: "© {year} CitationEasy. Miễn phí sử dụng.",
    poweredBy: "Vận hành bởi",
    allTools: "Tất cả công cụ viết",
    citationGuides: "Hướng dẫn trích dẫn",
    allStyles: "Tất cả kiểu trích dẫn",
    citationGlossary: "Thuật ngữ trích dẫn",
    howToCiteAny: "Cách trích dẫn mọi nguồn",
  },

  faq: {
    heading: "Câu hỏi thường gặp",
    homeQ1: "CitationEasy có thực sự miễn phí không?",
    homeA1:
      "Có. CitationEasy hoàn toàn miễn phí: không cần đăng ký, không giới hạn và không có bản trả phí. Toàn bộ {count} kiểu trích dẫn đều dành cho mọi người.",
    homeQ2: "Những kiểu trích dẫn nào được hỗ trợ?",
    homeA2:
      "Toàn bộ {count} kiểu từ dự án Citation Style Language, gồm APA bản thứ 7, MLA bản thứ 9, Chicago, Harvard, Vancouver, IEEE, AMA và Turabian.",
    homeQ3: "Tôi có cần tài khoản không?",
    homeA3:
      "Không. CitationEasy chạy hoàn toàn trong trình duyệt và thư mục tài liệu được lưu ngay trên thiết bị của bạn. Không có gì được tải lên máy chủ và cũng không có gì để đăng ký.",
    homeQ4: "Tôi có thể tạo trích dẫn bằng ngôn ngữ của mình không?",
    homeA4:
      "Có. Ngôn ngữ trích dẫn là một thiết lập riêng, tách khỏi ngôn ngữ giao diện, nên bạn có thể làm việc bằng tiếng Việt mà vẫn tạo tài liệu tham khảo bằng ngôn ngữ của bài viết.",
    styleQ1: "Công cụ tạo trích dẫn {style} có miễn phí không?",
    styleA1:
      "Có. Tạo trích dẫn {style} là miễn phí và không giới hạn, không cần tài khoản. Dán một DOI, URL, ISBN hoặc mục BibTeX rồi sao chép tài liệu tham khảo đã hoàn chỉnh.",
    styleQ2: "Trích dẫn một nguồn theo {style} như thế nào?",
    styleA2:
      "Dán DOI, URL, ISBN hoặc mục BibTeX của nguồn vào công cụ trên trang này. Kiểu {style} đã được chọn sẵn, nên tài liệu tham khảo và trích dẫn trong bài xuất hiện ngay.",
    styleQ3: "Định dạng {style} chính xác đến mức nào?",
    styleA3:
      "Mỗi tài liệu tham khảo được dựng từ định nghĩa {style} chính thức của dự án Citation Style Language — đúng tệp mà Zotero và Mendeley sử dụng — chứ không phải từ cách diễn giải gần đúng các quy tắc.",
  },

  tool: {
    modeLabel: "Chế độ nhập trích dẫn",
    modeAuto: "URL / DOI / ISBN",
    modeBook: "Tìm sách",
    modeArticles: "Tìm bài báo",
    modeManual: "Nhập thủ công",
    errorEnterManually: "Nhập thông tin thủ công",
    autoLabel: "Dán URL, DOI, PMID, mã arXiv, ISBN hoặc BibTeX",
    autoHint:
      "Chúng tôi tự động nhận diện loại tài liệu và lấy siêu dữ liệu. Dán mỗi dòng một mã để trích dẫn cả danh sách cùng lúc.",
    generate: "Tạo trích dẫn",
    generating: "Đang tạo…",
    bookSearchLabel: "Tìm theo nhan đề, tác giả hoặc ISBN",
    bookSearchEmpty: "Chưa có kết quả. Nhấn Tìm để tìm sách.",
    bookSearchSource: "Tìm trong danh mục Open Library với hàng triệu đầu sách",
    worksSearchLabel: "Tìm theo nhan đề bài báo hoặc tác giả",
    worksSearchEmpty: "Chưa có kết quả. Nhấn Tìm để tìm bài báo.",
    worksSearchSource:
      "Tìm trong danh mục Crossref: bài báo tạp chí, kỷ yếu hội nghị và chương sách",
    showingResults: "Hiển thị {shown} trong {total} kết quả",
    search: "Tìm",
    searching: "Đang tìm…",
    bulkResults: "Kết quả trích dẫn hàng loạt",
    copy: "Sao chép",
    copied: "Đã sao chép!",
    copyHint: "Sao chép và dán vào bài viết của bạn",
    resultTitle: "Trích dẫn đã định dạng",
    edit: "Sửa",
    completeFields: "Hoàn thiện",
    fieldsIncomplete: "other:{count} trường chưa đầy đủ",
    outputLanguage: "Ngôn ngữ",
    sourceType: "Loại tài liệu",
    fieldAuthors: "Tác giả",
    fieldAuthorsHint: "Nguyễn, Văn A hoặc Nguyễn Văn A",
    fieldTitle: "Nhan đề bài báo hoặc sách",
    fieldBookTitle: "Nhan đề sách",
    fieldBookTitleHint: "Nhan đề sách hoặc tuyển tập",
    fieldEditors: "Chủ biên",
    fieldJournal: "Tạp chí / ấn phẩm",
    fieldJournalHint: "Tên tạp chí hoặc ấn phẩm",
    fieldPublisher: "Nhà xuất bản / trang web",
    fieldPublisherHint: "Tên nhà xuất bản hoặc trang web",
    fieldDate: "Ngày / năm",
    fieldVolume: "Tập",
    fieldIssue: "Số",
    fieldPages: "Trang",
    fieldFormat: "Định dạng / phương tiện",
    fieldAuthorsGroup: "Tác giả là nhóm hoặc tổ chức",
    fieldAuthorsGroupHint:
      "Để ghi một nhóm cùng với cá nhân, đặt tên nhóm trong dấu ngoặc nhọn: {R Core Team}, Nguyễn Văn A",
    fieldTranslators: "Người dịch",
    fieldInterviewers: "Người phỏng vấn",
    fieldVersion: "Phiên bản",
    fieldCourt: "Tòa án",
    fieldIssuingAuthority: "Cơ quan cấp",
    fieldPatentNumber: "Số bằng sáng chế",
    fieldEpisodeNumber: "Số tập",
    fieldLawNumber: "Số luật hoặc dự luật",
    fieldReportNumber: "Số báo cáo",
    fieldReviewedTitle: "Tên tác phẩm được điểm",
    fieldReviewedAuthors: "Tác giả của tác phẩm được điểm",
    inTextCitation: "Trích dẫn trong bài",
    quickEdit: "Sửa nhanh",
    quickEditHint: "Cập nhật siêu dữ liệu và tạo lại trích dẫn.",
    update: "Cập nhật",
    saving: "Đang lưu…",
    fieldAuthor: "Tác giả",
    fieldDateShort: "Ngày",
    fieldTitleShort: "Nhan đề",
  },

  toolCollections: {
    "citation-generators": "Công cụ tạo trích dẫn",
    "citation-tools": "Công cụ trích dẫn và tài liệu tham khảo",
    "paper-formatting": "Định dạng bài viết",
    "essay-writing": "Viết tiểu luận và bài báo",
    "writing-analysis": "Phân tích và biên tập văn bản",
    "word-counters": "Bộ đếm và độ dễ đọc",
    vocabulary: "Từ vựng và tìm từ",
    "research-tools": "Nghiên cứu và xuất bản",
    statistics: "Máy tính thống kê",
    math: "Máy tính toán học",
    science: "Máy tính khoa học và phòng thí nghiệm",
    charts: "Biểu đồ và sơ đồ",
    economics: "Kinh tế, kinh doanh và tài chính",
    grades: "Máy tính GPA và điểm số",
    study: "Học tập và năng suất",
    classroom: "Lớp học và tài liệu in",
    random: "Trình tạo và bốc thăm ngẫu nhiên",
    "text-tools": "Làm sạch và định dạng văn bản",
    "fancy-text": "Chữ kiểu và ký hiệu",
    language: "Ngôn ngữ và chuyển tự",
    ciphers: "Mã và mật mã",
    converters: "Chuyển đổi đơn vị, ngày tháng và số",
    developer: "Dữ liệu, ngôn ngữ đánh dấu và mã",
  },
  bib: {
    title: "Danh mục tài liệu của tôi",
    studioTitle: "Không gian thư mục",
    studioProjects: "Dự án",
    studioExplore: "Khám phá",
    studioExploreIntro:
      "Hướng dẫn, công cụ và mọi kiểu trích dẫn chỉ cách một cú nhấp.",
    studioStyleGuide: "Hướng dẫn kiểu {style}",
    studioStyleGuideHint:
      "Quy tắc, ví dụ mẫu và định dạng trích dẫn trong văn bản",
    studioGenerator: "Trình tạo trích dẫn",
    studioNewProject: "Dự án mới",
    studioSwitchProject: "Đổi dự án",
    studioAddSource: "Thêm nguồn",
    studioAddSourceHint:
      "Dán DOI, URL hoặc ISBN, tìm sách và bài báo, hoặc nhập thông tin thủ công. Mọi thứ bạn lưu sẽ nằm trong dự án này.",
    studioDoneAdding: "Xong",
    studioReferences: "Tài liệu tham khảo",
    studioReferenceCount: "{count} tài liệu",
    studioInspectorTitle: "Chi tiết tài liệu",
    studioInspectorEmpty:
      "Chọn một tài liệu để xem trích dẫn trong văn bản, ghi chú và chi tiết nguồn.",
    studioSavedLocally: "Đã lưu trong trình duyệt này",
    studioOpen: "Mở Studio thư mục",
    studioViewInStudio: "Xem trong Studio",
    studioFooterSaved: "{count} đã lưu trong Studio thư mục của bạn",
    studioFooterEmpty:
      "Các trích dẫn đã lưu tạo thành thư mục hoàn chỉnh trong Studio",
    studioClearSelection: "Bỏ chọn",
    studioDeleteSelected: "Xóa mục đã chọn",
    studioDeleteSelectedBody:
      "Xóa {count} trích dẫn khỏi “{name}”? Không thể hoàn tác thao tác này.",
    studioDeletedMany: "Đã xóa {count} trích dẫn",
    studioMoveTo: "Chuyển đến",
    studioCopyTo: "Sao chép đến",
    studioSearchShortcut: "Nhấn / để tìm kiếm",
    studioStyle: "Kiểu",
    studioCopyEntry: "Sao chép mục",
    studioEntryCopied: "Đã sao chép mục",
    studioSourceDetails: "Chi tiết nguồn",
    studioEmptyTitle: "Dự án này trống",
    studioEmptyBody:
      "Thêm nguồn đầu tiên ở trên, hoặc nhập thư viện BibTeX, RIS hay CSL-JSON có sẵn.",
    studioBackup: "Sao lưu",
    sharedTitle: "Danh mục tài liệu được chia sẻ",
    save: "Lưu",
    saving: "Đang lưu…",
    saved: "Đã lưu",
    searchPlaceholder: "Tìm trong trích dẫn…",
    empty: "Chưa lưu trích dẫn nào",
    emptySearch: "Không có trích dẫn nào khớp với tìm kiếm của bạn.",
    countIn: "Trích dẫn trong {name}: {count}",
    savedOn: "Đã lưu ngày {date}",
    emptyInBib:
      "Danh mục này chưa có trích dẫn nào. Hãy tạo và lưu trích dẫn, hoặc nhập một thư viện BibTeX, RIS hay CSL-JSON.",
    savedToast: "Đã lưu trích dẫn vào danh mục",
    copyAll: "Sao chép tất cả",
    copyAllTitle: "Sao chép tất cả trích dẫn",
    export: "Xuất",
    exportTitle: "Xuất danh mục tài liệu",
    import: "Nhập",
    importTitle: "Nhập tài liệu",
    importLabel: "Nhập tài liệu (BibTeX, RIS hoặc CSL-JSON)",
    importing: "Đang nhập…",
    importFailed: "Nhập không thành công. Vui lòng thử lại.",
    importSummary:
      "Đã nhập: {added} · Bỏ qua trùng lặp: {duplicates} · Quá giới hạn: {overLimit} · Lỗi: {failed}",
    importUnreadable: "Không đọc được tệp.",
    importUnparseable: "Không nhập được tài liệu.",
    importReviewTitle: "Xem lại dữ liệu nhập",
    importReviewIntro:
      "Xem lại {total} tài liệu {format} trước khi định dạng và lưu.",
    importReviewCount: "Đã chọn {included} trên {total}",
    importSelectAll: "Chọn tất cả",
    importExcludeAll: "Bỏ chọn tất cả",
    importLimitNotice:
      "{count} tài liệu vượt quá giới hạn 200 mục sẽ không được nhập.",
    importDuplicateExisting: "Có thể trùng với “{title}” đã lưu",
    importDuplicateBatch: "Có thể trùng với “{title}” trong lần nhập này",
    importMissingField: "Thiếu {field}",
    importUntitled: "Tài liệu không có tiêu đề",
    importReview: "Xem lại tài liệu",
    importCommit: "Định dạng và nhập",
    importBack: "Quay lại",
    importOutcomeTitle: "Đã nhập xong",
    importOutcomeSummary:
      "Đã thêm: {added} · Bỏ qua bản trùng: {duplicates} · Loại trừ: {excluded} · Vượt giới hạn: {overLimit} · Lỗi: {failed}",
    sortBy: "Sắp xếp theo",
    sortTitle: "Sắp xếp danh mục tài liệu",
    sortAuthor: "Tác giả (A–Z)",
    sortNewest: "Ngày thêm (mới nhất)",
    sortOldest: "Năm (cũ nhất trước)",
    sortManual: "Thứ tự thủ công",
    backupAll: "Bản sao lưu toàn bộ dự án (.json)",
    backupDownloaded: "Đã tải bản sao lưu toàn bộ dự án",
    backupUnreadable: "Không thể đọc tệp sao lưu.",
    restore: "Khôi phục",
    restoreTitle: "Khôi phục tất cả dự án thư mục tài liệu",
    restoreWarning:
      "Bản sao lưu sẽ được xác thực trước, sau đó thay thế mọi thư mục tài liệu đang lưu trong trình duyệt này. Không thể hoàn tác.",
    restoreChoose: "Chọn bản sao lưu CitationEasy (.json)",
    replaceAndRestore: "Thay thế và khôi phục",
    restoreComplete: "Đã khôi phục tất cả dự án thư mục tài liệu",
    restoreInvalid: "Đây không phải bản sao lưu dự án CitationEasy hợp lệ.",
    selectAllVisible: "Chọn tất cả mục đang hiển thị",
    selectedCount: "Đã chọn {count}",
    clusterOpen: "Trích dẫn cùng nhau",
    clusterTitle: "Trích dẫn tổng hợp trong văn bản",
    clusterDescription:
      "Tạo một cụm trích dẫn duy nhất từ các tài liệu đã chọn. Kiểu được chọn quyết định thứ tự, dấu câu và cách đánh số.",
    clusterTarget: "Đầu ra",
    clusterLocatorOptional: "Vị trí tùy chọn",
    clusterBuildCopy: "Tạo và sao chép trích dẫn",
    clusterBuilding: "Đang tạo trích dẫn…",
    clusterCopied: "Đã sao chép trích dẫn tổng hợp",
    clusterFailed: "Không thể tạo trích dẫn tổng hợp. Vui lòng thử lại.",
    destination: "Thư mục tài liệu đích",
    chooseDestination: "Chọn một thư mục tài liệu…",
    copySelected: "Sao chép",
    moveSelected: "Di chuyển",
    copyComplete:
      "Đã sao chép {count} trích dẫn. Bỏ qua {skipped} mục trùng lặp.",
    moveComplete:
      "Đã di chuyển {count} trích dẫn. {skipped} mục trùng lặp vẫn ở nguồn.",
    selectCitation: "Chọn {title}",
    moveUp: "Di chuyển lên",
    moveDown: "Di chuyển xuống",
    deleteTitle: "Xoá trích dẫn",
    deleteConfirm: "Xoá trích dẫn?",
    deleted: "Đã xoá trích dẫn",
    editTitle: "Sửa trích dẫn",
    close: "Đóng",
    copiedAll: "Đã sao chép tất cả trích dẫn!",
    copiedAnnotated: "Đã sao chép danh mục có chú giải!",
    copiedBibtex: "Đã sao chép BibTeX!",
    copiedBulleted: "Đã sao chép danh sách gạch đầu dòng!",
    copiedNumbered: "Đã sao chép danh sách đánh số!",
    copiedHtml: "Đã sao chép đoạn HTML!",
    downloadedWord: "Đã tải tài liệu Word",
    downloadedRtf: "Đã tải tệp RTF",
    downloadedRis: "Đã tải tệp RIS",
    downloadedCsl: "Đã tải tệp CSL-JSON",
    downloadedAnnotated: "Đã tải danh mục có chú giải",
    copyFailed: "Không sao chép được vào bộ nhớ tạm",
    shareCopied:
      "Đã sao chép liên kết! Ai có liên kết đều có thể xem và nhập danh sách này.",
    shareFailed: "Không tạo được liên kết chia sẻ",
    regenerateFailed: "Không tạo lại được trích dẫn",
    updateFailed: "Không cập nhật được trích dẫn",
    fieldAuthor: "Tác giả",
    fieldTitle: "Nhan đề",
    fieldDate: "Ngày",
    fieldPublisher: "Nhà xuất bản",
    fieldVolume: "Tập",
    fieldIssue: "Số",
    fieldPages: "Trang",
    fieldUrl: "URL",
    fieldAccessed: "Ngày truy cập",
    fieldEditor: "Biên tập viên",
    fieldEvent: "Địa điểm sự kiện",
    noteLabel: "Chú giải cho tài liệu này",
    noteEdit: "Sửa ghi chú này",
    notePlaceholder:
      "Tóm tắt tài liệu, đánh giá và nêu vai trò của nó trong bài viết của bạn…",
    noteRemoved: "Đã xoá ghi chú",
    noteSave: "Lưu ghi chú",
    noteCancel: "Huỷ",
    noteAdd: "Thêm ghi chú",
    noteWords: "{count} từ",
    noteSaved: "Đã lưu ghi chú ({count} từ)",
    noteClickToEdit: "nhấn để sửa",
    inTextCopy: "Sao chép trích dẫn trong bài cho tài liệu này",
    inTextSelect: "Chọn trích dẫn bên dưới để sao chép.",
    inTextFailed: "Không dựng được trích dẫn trong bài. Vui lòng thử lại.",
    locator: "Vị trí trích",
    locatorType: "Loại vị trí",
    locatorPage: "Trang",
    locatorChapter: "Chương",
    locatorSection: "Mục",
    locatorParagraph: "Đoạn",
    locatorLine: "Dòng",
    locatorVerse: "Câu",
    reformat: "Định dạng lại",
    reformatTitle: "Định dạng lại mọi trích dẫn theo kiểu khác",
    reformatHeading: "Định dạng lại tất cả theo một kiểu",
    reformatChoose: "Chọn một kiểu…",
    reformatFailed:
      "Định dạng lại không thành công. Danh mục của bạn không thay đổi.",
    sortOrder: "Tiêu chí sắp xếp",
    copyToClipboard: "Sao chép vào bộ nhớ tạm",
    numberedList: "Danh sách đánh số",
    bulletedList: "Danh sách gạch đầu dòng",
    htmlSnippet: "Đoạn HTML",
    copyWithAnnotations: "Sao chép kèm chú giải",
    wordAnnotated: "Tài liệu Word có chú giải (.doc)",
    downloadFile: "Tải tệp về",
    wordDocument: "Tài liệu Word (.doc)",
    copyShareLink: "Sao chép liên kết chia sẻ",
    print: "In…",
    printFailed: "Cửa sổ bật lên bị chặn — hãy cho phép để in",
    font: "Phông chữ",
    sitePublication: "Trang web / tên ấn phẩm",
    importIntro:
      "Dán hoặc tải lên tệp BibTeX (.bib), RIS (.ris) hoặc CSL-JSON (.json)",
    importUpload: "Tải lên tệp .bib, .ris hoặc .json",
    importPaste: "Hoặc dán BibTeX, RIS hay CSL-JSON",
    cancel: "Huỷ",
    done: "Xong",
    delete: "Xoá",
    deleteBody: "Trích dẫn này sẽ bị xoá vĩnh viễn khỏi danh mục của bạn.",
    editBody: "Cập nhật siêu dữ liệu rồi lưu để tạo lại trích dẫn.",
    reformatExplain:
      "Dựng lại toàn bộ {count} mục từ dữ liệu nguồn đã lưu — không tải lại gì và không mất tài liệu nào.",
    inTextHeading: "Trích dẫn trong bài",
    inTextLocatorHint:
      "Thêm số trang hoặc vị trí khác để gắn trích dẫn vào một chỗ trong tài liệu — hầu hết các kiểu đều yêu cầu điều này khi trích nguyên văn. Để trống nếu muốn dạng đơn giản.",
    inTextCopyButton: "Sao chép trích dẫn trong bài",
    mixedStyles: "Danh mục này trộn lẫn {count} kiểu trích dẫn ({styles}).",
    mixedStylesAction:
      "Dùng {action} để đưa tất cả về một kiểu trước khi nộp bài.",
    selectBibliography: "Chọn danh mục tài liệu",
    newBibliography: "Danh mục mới",
    moreOptions: "Tùy chọn khác",
    rename: "Đổi tên",
    removeDuplicates: "Xóa mục trùng",
    cannotDeleteOnly: "Không thể xóa danh mục duy nhất",
    newBibliographyBody:
      "Tạo danh mục tài liệu cho một bài viết hoặc dự án khác.",
    bibliographyName: "Tên danh mục",
    create: "Tạo",
    renameBibliography: "Đổi tên danh mục",
    renameBibliographyBody: "Nhập tên mới cho “{name}”.",
    newName: "Tên mới",
    duplicateRemovedOne: "Đã xóa {count} mục trùng",
    duplicateRemovedMany: "Đã xóa {count} mục trùng",
    noDuplicates: "Không tìm thấy tài liệu trùng",
    removeDuplicatesConfirm: "Xóa tài liệu trùng?",
    removeDuplicatesBody:
      "Hệ thống quét “{name}” để tìm cùng một nguồn (theo DOI, ISBN hoặc tiêu đề, năm và tác giả) rồi giữ một bản. Các tài liệu không thể đối chiếu sẽ không thay đổi.",
    deleteBibliographyConfirm: "Xóa danh mục tài liệu?",
    deleteBibliographyBody:
      "Thao tác này sẽ xóa vĩnh viễn “{name}” và toàn bộ {count} trích dẫn.",
  },

  bibliographyPage: {
    metaTitle: "Không gian thư mục - sắp xếp, chú thích và xuất trích dẫn",
    metaDescription:
      "Tạo và quản lý dự án thư mục riêng tư trong trình duyệt. Tìm kiếm, sắp xếp, chú thích, sửa, định dạng, nhập, xuất và chia sẻ mà không cần tài khoản.",
    keyword1: "tạo danh mục tài liệu",
    keyword2: "quản lý trích dẫn",
    keyword3: "công cụ thư mục có chú thích",
    ogTitle: "Không gian thư mục",
    ogDescription:
      "Không gian riêng toàn trang để sắp xếp, định dạng, chú thích, nhập và xuất trích dẫn.",
    ogImageTitle: "Không gian thư mục",
    ogImageSubtitle:
      "Sắp xếp, chú thích, định dạng, xuất và chia sẻ tài liệu tham khảo.",
    ogKind: "Không gian trích dẫn",
    breadcrumb: "Không gian thư mục",
    eyebrow: "Không gian riêng trong trình duyệt",
    lead: "Quản lý mọi tài liệu tham khảo cho bài viết ở một nơi. Dự án chỉ nằm trong trình duyệt này trừ khi bạn chủ động xuất hoặc chia sẻ.",
    privacyTitle: "Mặc định là riêng tư",
    privacyBody:
      "Dự án và chú thích dùng bộ nhớ cục bộ của trình duyệt. Liên kết chia sẻ có trích dẫn nhưng chủ ý loại bỏ ghi chú riêng.",
    workflowTitle: "Từ danh sách nguồn đến bài hoàn chỉnh",
    workflowBody:
      "Chuyển dự án, tìm và sắp xếp tài liệu, thêm chú thích hoặc vị trí, sửa siêu dữ liệu và định dạng lại toàn bộ danh sách theo một kiểu.",
    formatsTitle: "Nhập tài liệu và mang đi mọi nơi",
    formatsBody:
      "Nhập BibTeX, RIS hoặc CSL-JSON. Sao chép danh sách đã định dạng hoặc xuất Word, RTF, RIS, CSL-JSON, HTML, BibTeX và bản có chú thích.",
  },

  // The 95-term glossary: /glossary and /glossary/[slug].
  //
  // The chrome only. Each term's own prose — `short`, the `body` paragraphs, the
  // example — is ~10,600 words that cannot live in a flat string map and must not be
  // copied verbatim into sixteen files; it lives in `src/content/glossary/<locale>.json`
  // and is read through `lib/localized-content.ts`.
  glossaryPage: {
    metaTitle: "{term} - định nghĩa và ví dụ",
    notFoundTitle: "Không tìm thấy thuật ngữ",
    keywordDefinition: "định nghĩa {term}",
    keywordWhatIs: "{term} là gì",
    ogTitle: "{term} - Thuật ngữ CitationEasy",
    ogKind: "Thuật ngữ trích dẫn",
    breadcrumb: "Thuật ngữ",
    alsoCalled: "Còn được gọi là: {aliases}",
    doItHeading: "Thực hiện trên CitationEasy",
    seeAlsoHeading: "Xem thêm",
    moreInHeading: "Thêm trong {category}",
    navLabel: "Điều hướng thuật ngữ",
    allTermsLink: "Tất cả {count} thuật ngữ",
    generatorLink: "Công cụ tạo trích dẫn miễn phí",
    termSetName: "Thuật ngữ trích dẫn CitationEasy",
    hubMetaTitle: "Thuật ngữ trích dẫn - {count} thuật ngữ được giải thích",
    hubMetaDescription:
      "Định nghĩa dễ hiểu cho {count} thuật ngữ trích dẫn và viết học thuật: et al., ibid., DOI, thụt lề treo, patchwriting, phiên bản chính thức và nhiều hơn nữa — mỗi thuật ngữ đều có ví dụ.",
    hubKeyword1: "thuật ngữ trích dẫn",
    hubKeyword2: "thuật ngữ trích dẫn học thuật",
    hubKeyword3: "thuật ngữ viết học thuật",
    hubKeyword4: "et al nghĩa là gì",
    hubKeyword5: "DOI là gì",
    hubKeyword6: "thuật ngữ tham khảo",
    hubOgTitle: "Thuật ngữ trích dẫn",
    hubOgDescription:
      "Định nghĩa của {count} thuật ngữ trích dẫn và viết học thuật, kèm ví dụ.",
    hubOgImageTitle: "Thuật ngữ Trích dẫn",
    hubOgImageSubtitle:
      "{count} thuật ngữ trích dẫn và viết học thuật, được định nghĩa dễ hiểu kèm ví dụ.",
    hubOgKind: "Tham khảo",
    hubTermSetDescription:
      "Định nghĩa của {count} thuật ngữ trích dẫn, tham khảo và viết học thuật.",
    hubCollectionName: "Thuật ngữ trích dẫn",
    hubCollectionDescription:
      "Định nghĩa dễ hiểu cho {count} thuật ngữ trích dẫn và viết học thuật.",
    hubHeading: "Thuật ngữ trích dẫn",
    hubIntro:
      "{count} thuật ngữ về trích dẫn và viết học thuật, được định nghĩa dễ hiểu kèm ví dụ — các từ viết tắt xuất hiện trong sổ tay kiểu trích dẫn, các thành phần cấu tạo nên một tài liệu tham khảo, các mã định danh xác định chính xác một nguồn, và vốn từ vựng của xuất bản học thuật.",
    hubJumpLabel: "Nhảy đến chữ cái",
    hubBrowseHeading: "Duyệt theo chủ đề",
    hubAllHeading: "Tất cả thuật ngữ A–Z",
    hubWorkHeading: "Áp dụng các thuật ngữ",
    hubWorkGenerator: "Công cụ tạo trích dẫn miễn phí",
    hubWorkStyles: "Hướng dẫn kiểu trích dẫn",
    hubWorkHowTo: "Cách trích dẫn mọi loại nguồn",
    hubWorkCompare: "So sánh các kiểu trích dẫn",
    hubWorkTools: "Công cụ viết và trích dẫn",
    hubWorkFaq: "Câu hỏi Thường gặp về Trích dẫn",
  },

  // /faq — the 17-question hub. The questions and answers themselves are in
  // `src/data/faq.ts` (the one source the API, the MCP tool and /md also read); this is
  // the page around them.
  faqPage: {
    metaTitle:
      "Câu hỏi Thường gặp về Trích dẫn - Trả lời Nhanh cho Các Câu hỏi Phổ biến",
    metaDescription:
      "Câu trả lời nhanh, chính xác cho những câu hỏi trích dẫn mà sinh viên thực sự thường hỏi: DOI, nguồn không có tác giả, et al., thụt lề treo, trích dẫn AI, quy tắc đạo văn, APA so với MLA và nhiều hơn nữa — kèm liên kết đến các hướng dẫn đầy đủ.",
    ogTitle: "Câu hỏi Thường gặp về Trích dẫn",
    ogDescription:
      "Câu trả lời nhanh cho những câu hỏi trích dẫn phổ biến nhất, từ DOI và et al. đến trích dẫn ChatGPT.",
    ogImageTitle: "Câu hỏi và Trả lời về Trích dẫn",
    ogImageSubtitle:
      "Câu trả lời ngắn gọn, chính xác cho những câu hỏi sinh viên thực sự thường hỏi về trích dẫn.",
    ogKind: "FAQ",
    breadcrumbLabel: "Đường dẫn điều hướng",
    breadcrumbHome: "Trang chủ",
    breadcrumbCurrent: "Câu hỏi Thường gặp về Trích dẫn",
    heading: "Câu hỏi Thường gặp về Trích dẫn",
    intro:
      "Câu trả lời nhanh, chính xác cho những câu hỏi trích dẫn mà sinh viên thực sự thường hỏi — kèm liên kết đến hướng dẫn hoặc công cụ đầy đủ khi bạn cần tìm hiểu sâu hơn.",
    contentsLabel: "Mục lục Câu hỏi Thường gặp",
    stillStuckHeading: "Vẫn chưa rõ?",
    stillStuckBody:
      "Duyệt qua [thư viện hướng dẫn đầy đủ](/guides), xem [bảng tra cứu nhanh các kiểu](/cheat-sheets), tra một thuật ngữ trong [thuật ngữ trích dẫn](/glossary), [tìm kiếm trên toàn trang](/search), hoặc chỉ cần [tạo trích dẫn](/) và để công cụ định dạng áp dụng các quy tắc cho bạn.",
  },

  // /cheat-sheets and its three style sheets. The citation FORMATS in them
  // ("Author, A. A. (Year)…") are the styles' own templates and stay as they are in
  // every language, exactly as the per-style examples do; the labels around them do not.
  cheatSheets: {
    hubMetaTitle:
      "Bảng Tra cứu Nhanh Kiểu Trích dẫn - Hướng dẫn Tham khảo Nhanh",
    hubMetaDescription:
      "Bảng tra cứu nhanh cho các kiểu trích dẫn APA, MLA và Chicago. Hướng dẫn thân thiện khi in, kèm ví dụ cho các loại nguồn thường gặp.",
    hubBreadcrumbHome: "Trang chủ",
    hubBreadcrumbCurrent: "Bảng Tra cứu Nhanh Kiểu Trích dẫn",
    hubBackLink: "← Quay lại Công cụ Tạo",
    hubHeading: "Bảng Tra cứu Nhanh Kiểu Trích dẫn",
    hubIntro:
      "Hướng dẫn tra cứu nhanh cho các kiểu trích dẫn phổ biến nhất. Thân thiện khi in và luôn được cập nhật.",
    hubApaTitle: "Bảng Tra cứu Nhanh APA Bản thứ 7",
    hubApaDesc: "Tâm lý học, khoa học xã hội, giáo dục, điều dưỡng",
    hubMlaTitle: "Bảng Tra cứu Nhanh MLA Bản thứ 9",
    hubMlaDesc: "Văn học, ngôn ngữ, nhân văn, nghiên cứu văn hóa",
    hubChicagoTitle: "Bảng Tra cứu Nhanh Kiểu Chicago",
    hubChicagoDesc: "Lịch sử, lịch sử nghệ thuật, triết học, tôn giáo",
    backToSheets: "← Quay lại Bảng Tra cứu Nhanh",
    generalRules: "Quy tắc Chung",
    inTextCitations: "Trích dẫn Trong bài",
    colSituation: "Tình huống",
    colFormat: "Định dạng",
    colExample: "Ví dụ",
    book: "Sách",
    journalArticle: "Bài Báo Tạp Chí",
    website: "Trang Web",
    apaMetaTitle:
      "Bảng Tra cứu Nhanh APA Bản thứ 7 - Hướng dẫn Tham khảo Nhanh",
    apaMetaDescription:
      "Bảng tra cứu nhanh trích dẫn APA bản thứ 7 kèm ví dụ cho sách, tạp chí, trang web và nhiều loại khác. Tham khảo nhanh, thân thiện khi in.",
    apaHeading: "Bảng Tra cứu Nhanh APA Bản thứ 7",
    apaLead: "Tham khảo nhanh cho các định dạng trích dẫn APA thường gặp nhất.",
    apaRule1:
      'Dùng **thụt lề treo** (dòng đầu căn lề trái, các dòng sau thụt vào 0,5")',
    apaRule2: "Giãn dòng đôi cho tất cả các mục",
    apaRule3: "Sắp xếp theo thứ tự chữ cái họ của tác giả",
    apaRule4: "In nghiêng nhan đề sách, tạp chí và tập",
    apaRule5: "Dùng DOI khi có",
    apaRow1Situation: "1 tác giả",
    apaRow1Format: "(Tác giả, Năm)",
    apaRow1Example: "(Smith, 2024)",
    apaRow2Situation: "2 tác giả",
    apaRow2Format: "(Tác giả & Tác giả, Năm)",
    apaRow2Example: "(Smith & Jones, 2024)",
    apaRow3Situation: "3+ tác giả",
    apaRow3Format: "(Tác giả đầu tiên et al., Năm)",
    apaRow3Example: "(Smith et al., 2024)",
    apaRow4Situation: "Trích dẫn trực tiếp",
    apaRow4Format: "(Tác giả, Năm, tr. #)",
    apaRow4Example: "(Smith, 2024, p. 45)",
    apaRow5Situation: "Không có tác giả",
    apaRow5Format: '("Nhan đề," Năm)',
    apaRow5Example: '("Study Results," 2024)',
    apaReferenceHeading: "Ví dụ Danh mục Tài liệu Tham khảo",
    apaBookExample:
      "Author, A. A. (Year). *Title of work: Capital letter also for subtitle*. Publisher. https://doi.org/xxxxx",
    apaJournalExample:
      "Author, A. A., & Author, B. B. (Year). Title of article. *Title of Periodical, Volume*(Issue), Page–Page. https://doi.org/xxxxx",
    apaWebsiteExample:
      "Author, A. A. (Year, Month Day). *Title of page*. Site Name. https://www.example.com/page",
    apaChapterLabel: "Chương Sách Biên tập",
    apaChapterExample:
      "Author, A. A. (Year). Title of chapter. In E. E. Editor (Ed.), *Title of book* (pp. #–#). Publisher.",
    apaConferenceLabel: "Bài Báo Hội Nghị",
    apaConferenceExample:
      "Author, A. A. (Year, Month Days). *Title of paper* [Paper presentation]. Conference Name, Location.",
    apaDifferencesHeading: "Khác biệt Chính so với APA Bản thứ 6",
    apaDifference1: 'Không dùng "Retrieved from" trước URL',
    apaDifference2: "Ghi DOI theo định dạng liên kết https://doi.org/",
    apaDifference3: "Liệt kê tối đa 20 tác giả trước khi dùng dấu ba chấm",
    apaDifference4: "Không còn yêu cầu địa điểm nhà xuất bản",
    apaDifference5: 'Dùng "they" số ít cho ngôn ngữ trung tính giới',
    apaCtaText: "Tạo trích dẫn APA hoàn hảo một cách tự động",
    apaCtaButton: "Công cụ Tạo Trích dẫn APA →",
    mlaMetaTitle:
      "Bảng Tra cứu Nhanh MLA Bản thứ 9 - Hướng dẫn Tham khảo Nhanh",
    mlaMetaDescription:
      "Bảng tra cứu nhanh trích dẫn MLA bản thứ 9 kèm ví dụ cho sách, bài báo, trang web và nhiều loại khác. Tham khảo nhanh, thân thiện khi in.",
    mlaHeading: "Bảng Tra cứu Nhanh MLA Bản thứ 9",
    mlaLead: "Tham khảo nhanh cho các định dạng trích dẫn MLA thường gặp nhất.",
    mlaRule1: "Dùng **thụt lề treo**",
    mlaRule2: "Giãn dòng đôi cho tất cả các mục",
    mlaRule3: "Sắp xếp theo thứ tự chữ cái họ của tác giả",
    mlaRule4: 'Đặt tiêu đề trang là "Danh mục Tài liệu Trích dẫn"',
    mlaRule5: "In nghiêng nhan đề của vật chứa (sách, tạp chí, trang web)",
    mlaRow1Situation: "1 tác giả",
    mlaRow1Format: "(Tác giả Trang)",
    mlaRow1Example: "(Smith 45)",
    mlaRow2Situation: "2 tác giả",
    mlaRow2Format: "(Tác giả và Tác giả Trang)",
    mlaRow2Example: "(Smith and Jones 45)",
    mlaRow3Situation: "3+ tác giả",
    mlaRow3Format: "(Tác giả đầu tiên et al. Trang)",
    mlaRow3Example: "(Smith et al. 45)",
    mlaRow4Situation: "Không có tác giả",
    mlaRow4Format: '("Nhan đề" Trang)',
    mlaRow4Example: '("Study Results" 45)',
    mlaRow5Situation: "Không có số trang",
    mlaRow5Format: "(Tác giả)",
    mlaRow5Example: "(Smith)",
    mlaWorksCitedHeading: "Ví dụ Danh mục Tài liệu Trích dẫn",
    mlaBookExample: "Last, First. *Title of Book*. Publisher, Year.",
    mlaJournalExample:
      'Last, First. "Title of Article." *Journal Title*, vol. #, no. #, Year, pp. #–#.',
    mlaWebsiteExample:
      'Last, First. "Title of Page." *Website Name*, Day Month Year, URL.',
    mlaAnthologyLabel: "Tuyển tập/Sách Biên tập",
    mlaAnthologyExample:
      'Last, First. "Title of Essay." *Title of Collection*, edited by First Last, Publisher, Year, pp. #–#.',
    mlaCoreHeading: "Các Yếu tố Cốt lõi MLA (theo thứ tự)",
    mlaCore1: "Tác giả.",
    mlaCore2: '"Nhan đề Nguồn."',
    mlaCore3: "*Nhan đề Vật chứa*,",
    mlaCore4: "Người đóng góp,",
    mlaCore5: "Phiên bản,",
    mlaCore6: "Số,",
    mlaCore7: "Nhà xuất bản,",
    mlaCore8: "Ngày xuất bản,",
    mlaCore9: "Vị trí (số trang, URL, DOI).",
    mlaCtaText: "Tạo trích dẫn MLA hoàn hảo một cách tự động",
    mlaCtaButton: "Công cụ Tạo Trích dẫn MLA →",
    chicagoMetaTitle:
      "Bảng Tra cứu Nhanh Kiểu Chicago - Hướng dẫn Tham khảo Nhanh",
    chicagoMetaDescription:
      "Bảng tra cứu nhanh trích dẫn theo Chicago Manual of Style kèm ví dụ hệ Chú thích-Thư mục và Tác giả-Năm. Tham khảo nhanh, thân thiện khi in.",
    chicagoHeading: "Bảng Tra cứu Nhanh Kiểu Chicago",
    chicagoLead:
      "Tham khảo nhanh cho các định dạng trích dẫn theo Chicago Manual of Style (bản thứ 18).",
    chicagoSystemsHeading: "Hai Hệ thống Chicago",
    chicagoColNb: "Chú thích-Thư mục (NB)",
    chicagoColAd: "Tác giả-Năm (AD)",
    chicagoRow1Nb: "Chú thích chân trang/chú thích cuối bài + thư mục",
    chicagoRow1Ad: "Trích dẫn trong ngoặc + danh mục tài liệu tham khảo",
    chicagoRow2Nb: "Lịch sử, nghệ thuật, nhân văn",
    chicagoRow2Ad: "Khoa học, khoa học xã hội",
    chicagoRow3Nb: "Chú thích đầu tiên chi tiết hơn",
    chicagoRow3Ad: "Tương tự định dạng APA",
    chicagoExamplesHeading: "Ví dụ Chú thích-Thư mục",
    chicagoNoteLabel: "Chú thích:",
    chicagoBibliographyLabel: "Thư mục:",
    chicagoBookLabel: "Sách (Chú thích chân trang)",
    chicagoBookNote: "1. First Last, *Title of Book* (Publisher, Year), page.",
    chicagoBookBibliography: "Last, First. *Title of Book*. Publisher, Year.",
    chicagoJournalLabel: "Bài Báo Tạp Chí (Chú thích chân trang)",
    chicagoJournalNote:
      '1. First Last, "Title of Article," *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoJournalBibliography:
      'Last, First. "Title of Article." *Journal Title* Vol, no. Issue (Year): pages.',
    chicagoWebsiteLabel: "Trang Web (Chú thích chân trang)",
    chicagoWebsiteNote:
      '1. First Last, "Title of Page," Site Name, Month Day, Year, URL.',
    chicagoWebsiteBibliography:
      'Last, First. "Title of Page." Site Name. Month Day, Year. URL.',
    chicagoShortHeading: "Chú thích Rút gọn",
    chicagoShortIntro:
      "Sau trích dẫn đầy đủ đầu tiên, hãy dùng chú thích chân trang rút gọn:",
    chicagoShortExample: "1. Last, *Short Title*, page.",
    chicagoRulesHeading: "Quy tắc Định dạng Chính",
    chicagoRule1:
      "Dùng số mũ (superscript) cho các tham chiếu chú thích chân trang trong văn bản",
    chicagoRule2: "Các mục trong thư mục dùng thụt lề treo",
    chicagoRule3:
      'Dùng chú thích rút gọn thay cho "Ibid." khi trích dẫn liên tiếp cùng một nguồn',
    chicagoRule4:
      "Nhan đề: sách và tạp chí in nghiêng, bài báo và chương sách để trong ngoặc kép",
    chicagoRule5: "Dùng ngày truy cập cho các nguồn trực tuyến có thể thay đổi",
    chicagoCtaText: "Tạo trích dẫn Chicago hoàn hảo một cách tự động",
    chicagoCtaButton: "Công cụ Tạo Trích dẫn Chicago →",
  },

  // The catalog's page-type labels (`CATALOG_TYPE_LABELS`), which the search page shows
  // as facet chips and beside every result. Layer 2: a fact from `src/lib/**` rather
  // than page chrome, and English until it is mapped through here.
  catalogTypes: {
    core: "Trang chính",
    styleLanding: "Trang trung tâm kiểu trích dẫn chính",
    style: "Trang tham khảo kiểu trích dẫn",
    styleExamples: "Trang ví dụ trích dẫn",
    styleFormat: "Hướng dẫn định dạng bài viết",
    styleInText: "Hướng dẫn trích dẫn trong bài",
    styleAnnotatedBibliography: "Hướng dẫn thư mục có chú giải",
    styleReferencePage: "Hướng dẫn trang tài liệu tham khảo/danh mục trích dẫn",
    tool: "Công cụ viết và trích dẫn miễn phí",
    guide: "Hướng dẫn học tập",
    guideCategory: "Danh mục hướng dẫn",
    toolCollection: "Bộ sưu tập công cụ",
    howToCite: "Cách trích dẫn <nguồn> theo <kiểu>",
    comparison: "So sánh các kiểu trích dẫn",
    converter: "Công cụ chuyển đổi mã định danh và định dạng",
    field: "Kiểu trích dẫn theo lĩnh vực học thuật",
    region: "Kiểu trích dẫn theo quốc gia/khu vực",
    category: "Kiểu trích dẫn theo chủ đề",
    cheatSheet: "Bảng tra cứu nhanh một trang",
    glossary: "Thuật ngữ trích dẫn và viết học thuật",
  },

  // /about
  aboutPage: {
    metaTitle: "Giới thiệu CitationEasy - Công cụ Tạo Trích dẫn Miễn phí",
    metaDescription:
      "CitationEasy là công cụ tạo trích dẫn miễn phí hỗ trợ {count} kiểu. Được xây dựng bởi Samuel Sergi bằng các công cụ mã nguồn mở như Citation Style Language, Citation.js và Next.js.",
    backLink: "← Quay lại Công cụ Tạo",
    heading: "Giới thiệu CitationEasy",
    intro:
      "CitationEasy là công cụ tạo trích dẫn miễn phí, truy cập mở, được xây dựng cho sinh viên, nhà nghiên cứu và người viết học thuật. Nó hỗ trợ **{count} kiểu trích dẫn** và cung cấp một bộ sưu tập ngày càng lớn gồm công cụ viết, hướng dẫn học tập và tài nguyên tham khảo — tất cả đều không yêu cầu đăng ký hay trả phí.",
    offerHeading: "Những Gì Chúng tôi Cung cấp",
    offer1:
      "[Công cụ tạo trích dẫn](/) với {count} kiểu bao gồm APA bản 7, MLA bản 9, Chicago bản 18, Harvard, Vancouver, IEEE và hàng nghìn kiểu khác",
    offer2:
      "[40 công cụ viết và trích dẫn miễn phí](/tools) — đếm từ, kiểm tra độ dễ đọc, xác thực DOI, sắp xếp thư mục theo bảng chữ cái và nhiều hơn nữa",
    offer3:
      "[750 hướng dẫn cách trích dẫn](/how-to-cite) bao quát mọi loại nguồn chính trên 6 kiểu trích dẫn",
    offer4:
      "[Hơn 100 hướng dẫn học tập](/guides) về các phương pháp trích dẫn tốt nhất, viết học thuật và kỹ năng nghiên cứu",
    offer5:
      "[Công cụ so sánh kiểu trích dẫn](/compare), [trắc nghiệm kiểu trích dẫn](/quiz) và [bảng tra cứu nhanh](/cheat-sheets) để tham khảo nhanh",
    offer6:
      "7 định dạng xuất: văn bản thuần, BibTeX, Word, danh sách đánh số, danh sách gạch đầu dòng, RIS và CSV",
    openSourceHeading: "Được Xây dựng Từ Mã nguồn Mở",
    openSourceIntro:
      "CitationEasy được thực hiện nhờ một số dự án và API mã nguồn mở xuất sắc. Chúng tôi tin vào việc ghi nhận công lao đúng chỗ:",
    openSource1:
      "[Citation Style Language (CSL)](https://citationstyles.org/) — tiêu chuẩn mở cung cấp năng lượng cho {count} kiểu trích dẫn của chúng tôi. CSL được duy trì bởi một cộng đồng tình nguyện viên và được sử dụng bởi các trình quản lý tài liệu tham khảo như Zotero, Mendeley và Papers. Các định nghĩa kiểu đến từ [Kho lưu trữ Kiểu CSL](https://github.com/citation-style-language/styles) trên GitHub.",
    openSource2:
      "[Citation.js](https://citation.js.org/) — thư viện JavaScript xử lý trích dẫn và định dạng chúng theo các kiểu CSL. Được tạo ra bởi Lars Willighagen.",
    openSource3:
      "[Open Library API](https://openlibrary.org/developers/api) — API tìm kiếm sách miễn phí do Internet Archive cung cấp, được dùng để tra cứu siêu dữ liệu sách theo nhan đề hoặc ISBN.",
    openSource4:
      "[DOI Foundation](https://www.doi.org/) — hệ thống Định danh Đối tượng Số dùng để phân giải và xác thực DOI.",
    createdHeading: "Được Tạo Bởi",
    createdBody:
      "CitationEasy được tạo ra và duy trì bởi **Samuel Sergi**. Mục tiêu rất đơn giản: cung cấp một công cụ trích dẫn thực sự miễn phí, chất lượng cao, không giới hạn tính năng sau bức tường trả phí hay yêu cầu tài khoản.",
    contactPrompt: "Bạn có câu hỏi, phản hồi hoặc góp ý? Hãy liên hệ:",
    contactEmail: "Email: [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    missionHeading: "Sứ mệnh của Chúng tôi",
    mission1:
      "Trích dẫn chính xác không nên tốn tiền. Nhiều công cụ trích dẫn quảng cáo là miễn phí nhưng lại giới hạn định dạng xuất, giới hạn số lượng trích dẫn hoặc thúc đẩy người dùng chuyển sang gói trả phí. CitationEasy cam kết hoàn toàn miễn phí — không đăng ký, không giới hạn, không có gói cao cấp.",
    mission2:
      "Mọi tính năng trên trang này, từ công cụ tạo trích dẫn đến các công cụ viết và hướng dẫn học tập, đều miễn phí cho tất cả mọi người. Chúng tôi tin rằng các công cụ liêm chính học thuật nên được tiếp cận bởi mọi sinh viên và nhà nghiên cứu, bất kể ngân sách của họ.",
  },

  // /contact
  contactPage: {
    metaTitle: "Liên hệ",
    metaDescription:
      "Liên hệ với CitationEasy. Bạn có câu hỏi, phản hồi hoặc góp ý về công cụ tạo trích dẫn và công cụ viết miễn phí của chúng tôi? Chúng tôi rất muốn được lắng nghe.",
    backLink: "← Quay lại Công cụ Tạo",
    heading: "Liên hệ",
    intro:
      "Bạn có câu hỏi, phản hồi hoặc góp ý về CitationEasy? Chúng tôi rất muốn được lắng nghe. Dù bạn phát hiện lỗi, có đề xuất tính năng hay cần trợ giúp về trích dẫn, đừng ngần ngại liên hệ với chúng tôi.",
    touchHeading: "Liên hệ với Chúng tôi",
    touchBody:
      "Cách tốt nhất để liên hệ với chúng tôi là qua email. Chúng tôi cố gắng phản hồi trong vòng 48 giờ.",
    emailLine: "**Email:** [sam@sammysergi.com](mailto:sam@sammysergi.com)",
    commonHeading: "Câu hỏi Thường gặp",
    commonIntro:
      "Trước khi liên hệ, bạn có thể tìm thấy câu trả lời cho câu hỏi của mình trong các tài nguyên sau:",
    resource1:
      "[Hướng dẫn trích dẫn](/guides) — hướng dẫn từng bước để trích dẫn nguồn theo mọi kiểu chính",
    resource2:
      "[Hướng dẫn cách trích dẫn](/how-to-cite) — 750 tổ hợp loại nguồn và kiểu trích dẫn kèm ví dụ",
    resource3:
      "[Bảng tra cứu nhanh](/cheat-sheets) — tham khảo nhanh cho định dạng APA, MLA và Chicago",
    resource4:
      "[Công cụ viết](/tools) — đếm từ, kiểm tra độ dễ đọc, xác thực DOI và nhiều hơn nữa",
    issueHeading: "Báo cáo Sự cố",
    issueIntro:
      "Nếu bạn phát hiện lỗi định dạng trích dẫn, tính năng bị hỏng hoặc kiểu trích dẫn không chính xác, vui lòng cung cấp càng nhiều chi tiết càng tốt khi liên hệ với chúng tôi:",
    issue1: "Kiểu trích dẫn bạn đang sử dụng",
    issue2: "Loại nguồn (sách, trang web, bài báo tạp chí, v.v.)",
    issue3: "Kết quả bạn mong đợi so với kết quả được tạo ra",
    issue4: "Trình duyệt và thiết bị của bạn (nếu liên quan)",
    issueOutro:
      "Điều này giúp chúng tôi xác định và khắc phục sự cố nhanh chóng.",
    aboutHeading: "Về CitationEasy",
    aboutBody:
      "CitationEasy là công cụ tạo trích dẫn miễn phí hỗ trợ hơn 10.000 kiểu trích dẫn. Nó được tạo ra bởi Samuel Sergi với mục tiêu giúp mọi người đều có thể tiếp cận trích dẫn chính xác. Tìm hiểu thêm tại [trang Giới thiệu](/about) của chúng tôi.",
  },

  // /ai — the agent and developer docs.
  //
  // The code samples, endpoint paths and MCP tool NAMES are deliberately absent: they are
  // the API's identifiers, served in English by the API itself, and a translated one
  // would document an endpoint that does not exist.
  aiPage: {
    metaTitle:
      "CitationEasy cho Trợ lý & Agent AI - API, Máy chủ MCP, llms.txt",
    metaDescription:
      "Sử dụng CitationEasy theo cách lập trình: một API JSON miễn phí không cần xác thực cho trích dẫn theo {count} kiểu, một máy chủ MCP dành cho agent, llms.txt, đặc tả OpenAPI và chế độ xem markdown cho mọi trang.",
    keyword1: "API trích dẫn",
    keyword2: "máy chủ MCP",
    keyword3: "API công cụ tạo trích dẫn",
    keyword4: "llms.txt",
    keyword5: "OpenAPI",
    keyword6: "trích dẫn cho agent AI",
    keyword7: "API trích dẫn miễn phí",
    webApiDescription:
      "API JSON miễn phí, không cần xác thực, định dạng trích dẫn theo {count} kiểu Citation Style Language từ một URL, DOI, ISBN, PubMed ID, arXiv ID hoặc siêu dữ liệu CSL-JSON.",
    breadcrumb: "Dành cho AI & agent",
    heading: "CitationEasy dành cho trợ lý và agent AI",
    intro:
      "Mọi thứ trên trang này đều khả dụng cho phần mềm cũng như con người: một API JSON miễn phí, một máy chủ MCP, một đặc tả OpenAPI, một chỉ mục llms.txt và chế độ xem markdown cho tất cả {count} trang. Không cần khóa API, không cần tài khoản, không có giới hạn tốc độ riêng của chúng tôi.",
    whyHeading: "Tại sao nên gọi API thay vì tự viết trích dẫn",
    whyBody:
      "Định dạng trích dẫn trông giống như một bài toán sinh văn bản nhưng không phải vậy. Mỗi kiểu mã hóa hàng trăm quy tắc về đảo tên tác giả, chữ viết tắt, viết hoa tiêu đề, dấu câu của vật chứa, cách ghi ấn bản và vị trí ngày tháng, và chúng khác nhau theo những cách rất dễ nhớ sai một cách tinh vi. CitationEasy chạy **citeproc-js** dựa trên các định nghĩa Citation Style Language chính thức — cùng công cụ mà Zotero và Mendeley sử dụng — nên đầu ra là tất định và khớp với những gì hệ thống nộp bài của một tạp chí mong đợi. Siêu dữ liệu đến từ Crossref, Open Library và PubMed; không có gì được bịa ra, và một trường bị thiếu ở nguồn dữ liệu gốc sẽ vẫn thiếu thay vì được điền bằng một phỏng đoán hợp lý.",
    generateHeading: "Tạo một trích dẫn",
    generateBody:
      "Gửi `inputs` thay vì `input` để xử lý tối đa 10 nguồn trong một lần gọi, hoặc `entry` với siêu dữ liệu CSL-JSON bạn đã có sẵn để bỏ qua hoàn toàn bước tra cứu. Thêm `note: true` để lấy dạng chú thích chân trang. Lỗi của từng nguồn được trả về riêng cho nguồn đó, vì vậy một lô không bao giờ thất bại toàn bộ.",
    mcpHeading: "Kết nối qua MCP",
    mcpIntro:
      "Điểm cuối Model Context Protocol tại `/api/mcp` giao tiếp bằng JSON-RPC 2.0 qua streamable HTTP và không cần thông tin xác thực.",
    mcpToolsHeading: "Các công cụ nó cung cấp",
    endpointsHeading: "Điểm cuối",
    colEndpoint: "Điểm cuối",
    colWhat: "Chức năng",
    endpointCite:
      "Định dạng tối đa 10 nguồn cùng lúc. Nhận một URL, DOI, ISBN, PubMed ID, arXiv ID, văn bản BibTeX/RIS/CSL-JSON, hoặc một đối tượng mục CSL-JSON. Trả về mục tài liệu tham khảo, và tùy chọn cả trích dẫn trong bài lẫn chú thích chân trang.",
    endpointStyles:
      "Tìm kiếm toàn bộ {count} kiểu theo tên, nhóm định dạng trích dẫn, ngành học hoặc khu vực.",
    endpointStyleSlug:
      "Một kiểu đầy đủ, với các ví dụ định dạng thực tế được tạo ra từ chính định nghĩa CSL của kiểu đó.",
    endpointSearch:
      "Tìm kiếm được xếp hạng theo mức độ liên quan trên mọi trang của trang web.",
    endpointPages:
      "Toàn bộ danh mục trang web dưới dạng các mục có cấu trúc, có thể lọc theo loại trang.",
    endpointHowToCite:
      "Mọi trang hướng dẫn theo tổ hợp loại nguồn × kiểu, có thể lọc theo một trong hai.",
    endpointTools: "Mọi công cụ miễn phí, kèm danh mục và từ khóa.",
    endpointGuides: "Mọi hướng dẫn học tập, kèm danh mục.",
    endpointConverters:
      "Mọi công cụ chuyển đổi mã định danh và định dạng mà trang web cung cấp.",
    endpointComparisons:
      "So sánh song song các kiểu, liên kết đến hồ sơ của cả hai kiểu.",
    endpointFields:
      'Các lĩnh vực học thuật, danh mục chủ đề và khu vực — để trả lời câu hỏi "tôi nên dùng kiểu nào?".',
    endpointFaq:
      "Các câu trả lời đã được kiểm chứng cho những câu hỏi trích dẫn thường gặp, có thể lọc bằng q.",
    endpointGlossary:
      "Các thuật ngữ trích dẫn và viết học thuật kèm định nghĩa đầy đủ — phản hồi mang theo toàn bộ văn bản, nên không cần lấy thêm trang nào sau đó.",
    endpointIndex:
      "Tài liệu khám phá điểm cuối. Bắt đầu tại đây nếu bạn đang tìm hiểu.",
    discoveryHeading: "Tệp khám phá",
    discoveryLlms:
      "Chỉ mục được tuyển chọn của trang web, viết dành cho mô hình ngôn ngữ.",
    discoveryLlmsFull:
      "Mọi trang mà trang web xuất bản, được nhóm theo loại, mỗi trang một dòng.",
    discoveryOpenapi: "Mô tả OpenAPI 3.1 cho toàn bộ API công khai.",
    discoveryMcp:
      "Điểm cuối MCP (streamable HTTP). Gửi GET trong trình duyệt để xem mô tả.",
    discoveryWellKnownMcp:
      "Tài liệu khám phá MCP dành cho agent dò tìm một tên miền.",
    discoveryAiPlugin:
      "Tệp khai báo plugin cũ, dành cho các framework vẫn còn tìm kiếm nó.",
    discoveryMd: "Chế độ xem markdown của bất kỳ trang nào trên trang web.",
    discoverySitemap: "Mọi URL có thể được lập chỉ mục.",
    catalogHeading: "Danh mục gồm những gì",
    catalogIntro:
      "Mọi trang dưới đây đều có thể truy cập dưới dạng HTML, dưới dạng markdown tại `/md/`, và dưới dạng một mục có cấu trúc từ `/api/v1/pages`.",
    catalogStyles:
      "**{count}** kiểu trích dẫn, mỗi kiểu có ví dụ thực tế được tạo ra từ chính định nghĩa CSL của nó",
    catalogTools: "**{count}** công cụ trình duyệt miễn phí",
    catalogGuides: "**{count}** hướng dẫn học tập",
    catalogHowToCite: "**{count}** trang cách trích dẫn",
    catalogComparisons: "**{count}** so sánh kiểu",
    catalogConverters: "**{count}** công cụ chuyển đổi",
    catalogFields: "**{count}** lĩnh vực học thuật",
    catalogStyleLandings:
      "**{count}** trang trung tâm kiểu chính với đầy đủ quy tắc định dạng",
    faqHeading: "Câu hỏi Thường gặp",
    faqFreeQ:
      "API CitationEasy có miễn phí không, và tôi có cần khóa API không?",
    faqFreeA:
      "Miễn phí và không cần khóa API. Mọi điểm cuối trong /api/v1 đều không cần xác thực và mở CORS, vì vậy bạn có thể gọi từ trình duyệt, notebook hoặc agent mà không cần đăng ký. Chúng tôi không đặt giới hạn tốc độ riêng, nhưng các tra cứu mã định danh được chuyển tiếp đến Crossref, Open Library và PubMed, những bên áp dụng giới hạn sử dụng hợp lý của riêng họ — hãy gộp lô bằng `inputs` thay vì gửi nhiều yêu cầu song song.",
    faqLlmQ: "Trích dẫn có được tạo bởi mô hình ngôn ngữ không?",
    faqLlmA:
      "Không. Việc định dạng chạy citeproc-js dựa trên các định nghĩa Citation Style Language chính thức, cùng công cụ mà các trình quản lý tài liệu tham khảo sử dụng. Cùng một đầu vào và kiểu luôn tạo ra cùng một chuỗi kết quả. Siêu dữ liệu thư mục đến từ Crossref (DOI), Open Library (ISBN) và PubMed (PMID) — CitationEasy không bịa ra các trường, vì vậy bất cứ điều gì thiếu ở nguồn gốc sẽ thiếu trong đầu ra thay vì bị đoán ra.",
    faqMcpQ: "Làm thế nào để kết nối một agent với CitationEasy qua MCP?",
    faqMcpA:
      "Trỏ bất kỳ client Model Context Protocol nào đến https://www.citationeasy.com/api/mcp bằng giao vận streamable HTTP. Không cần thông tin xác thực. Trong Claude Code: `claude mcp add --transport http citationeasy https://www.citationeasy.com/api/mcp`. Máy chủ này cung cấp các công cụ để tạo trích dẫn, tìm kiếm {count} kiểu, hướng dẫn theo loại nguồn, tìm kiếm trang web và đọc bất kỳ trang nào dưới dạng markdown.",
    faqStylesQ: "API có thể tạo ra những kiểu trích dẫn nào?",
    faqStylesA:
      'Tất cả {count} kiểu trong kho lưu trữ Citation Style Language, bao gồm APA 7, MLA 9, cả hai hệ thống Chicago, Harvard, Vancouver, IEEE, AMA và hàng nghìn kiểu tạp chí riêng lẻ. Truyền slug của kiểu vào trường `style`. Các slug thân thiện như "chicago" và "harvard" sẽ phân giải đến đúng biến thể CSL, và /api/v1/styles?q= tìm ra phần còn lại.',
    faqLlmsTxtQ: "llms.txt là gì và của CitationEasy nằm ở đâu?",
    faqLlmsTxtA:
      "llms.txt là một chỉ mục dạng văn bản thuần của một trang web, viết dành cho mô hình ngôn ngữ thay vì trình duyệt. Của CitationEasy nằm tại /llms.txt; phiên bản đầy đủ liệt kê mọi trang của trang web nằm tại /llms-full.txt.",
    faqMarkdownQ:
      "Tôi có thể đọc các trang của CitationEasy dưới dạng markdown thay vì HTML không?",
    faqMarkdownA:
      "Có. Thêm tiền tố /md/ vào bất kỳ đường dẫn trang nào — ví dụ /md/citation-style/apa hoặc /md/tools/word-counter. Các trang dựa trên dữ liệu trả về toàn bộ nội dung, bao gồm các ví dụ định dạng thực tế được tạo ra từ chính định nghĩa CSL của mỗi kiểu. Các trang văn xuôi viết tay (hướng dẫn, bảng tra cứu nhanh) trả về một thẻ tóm tắt cùng URL HTML chính thức, vì nội dung của chúng nằm ngay trong trang.",
    faqReuseQ:
      "Tôi có thể sử dụng kết quả của CitationEasy trong sản phẩm của riêng mình không?",
    faqReuseA:
      "Có. Một trích dẫn đã định dạng là một sự thật về một nguồn; hãy sử dụng nó tự do. Bản thân các định nghĩa kiểu CSL đến từ dự án Citation Style Language theo giấy phép CC BY-SA 3.0. Ghi công cho CitationEasy được hoan nghênh nhưng không bắt buộc.",
    missingHeading: "Thiếu điều gì đó?",
    missingBody:
      "Nếu agent của bạn cần một điểm cuối, một trường hoặc một định dạng chưa có ở đây, [hãy cho chúng tôi biết](/contact). Đang duyệt thủ công? [Bắt đầu tại công cụ tạo trích dẫn](/).",
  },

  // /quiz. The client component reads these as a prop rather than through a context:
  // it is one component, not the generator's nine, so there is nothing to drill through.
  quizPage: {
    metaTitle: "Tôi Nên Dùng Kiểu Trích dẫn Nào? - Trắc nghiệm Kiểu Miễn phí",
    metaDescription:
      "Trả lời một vài câu hỏi nhanh về lĩnh vực, loại bài viết và sở thích của bạn để tìm ra kiểu trích dẫn phù hợp nhất cho bài viết của bạn. APA, MLA, Chicago, Vancouver và nhiều kiểu khác.",
    ogTitle: "Tôi Nên Dùng Kiểu Trích dẫn Nào?",
    ogDescription:
      "Làm bài trắc nghiệm miễn phí của chúng tôi để tìm kiểu trích dẫn phù hợp nhất cho bài viết của bạn.",
    breadcrumbHome: "CitationEasy",
    breadcrumbCurrent: "Trắc nghiệm Kiểu",
    backLink: "← Quay lại Công cụ Tạo",
    heading: "Tôi Nên Dùng Kiểu Trích dẫn Nào?",
    intro:
      "Trả lời một vài câu hỏi nhanh và chúng tôi sẽ đề xuất kiểu trích dẫn phù hợp nhất cho bài viết của bạn.",
    progress: "Câu hỏi {current} / {total}",
    qDiscipline: "Lĩnh vực học tập của bạn là gì?",
    optSocialScience: "Tâm lý học / Khoa học Xã hội",
    optHumanities: "Văn học / Nhân văn",
    optHistory: "Lịch sử / Lịch sử Nghệ thuật",
    optMedical: "Y học / Điều dưỡng / Sức khỏe",
    optEngineering: "Kỹ thuật / Khoa học Máy tính",
    optNaturalScience: "Khoa học Tự nhiên (Sinh học, Hóa học)",
    optLaw: "Luật",
    optBusiness: "Kinh doanh / Kinh tế",
    qPaperType: "Bạn đang viết loại bài viết nào?",
    optResearch: "Bài nghiên cứu hoặc luận văn",
    optReview: "Tổng quan tài liệu",
    optReport: "Báo cáo thí nghiệm hoặc báo cáo kỹ thuật",
    optEssay: "Bài luận hoặc bài tập lớp",
    optJournal: "Bài nộp cho tạp chí",
    qRegion: "Cơ sở đào tạo của bạn ở đâu?",
    optUs: "Hoa Kỳ",
    optUk: "Vương quốc Anh / Úc",
    optCanada: "Canada",
    optEurope: "Châu Âu (ngoài Anh)",
    optOther: "Khác",
    qPreference: "Bạn có ưu tiên định dạng trích dẫn nào không?",
    optAuthorDate: "Trích dẫn trong bài (Tác giả, Năm)",
    optNumeric: "Tài liệu tham khảo đánh số [1]",
    optFootnotes: "Chú thích chân trang",
    optNoPreference: "Không ưu tiên",
    styleVancouver: "Vancouver",
    styleAma: "AMA (Hiệp hội Y khoa Hoa Kỳ)",
    styleIeee: "IEEE",
    styleBluebook: "Bluebook",
    styleCse: "CSE (Hội đồng Biên tập viên Khoa học)",
    styleChicagoNotes: "Chicago (Chú thích & Thư mục)",
    styleMla: "MLA (Bản thứ 9)",
    styleApa: "APA (Bản thứ 7)",
    styleHarvard: "Harvard",
    reasonVancouverMedical:
      "Vancouver là kiểu chuẩn cho các tạp chí y học và khoa học sức khỏe, sử dụng tài liệu tham khảo đánh số.",
    reasonAma:
      "AMA được sử dụng rộng rãi trong các tạp chí y khoa và dùng trích dẫn đánh số.",
    reasonIeee:
      "IEEE là kiểu trích dẫn chuẩn cho các lĩnh vực kỹ thuật, khoa học máy tính và công nghệ thông tin.",
    reasonBluebook:
      "Bluebook là kiểu trích dẫn chính thức cho văn bản pháp lý. Kiểu Chicago là lựa chọn thay thế đa dụng gần nhất.",
    reasonCse: "CSE là kiểu chuẩn cho sinh học và khoa học tự nhiên.",
    reasonChicagoHistory:
      "Chicago Chú thích & Thư mục là tiêu chuẩn vàng cho lịch sử và lịch sử nghệ thuật, sử dụng chú thích chân trang cho trích dẫn.",
    reasonChicagoHumanities:
      "Chicago Chú thích & Thư mục phù hợp tốt với ngành nhân văn nhờ cách tiếp cận dựa trên chú thích chân trang.",
    reasonMla:
      "MLA là kiểu chuẩn cho các lĩnh vực văn học, ngôn ngữ và nhân văn.",
    reasonApaBusiness:
      "APA được sử dụng rộng rãi trong các lĩnh vực kinh doanh, kinh tế và quản lý.",
    reasonHarvard:
      "Trích dẫn Harvard là kiểu phổ biến nhất tại các trường đại học Anh và Úc.",
    reasonChicagoFootnotes:
      "Chicago Chú thích & Thư mục sử dụng chú thích chân trang, lý tưởng cho các trích dẫn chi tiết.",
    reasonVancouverNumeric:
      "Vancouver sử dụng trích dẫn đánh số, giúp văn bản của bạn gọn gàng và dễ đọc.",
    reasonApaDefault:
      "APA là kiểu trích dẫn được sử dụng rộng rãi nhất trong khoa học xã hội, giáo dục và nhiều lĩnh vực khác.",
    recommendLabel: "Chúng tôi đề xuất",
    generateButton: "Tạo Trích dẫn {style}",
    retakeButton: "Làm lại Trắc nghiệm",
    guidesLink:
      "Duyệt hướng dẫn trích dẫn của chúng tôi để được trợ giúp thêm →",
    previousButton: "← Câu hỏi trước",
  },

  // /search — the server-rendered site search.
  searchPage: {
    metaTitle: "Tìm kiếm CitationEasy",
    metaDescription:
      "Tìm kiếm mọi trang trên CitationEasy cùng lúc: {count} kiểu trích dẫn, hơn 250 công cụ miễn phí, hướng dẫn, trang cách trích dẫn, so sánh kiểu, công cụ chuyển đổi và thuật ngữ.",
    keyword1: "tìm kiếm kiểu trích dẫn",
    keyword2: "tìm hướng dẫn trích dẫn",
    keyword3: "tìm kiếm công cụ trích dẫn",
    ogDescription:
      "Tìm kiếm mọi trang trên trang web cùng lúc — kiểu, công cụ, hướng dẫn, trang cách trích dẫn, so sánh, công cụ chuyển đổi và thuật ngữ.",
    ogImageSubtitle:
      "Mọi kiểu trích dẫn, công cụ, hướng dẫn, trang cách trích dẫn, so sánh, công cụ chuyển đổi và thuật ngữ — được tìm kiếm cùng nhau.",
    ogKind: "Tìm kiếm",
    breadcrumb: "Tìm kiếm",
    heading: "Tìm kiếm CitationEasy",
    intro:
      "Mọi kiểu trích dẫn, công cụ, hướng dẫn, trang cách trích dẫn, so sánh, công cụ chuyển đổi và thuật ngữ trên trang — được tìm kiếm cùng nhau.",
    inputLabel: "Từ khóa tìm kiếm",
    inputPlaceholder: "ví dụ: trích dẫn podcast theo APA, thụt lề treo, DOI",
    submit: "Tìm kiếm",
    browseHeading: "Hoặc duyệt theo mục",
    browseStyles: "Kiểu trích dẫn",
    browseStylesNote: "{count} kiểu",
    browseTools: "Công cụ miễn phí",
    browseToolsNote: "{count} công cụ",
    browseHowTo: "Cách trích dẫn mọi loại nguồn",
    browseHowToNote: "{count} trang",
    browseGuides: "Hướng dẫn",
    browseGuidesNote: "{count} hướng dẫn",
    browseGlossary: "Thuật ngữ",
    browseGlossaryNote: "{count} thuật ngữ",
    browseComparisons: "So sánh kiểu",
    browseComparisonsNote: "{count} so sánh",
    browseConverters: "Công cụ chuyển đổi",
    browseConvertersNote: "{count} công cụ chuyển đổi",
    browseCheatSheets: "Bảng tra cứu nhanh",
    browseCheatSheetsNote: "{count} bảng",
    facetsLabel: "Lọc theo loại trang",
    facetAll: "Tất cả ({count})",
    noMatches: "Không có trang nào khớp với “{query}”.",
    matchesOne: "{count} trang khớp với “{query}”.",
    matchesMany: "{count} trang khớp với “{query}”.",
    pagerLabel: "Trang kết quả",
    pagerPrevious: "← Trước",
    pagerNext: "Tiếp →",
    pagerPosition: "Trang {page} / {total}",
    paletteLoading: "Đang tìm kiếm…",
    paletteError: "Tính năng tìm kiếm hiện không khả dụng. Vui lòng thử lại.",
    paletteViewAll: "Xem tất cả kết quả cho “{query}”",
    apiNote:
      "Đang xây dựng thứ gì đó? Cùng chỉ mục này cũng có sẵn dưới dạng JSON tại [/api/v1/search](/api/v1/search?q=podcast) và qua MCP — xem [tài liệu dành cho agent](/ai).",
  },

  // /cite-this-page. The six FAQ answers used to exist twice — once in the layout for the
  // FAQPage markup and once in the page for the visible list — which is exactly the drift
  // this dictionary removes: both now read the same keys.
  citeThisPage: {
    metaTitle:
      "Trích dẫn Trang Này - Trích dẫn Một Cú nhấp (Bookmarklet & Tiện ích Chrome)",
    metaDescription:
      "Trích dẫn bất kỳ trang web nào chỉ với một cú nhấp. Kéo bookmarklet 'Trích dẫn Trang Này' miễn phí vào thanh dấu trang của bạn, hoặc cài đặt tiện ích Chrome miễn phí với nút trên thanh công cụ và trích dẫn bằng nhấp chuột phải. Cũng hoạt động trên Chromebook và trình duyệt bị khóa.",
    ogTitle: "Bookmarklet Trích dẫn Trang Này & Tiện ích Chrome",
    ogDescription:
      "Trích dẫn trang web bằng một cú nhấp từ bất kỳ trang nào — một bookmarklet kéo-thả cùng với tiện ích Chrome miễn phí hỗ trợ trích dẫn bằng nhấp chuột phải.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbSchemaCurrent: "Bookmarklet Trích dẫn Trang Này",
    appName: "Bookmarklet Trích dẫn Trang Này",
    appDescription:
      "Một bookmarklet miễn phí giúp trích dẫn trang web bạn đang đọc chỉ với một cú nhấp — nó mở CitationEasy với URL của trang đã được điền sẵn, sau đó định dạng trích dẫn theo APA, MLA, Chicago và {count} kiểu khác.",
    breadcrumbLabel: "Đường dẫn điều hướng",
    breadcrumbHome: "Trang chủ",
    breadcrumbCurrent: "Bookmarklet Trích dẫn Trang Này",
    heading: "Trích dẫn Trang Này: Bookmarklet & Tiện ích Chrome",
    intro:
      "Trích dẫn bất kỳ trang web nào chỉ với một cú nhấp — không cần đăng ký. Kéo bookmarklet bên dưới vào thanh dấu trang của bạn (không cần cài đặt gì cả), hoặc lấy tiện ích Chrome miễn phí để có nút trên thanh công cụ và trích dẫn bằng nhấp chuột phải.",
    dragPrompt: "Kéo nút này vào thanh dấu trang của bạn:",
    buttonTitle: "Kéo tôi vào thanh dấu trang của bạn",
    buttonLabel: "📑 Trích dẫn Trang Này",
    dontClick:
      "Đừng nhấp vào đây — hãy kéo nó lên thanh dấu trang của bạn trước.",
    installHeading: "Cách cài đặt",
    step1Title: "Hiện thanh dấu trang của bạn",
    step1Body:
      "Ở hầu hết các trình duyệt, nhấn Ctrl+Shift+B (Cmd+Shift+B trên Mac) để bật/tắt thanh dấu trang để bạn có chỗ thả nút.",
    step2Title: "Kéo nút lên",
    step2Body:
      "Nhấp và giữ nút 'Trích dẫn Trang Này' bên dưới, sau đó kéo nó vào thanh dấu trang của bạn rồi thả ra. Nó sẽ trở thành một dấu trang bình thường.",
    step3Title: "Nhấp vào nó trên bất kỳ trang nào",
    step3Body:
      "Khi đang đọc một bài báo, tin tức hoặc trang tạp chí, hãy nhấp vào dấu trang mới của bạn. CitationEasy sẽ mở ra với URL của trang đó đã được điền sẵn và trích dẫn đã sẵn sàng để sao chép.",
    manualHeading: "Không kéo được? Thêm thủ công",
    manualBody:
      'Tạo một dấu trang mới, đặt tên là "Trích dẫn Trang Này", và dán nội dung sau làm URL/địa chỉ:',
    howHeading: "Cách hoạt động",
    howBody:
      "Bookmarklet này không chạy bất kỳ đoạn mã nào trên trang bạn đang đọc. Nó chỉ chuyển địa chỉ web của trang đó cho CitationEasy, nơi máy chủ của chúng tôi lấy và phân tích siêu dữ liệu công khai của trang — cùng một đường dẫn đáng tin cậy được dùng khi bạn tự dán URL vào công cụ tạo. Điều này giữ cho nó an toàn và tránh các giới hạn cross-origin từng khiến các bookmarklet chạy trong trang cũ bị loại bỏ.",
    extensionHeading: "Thích dùng tiện ích Chrome hơn?",
    extensionBody:
      "Tiện ích CitationEasy miễn phí thêm một nút trên thanh công cụ để trích dẫn tab hiện tại, cùng với tùy chọn nhấp chuột phải để trích dẫn một liên kết — hoặc một DOI hay ISBN đã chọn — mà không cần mở nó. Giống như bookmarklet, nó không chạy bất kỳ đoạn mã nào trên các trang bạn truy cập: nó chỉ chuyển URL cho CitationEasy. Nó chỉ cần quyền `activeTab` và `contextMenus`, và hoạt động trên Chrome, Edge, Brave và các trình duyệt Chromium khác.",
    downloadButton: "⬇ Tải tiện ích Chrome (.zip)",
    install1: "Tải xuống và giải nén tiện ích.",
    install2:
      "Mở `chrome://extensions` và bật **Chế độ dành cho nhà phát triển** (góc trên bên phải).",
    install3:
      "Nhấp vào **Tải tiện ích đã giải nén** và chọn thư mục đã giải nén.",
    install4:
      "Ghim nút CitationEasy, sau đó nhấp vào nó trên bất kỳ trang nào để trích dẫn.",
    faqHeading: "Câu hỏi Thường gặp",
    faqWhatQ: "Bookmarklet 'Trích dẫn Trang Này' là gì?",
    faqWhatA:
      "Đây là một dấu trang nhỏ mà bạn kéo vào thanh dấu trang của trình duyệt. Khi bạn nhấp vào nó trên bất kỳ trang web nào, nó sẽ mở CitationEasy trong một tab mới với URL của trang đó đã được điền sẵn, để bạn có được trích dẫn đã định dạng chỉ với một cú nhấp — không cần sao chép-dán.",
    faqExtensionNeededQ: "Tôi có cần cài đặt tiện ích không?",
    faqExtensionNeededA:
      "Không. Bookmarklet chỉ là một dấu trang, vì vậy không có gì cần cài đặt và không có quyền nào cần cấp. Nó hoạt động trên Chromebook trường học bị khóa và hầu hết trình duyệt di động nơi tiện ích bị chặn. Nếu bạn thích dùng tiện ích hơn, một tiện ích Chrome miễn phí cũng có sẵn trên trang này.",
    faqChromeQ: "Có tiện ích Chrome không?",
    faqChromeA:
      "Có. Tiện ích Chrome CitationEasy miễn phí thêm một nút trên thanh công cụ để trích dẫn tab hiện tại, cùng với tùy chọn nhấp chuột phải để trích dẫn một liên kết hoặc một DOI/ISBN đã chọn mà không cần mở nó. Nó không chạy bất kỳ đoạn mã nào trên các trang bạn truy cập và chỉ cần quyền activeTab và contextMenus. Tải nó từ trang này và nạp qua chrome://extensions, nó hoạt động trên Chrome, Edge, Brave và các trình duyệt Chromium khác.",
    faqAddQ: "Làm thế nào để thêm bookmarklet?",
    faqAddA:
      "Đảm bảo thanh dấu trang của bạn đang hiển thị, sau đó kéo nút 'Trích dẫn Trang Này' trên trang này vào đó. Nếu không thể kéo (ví dụ trên di động), hãy tạo một dấu trang mới thủ công và dán mã bookmarklet làm URL.",
    faqSafeQ: "Có an toàn không? Nó có đọc trang tôi đang xem không?",
    faqSafeA:
      "Có, nó an toàn. Bookmarklet không chạy bất kỳ đoạn mã nào trên trang bạn đang đọc — nó chỉ gửi địa chỉ web của trang đó đến CitationEasy, nơi máy chủ của chúng tôi lấy và phân tích siêu dữ liệu công khai của trang, giống hệt như khi bạn tự dán một URL vào.",
    faqOtherSourcesQ:
      "Nó có hoạt động với các nguồn khác ngoài trang web không?",
    faqOtherSourcesA:
      "Bookmarklet này dành cho trang web, nhưng liên kết bên dưới cũng chấp nhận DOI, ISBN, PMID hoặc arXiv ID thông qua tham số ?source= — vì vậy một liên kết 'trích dẫn' có thể chia sẻ cũng hoạt động với bài báo tạp chí và sách.",
    relatedHeading: "Công cụ Liên quan",
    relatedGenerator: "Công cụ Tạo Trích dẫn",
    relatedHowToCite: "Cách Trích dẫn Trang Web",
    relatedTools: "Tất cả Công cụ",
  },

  // /shared-bibliography — opens a bibliography that travelled inside a share link.
  sharedBibliographyPage: {
    metaTitle: "Thư mục Được Chia sẻ - Xem & Nhập Trích dẫn Được Chia sẻ",
    metaDescription:
      "Mở một thư mục mà ai đó đã chia sẻ với bạn từ CitationEasy. Xem các trích dẫn đã định dạng, sao chép chúng, hoặc nhập toàn bộ danh sách vào thư mục của riêng bạn — miễn phí, không cần tài khoản, và dữ liệu nằm ngay trong liên kết.",
    ogTitle: "Thư mục Được Chia sẻ",
    ogDescription:
      "Xem và nhập một thư mục được chia sẻ. Các trích dẫn di chuyển bên trong liên kết — không có gì được lưu trên máy chủ, và liên kết không bao giờ hết hạn.",
    breadcrumbRoot: "CitationEasy",
    breadcrumbLabel: "Đường dẫn điều hướng",
    breadcrumbHome: "Trang chủ",
    breadcrumbCurrent: "Thư mục Được Chia sẻ",
    heading: "Thư mục Được Chia sẻ",
    intro:
      "Ai đó đã chia sẻ những trích dẫn này với bạn. Sao chép chúng, hoặc nhập toàn bộ danh sách vào thư mục CitationEasy của riêng bạn chỉ với một cú nhấp chuột.",
    loading: "Đang mở thư mục được chia sẻ…",
    copyAll: "Sao chép tất cả",
    copied: "Đã sao chép",
    copyFailed: "Sao chép thất bại",
    citationOne: "trích dẫn",
    citationMany: "trích dẫn",
    addAll: "Thêm tất cả vào thư mục của tôi",
    added: "Đã thêm {count} vào thư mục của bạn",
    skippedOne: "Đã bỏ qua {count} mục trùng lặp",
    skippedMany: "Đã bỏ qua {count} mục trùng lặp",
    openGenerator: "mở công cụ tạo",
    emptyHeading: "Không có thư mục được chia sẻ trong liên kết này",
    emptyBody:
      "Trang này hiển thị các thư mục được chia sẻ từ CitationEasy. Để chia sẻ thư mục của bạn, hãy mở thư mục của bạn trong [công cụ tạo trích dẫn](/), chọn **Xuất → Sao chép liên kết chia sẻ**, và gửi liên kết cho bất kỳ ai. Các trích dẫn di chuyển ngay bên trong liên kết — không có gì được lưu trên máy chủ, vì vậy liên kết luôn hoạt động mãi mãi và dữ liệu của bạn luôn ở chế độ riêng tư.",
    decodeError: "Không thể mở liên kết chia sẻ này.",
  },

  // The 19 source types the 15 detailed styles show worked examples for
  // (`DetailedStyleData.examples[].sourceType`). 75 rows, 19 distinct values — so this
  // is a vocabulary, not per-page copy, and it belongs here rather than repeated in
  // every locale's `src/content/style-pages/<locale>.json`.
  //
  // Two casings for the same reason `howToCitePage.refList*Lower` has two: the pages
  // print the label as a heading ("Book") and inside a sentence ("a sample APA entry
  // for a book"). Lower-casing the translated noun in code is wrong in German, where
  // every one of these is capitalised, so the lower form is a real key a translator
  // fills rather than a `.toLowerCase()` call.
  //
  // The citations themselves — `referenceEntry` and `inTextCitation` — are NOT here and
  // are not translatable anywhere: they are worked examples in a specific style's own
  // punctuation. See `src/lib/localized-content.ts`.
  sourceTypes: {
    book: "Sách",
    bookLower: "sách",
    bookChapter: "Chương Sách",
    bookChapterLower: "chương sách",
    case: "Vụ Án",
    caseLower: "vụ án",
    conferencePaper: "Bài Báo Hội Nghị",
    conferencePaperLower: "bài báo hội nghị",
    courtCase: "Vụ Án Tòa Án",
    courtCaseLower: "vụ án tòa án",
    federalStatute: "Đạo Luật Liên Bang",
    federalStatuteLower: "đạo luật liên bang",
    governmentDocument: "Văn Bản Chính Phủ",
    governmentDocumentLower: "văn bản chính phủ",
    governmentReport: "Báo Cáo Chính Phủ",
    governmentReportLower: "báo cáo chính phủ",
    journalArticle: "Bài Báo Tạp Chí",
    journalArticleLower: "bài báo tạp chí",
    lawReviewArticle: "Bài Báo Tạp Chí Luật",
    lawReviewArticleLower: "bài báo tạp chí luật",
    legislation: "Văn Bản Pháp Luật",
    legislationLower: "văn bản pháp luật",
    newspaperArticle: "Bài Báo Trên Báo",
    newspaperArticleLower: "bài báo trên báo",
    patent: "Bằng Sáng Chế",
    patentLower: "bằng sáng chế",
    podcast: "Podcast",
    podcastLower: "podcast",
    preprint: "Bản Thảo Trước Xuất Bản",
    preprintLower: "bản thảo trước xuất bản",
    standard: "Tiêu Chuẩn",
    standardLower: "tiêu chuẩn",
    thesis: "Luận Văn",
    thesisLower: "luận văn",
    website: "Trang Web",
    websiteLower: "trang web",
    youtubeVideo: "Video YouTube",
    youtubeVideoLower: "video YouTube",
  },

  // Chrome shared by the five per-style guide routes — /examples, /format,
  // /in-text-citation, /reference-page and /annotated-bibliography, 15 styles each.
  //
  // One section rather than five copies: the CTA, the back link and the cross-links
  // between the five pages are the same sentences on every one of them, and duplicating
  // them per route would be five identical translation units instead of one.
  styleGuidePages: {
    backToStyle: "Quay lại {style}",
    backToGenerator: "Quay lại Công cụ Tạo Trích dẫn",
    ctaHeading: "Tạo Trích dẫn {style} Tự động",
    ctaButton: "Trích dẫn theo {style} Ngay →",
    faqHeading: "Câu hỏi thường gặp",
    resourcesHeading: "Thêm Tài nguyên",
    relatedHeading: "Hướng dẫn {style} Liên quan",
    resourceGenerator: "Công cụ Tạo Trích dẫn Miễn phí ({count} kiểu)",
    resourceTools: "Công cụ Viết Miễn phí",
    resourceGuides: "Tất cả Hướng dẫn Trích dẫn",
    resourceStyleGenerator: "Công cụ Tạo Trích dẫn {style}",
    resourceExamples: "Ví dụ Trích dẫn {style}",
    resourceFormat: "Hướng dẫn Định dạng {style}",
    resourceInText: "Hướng dẫn Trích dẫn Trong bài {style}",
    resourceAnnotatedBib: "Hướng dẫn Thư mục Có chú giải {style}",
    resourceReferencePage: "Hướng dẫn {list} {style}",
    notFoundTitle: "Không Tìm Thấy",
  },

  // /examples/<style> — the copy-ready worked examples for all 15 detailed styles.
  examplesPage: {
    metaTitle: "Ví dụ Trích dẫn {style} - Mọi Loại Nguồn [2026]",
    metaDescription:
      "Xem các ví dụ trích dẫn {style} ({edition}) đã định dạng cho sách, bài báo tạp chí, trang web và nhiều loại khác. Các mục {list} và trích dẫn trong bài sẵn sàng để sao chép.",
    ogTitle: "Ví dụ trích dẫn {style}",
    ogDescription:
      "Các mục {style} sẵn sàng sao chép cho mọi loại nguồn thường gặp.",
    ogImageTitle: "Ví dụ Trích dẫn {style}",
    ogKind: "{style} {edition}",
    keywordExamples: "ví dụ trích dẫn {style}",
    keywordReference: "ví dụ tài liệu tham khảo {style}",
    keywordInText: "ví dụ trích dẫn trong bài {style}",
    keywordList: "ví dụ {listLower} {style}",
    keywordHowTo: "cách trích dẫn theo {style}",
    breadcrumb: "Ví dụ Trích dẫn {style}",
    heading: "Ví dụ Trích dẫn {style}",
    lead: "Xem các ví dụ trích dẫn {style} ({edition}) được định dạng chính xác cho {count} loại nguồn thường gặp. Mỗi ví dụ gồm cả mục {listLower} và trích dẫn trong bài tương ứng.",
    entryLabel: "Mục {list}:",
    inTextLabel: "Trích dẫn Trong bài:",
    ctaBody:
      "Bỏ qua việc định dạng thủ công. Dán DOI, URL hoặc ISBN vào CitationEasy để nhận trích dẫn {style} được định dạng hoàn hảo chỉ trong vài giây.",
    faqLookQ: "Trích dẫn {style} trông như thế nào?",
    faqLookA:
      "Trích dẫn {style} gồm một mục {listLower} với đầy đủ chi tiết nguồn và một trích dẫn trong bài. Định dạng thay đổi tùy theo loại nguồn. Ví dụ, trích dẫn sách theo {style} ({edition}) gồm tác giả, năm, nhan đề và nhà xuất bản.",
    faqHowManyQ: "Có bao nhiêu ví dụ trích dẫn {style}?",
    faqHowManyA:
      "CitationEasy cung cấp ví dụ trích dẫn {style} cho {count} loại nguồn, bao gồm {types}. Mỗi ví dụ gồm cả mục {listLower} và trích dẫn trong bài tương ứng.",
    faqCopyQ: "Tôi có thể sao chép các ví dụ trích dẫn {style} này không?",
    faqCopyA:
      "Có, các ví dụ {style} trên trang này cho thấy định dạng chính xác cho từng loại nguồn. Bạn có thể dùng chúng làm mẫu cho trích dẫn của riêng mình. Để định dạng tự động, hãy dùng công cụ tạo trích dẫn {style} miễn phí của chúng tôi.",
  },

  // /format/<style> — font, margins, spacing, title page and headers. The VALUES those
  // labels take are per-style prose and live in the overlay, not here.
  formatPage: {
    metaTitle:
      "Hướng dẫn Định dạng {style} - Quy tắc Định dạng Bài viết [2026]",
    metaDescription:
      "Hướng dẫn định dạng bài viết {style} ({edition}) đầy đủ. Tìm hiểu phông chữ, lề, giãn dòng, trang bìa, tiêu đề trang và quy tắc định dạng {listLower} chính xác.",
    ogTitle: "Định dạng bài viết {style}",
    ogDescription:
      "Lề, phông chữ, giãn dòng và trang bìa cho bài viết {style}.",
    ogImageTitle: "Định dạng Bài viết {style}",
    ogImageSubtitle: "Lề {margins} · {spacing}",
    ogKind: "{style} {edition}",
    keywordFormat: "định dạng {style}",
    keywordPaperFormat: "định dạng bài viết {style}",
    keywordRules: "quy tắc định dạng {style}",
    keywordMargins: "lề phông chữ giãn dòng {style}",
    keywordList: "định dạng {listLower} {style}",
    breadcrumb: "Hướng dẫn Định dạng {style}",
    heading: "Hướng dẫn Định dạng {style}",
    lead: "Làm theo các quy tắc định dạng bài viết {style} ({edition}) này để đảm bảo tài liệu của bạn đáp ứng tiêu chuẩn yêu cầu. Hướng dẫn này bao gồm phông chữ, lề, giãn dòng, trang bìa, tiêu đề trang và định dạng {listLower}.",
    paperHeading: "Định dạng Bài viết",
    paperIntro:
      "Dưới đây là các yêu cầu định dạng cốt lõi cho bài viết theo kiểu {style} ({edition}).",
    labelFont: "Phông chữ",
    labelFontSize: "Cỡ chữ",
    labelMargins: "Lề",
    labelSpacing: "Giãn dòng",
    labelTitlePage: "Trang Bìa",
    labelHeaders: "Tiêu đề Trang / Số Trang",
    listHeading: "Định dạng {list}",
    listIntro:
      "{listLower} của bạn phải tuân theo các quy tắc sau để được định dạng đúng theo kiểu {style}:",
    ctaBody:
      "Hãy để CitationEasy xử lý việc định dạng. Dán DOI, URL hoặc ISBN và nhận trích dẫn {style} được định dạng hoàn hảo chỉ trong vài giây.",
    faqFontQ: "Tôi nên dùng phông chữ và cỡ chữ nào cho định dạng {style}?",
    faqFontA:
      "{style} ({edition}) yêu cầu {font}. Cỡ chữ tiêu chuẩn là {fontSize}.",
    faqMarginsQ: "Yêu cầu về lề đối với {style} là gì?",
    faqMarginsA:
      "Bài viết theo {style} yêu cầu {margins}. Điều này áp dụng cho lề trên, dưới, trái và phải của mọi trang.",
    faqTitlePageQ: "{style} có yêu cầu trang bìa không?",
  },

  // /in-text-citation/<style> — the six in-text forms. The forms themselves
  // ("(Smith, 2024)") are per-style prose in the overlay.
  inTextCitationPage: {
    metaTitle: "Hướng dẫn Trích dẫn Trong bài {style} - Quy tắc & Ví dụ [2026]",
    metaDescription:
      "Tìm hiểu cách định dạng trích dẫn trong bài {style} ({edition}). Quy tắc cho một tác giả, nhiều tác giả, trích dẫn trực tiếp, không có tác giả và không có ngày, kèm ví dụ.",
    ogTitle: "Trích dẫn trong bài {style}",
    ogDescription: "Mọi hình thức trích dẫn trong bài {style}, kèm ví dụ.",
    ogImageTitle: "Trích dẫn Trong bài {style}",
    ogImageSubtitle:
      "Một tác giả {singleAuthor} · từ ba tác giả trở lên {threeOrMore}",
    ogKind: "{style} {edition}",
    keywordInText: "trích dẫn trong bài {style}",
    keywordExamples: "ví dụ trích dẫn trong bài {style}",
    keywordParenthetical: "trích dẫn trong ngoặc {style}",
    keywordRules: "quy tắc trích dẫn {style}",
    keywordHowTo: "cách trích dẫn trong bài theo {style}",
    breadcrumb: "Trích dẫn Trong bài {style}",
    heading: "Trích dẫn Trong bài {style}",
    lead: "Thành thạo trích dẫn trong bài {style} ({edition}) với hướng dẫn đầy đủ này. Tìm hiểu định dạng chính xác cho mọi tình huống, bao gồm một và nhiều tác giả, trích dẫn trực tiếp và nguồn thiếu thông tin.",
    rulesHeading: "Quy tắc Trích dẫn Trong bài",
    rulesIntro:
      "Dưới đây là các quy tắc trích dẫn trong bài {style} cho mọi tình huống thường gặp khi viết bài.",
    labelSingleAuthor: "Một Tác giả",
    labelTwoAuthors: "Hai Tác giả",
    labelThreeOrMore: "Từ Ba Tác giả Trở lên",
    labelDirectQuote: "Trích dẫn Trực tiếp",
    labelNoAuthor: "Không có Tác giả",
    labelNoDate: "Không có Ngày",
    examplesHeading: "Ví dụ Nhanh",
    examplesIntro:
      "Dưới đây là các ví dụ trích dẫn trong bài {style} thực tế cho các loại nguồn khác nhau:",
    ctaBody:
      "Đừng lo lắng về việc định dạng trích dẫn trong bài nữa. Dán DOI, URL hoặc ISBN vào CitationEasy để nhận ngay cả mục {listLower} lẫn trích dẫn trong bài.",
    faqFormatQ: "Làm thế nào để định dạng trích dẫn trong bài theo {style}?",
    faqFormatA:
      "Với một tác giả theo {style}, dùng định dạng {singleAuthor}. Với hai tác giả, dùng {twoAuthors}. Với từ ba tác giả trở lên, dùng {threeOrMore}.",
    faqQuoteQ: "Làm thế nào để trích dẫn trực tiếp theo {style}?",
    faqQuoteA:
      "Với trích dẫn trực tiếp theo {style} ({edition}), dùng định dạng: {directQuote}.",
    faqMissingQ:
      "Nếu không có tác giả hoặc không có ngày theo {style} thì sao?",
    faqMissingA:
      "Khi không có tác giả theo {style}, dùng: {noAuthor}. Khi không có ngày, dùng: {noDate}.",
  },

  // /reference-page/<style> — how to build the list at the back of the paper.
  //
  // The five `mistake*` strings carry `**bold**` inline markup because the lead-in of
  // each bullet is emphasised inside the sentence; they render through `InlineText`.
  referenceListPage: {
    metaTitle: "Hướng dẫn {list} {style} - Quy tắc Định dạng [2026]",
    metaDescription:
      "Tìm hiểu cách định dạng {listLower} theo {style} ({edition}). Quy tắc định dạng từng bước, ví dụ và các lỗi thường gặp cần tránh cho {fullName}.",
    ogTitle: "{listLower} {style}",
    ogDescription: "Cách xây dựng {list} theo {style}.",
    ogImageTitle: "{list} {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "Cách Định dạng {list} {style}",
    heading: "Cách Định dạng {list} {style}",
    lead: "{listLower} là một trong những phần quan trọng nhất của bất kỳ bài viết học thuật nào được định dạng theo {style} ({edition}). Nó cung cấp cho người đọc đầy đủ chi tiết của mọi nguồn bạn đã trích dẫn, giúp họ tìm và xác minh tài liệu tham khảo của bạn. Định dạng đúng là điều thiết yếu để đảm bảo độ tin cậy học thuật. Hướng dẫn này trình bày các quy tắc chính xác, đưa ra ví dụ thực tế và chỉ ra những lỗi phổ biến nhất mà sinh viên thường mắc phải.",
    rulesHeading: "Quy tắc Định dạng",
    rulesIntro:
      "Làm theo các quy tắc sau khi tạo {listLower} theo {style} của bạn:",
    exampleHeading: "Ví dụ {list}",
    exampleIntro:
      "Đây là cách {listLower} theo {style} trông như thế nào với các mục cho những loại nguồn khác nhau:",
    mistakesHeading: "Những Lỗi Thường Gặp Cần Tránh",
    mistakesIntro:
      "Đây là năm lỗi định dạng phổ biến nhất mà sinh viên mắc phải khi tạo {listLower} theo {style}:",
    mistakeIndent:
      "**Thiếu hoặc sai thụt lề treo:** Mỗi mục nên có dòng đầu tiên căn lề trái và tất cả các dòng tiếp theo thụt vào 0,5 inch. Hãy dùng cài đặt đoạn văn trong trình soạn thảo văn bản thay vì nhấn phím Tab.",
    mistakeOrder:
      '**Sắp xếp thứ tự chữ cái sai:** Các mục phải được sắp xếp theo quy tắc của {style}. Bỏ qua các mạo từ như "A," "An," và "The" khi sắp xếp theo chữ cái. Với các kiểu đánh số, liệt kê các mục theo thứ tự chúng xuất hiện lần đầu trong bài viết.',
    mistakeSpacing:
      "**Giãn dòng không nhất quán:** Kiểm tra kỹ giãn dòng trong suốt {listLower}. Trộn lẫn giãn dòng đơn và đôi là lỗi phổ biến rất dễ bị bỏ sót.",
    mistakeItalics:
      "**Dùng chữ nghiêng sai:** In nghiêng nhan đề của các tác phẩm độc lập như sách và tạp chí, nhưng không in nghiêng nhan đề bài báo hoặc chương sách. Kiểm tra hướng dẫn của {style} để biết chính xác yếu tố nào cần in nghiêng.",
    mistakeLinks:
      "**Thiếu hoặc hỏng DOI và URL:** Luôn bao gồm DOI khi có, định dạng dưới dạng liên kết có thể nhấp. Kiểm tra mọi URL trước khi nộp bài để đảm bảo nó dẫn đến đúng nguồn.",
    ctaHeading: "Tạo {list} của Bạn Tự động",
    ctaBody:
      "Bỏ qua việc định dạng thủ công. Dán DOI, URL hoặc ISBN vào CitationEasy để nhận trích dẫn {style} được định dạng hoàn hảo trong vài giây, sẵn sàng cho {listLower} của bạn.",
    faqWhatQ: "{list} theo {style} là gì?",
    faqWhatA:
      "{list} theo {style} là phần ở cuối bài viết liệt kê tất cả các nguồn bạn đã trích dẫn trong bài, được định dạng theo hướng dẫn của {fullName} ({edition}). Nó giúp người đọc tìm và xác minh từng nguồn bạn đã tham khảo.",
    faqFormatQ: "Làm thế nào để định dạng {listLower} theo {style}?",
    faqFormatA:
      'Bắt đầu trên một trang mới, đặt tiêu đề là "{list}," và liệt kê tất cả các nguồn bạn đã trích dẫn trong bài. Làm theo các quy tắc cụ thể của {style} về thụt lề treo, giãn dòng, thứ tự chữ cái hoặc đánh số, và in nghiêng.',
    faqDifferenceQ: "Sự khác biệt giữa {listLower} và thư mục tham khảo là gì?",
    faqDifferenceA:
      '{listLower} chỉ bao gồm các nguồn bạn trực tiếp trích dẫn trong bài, trong khi thư mục tham khảo có thể bao gồm cả các nguồn bạn đã tham khảo nhưng không trích dẫn. Theo {style} ({edition}), danh sách ở cuối bài được gọi là "{list}."',
  },

  // /annotated-bibliography/<style>. `whatTypes` carries `**bold**` inline markup.
  //
  // `exampleAnnotation` is a specimen annotation, not a citation: it is ordinary prose
  // about an imaginary source and translates like any other paragraph. The reference
  // entry printed above it does not — that comes from `DETAILED_STYLES` and stays as
  // the style wrote it.
  annotatedBibPage: {
    metaTitle: "Hướng dẫn & Ví dụ Thư mục Có chú giải {style} [2026]",
    metaDescription:
      "Tìm hiểu cách viết thư mục có chú giải theo {style} ({edition}). Bao gồm quy tắc định dạng, ví dụ các mục và mẹo cho thư mục có chú giải theo {fullName}.",
    ogTitle: "Thư mục có chú giải {style}",
    ogDescription: "Cách định dạng thư mục có chú giải theo {style}.",
    ogImageTitle: "Thư mục Có chú giải {style}",
    ogKind: "{style} {edition}",
    breadcrumb: "Thư mục Có chú giải {style}",
    heading: "Thư mục Có chú giải {style}",
    lead: "Thư mục có chú giải là danh sách các trích dẫn nguồn, mỗi mục kèm theo một đoạn văn mô tả hoặc đánh giá ngắn. Theo định dạng {style} ({edition}), mỗi mục bắt đầu bằng một tài liệu tham khảo được định dạng đúng, theo sau là một chú giải tóm tắt, đánh giá hoặc nhận xét về nguồn đó. Hướng dẫn này sẽ dẫn dắt bạn qua các quy tắc, cách định dạng và ví dụ cần thiết để tạo một thư mục có chú giải {style} hoàn chỉnh.",
    whatHeading: "Thư mục Có chú giải Là gì?",
    whatBody:
      "Thư mục có chú giải đi xa hơn một {listLower} thông thường bằng cách thêm một đoạn văn ngắn sau mỗi trích dẫn. Chú giải này giúp người đọc hiểu rõ nội dung, chất lượng và mức độ liên quan của nguồn. Giảng viên thường giao bài tập thư mục có chú giải để giúp sinh viên đánh giá nguồn tài liệu một cách phê phán và chứng minh mỗi nguồn đóng góp như thế nào cho đề tài nghiên cứu của họ.",
    whatTypes:
      "Có ba loại chú giải phổ biến: chú giải **mô tả** tóm tắt nguồn, chú giải **đánh giá** đánh giá chất lượng và độ tin cậy của tác phẩm, và chú giải **kết hợp** làm cả hai việc. Hướng dẫn bài tập của bạn nên nêu rõ loại nào cần sử dụng.",
    rulesHeading: "Quy tắc Thư mục Có chú giải {style}",
    rulesIntro:
      "Làm theo các quy tắc sau khi định dạng thư mục có chú giải theo {fullName}:",
    exampleHeading: "Ví dụ Mục Thư mục Có chú giải",
    exampleIntro:
      "Dưới đây là một mục thư mục có chú giải mẫu theo {style} cho {sourceType}:",
    exampleAnnotation:
      "Nguồn này cung cấp một cái nhìn tổng quan toàn diện về chủ đề, trình bày các luận điểm được hỗ trợ tốt bằng bằng chứng thực nghiệm. Tác giả sử dụng nhiều nguồn sơ cấp và thứ cấp để xây dựng một lập luận thuyết phục. Phương pháp nghiên cứu chặt chẽ và các phát hiện được trình bày rõ ràng, khiến tác phẩm này trở thành một nguồn tài liệu quý giá để hiểu về chủ đề. Nguồn này đặc biệt hữu ích để xây dựng khung lý thuyết cho đề tài nghiên cứu và đưa ra những góc nhìn bổ sung cho các tác phẩm khác trong thư mục.",
    tipsHeading: "Mẹo Viết Chú giải {style}",
    tipSummarize:
      "Bắt đầu bằng cách tóm tắt nguồn trong hai đến ba câu, sau đó thêm đánh giá của bạn về điểm mạnh, hạn chế và mức độ liên quan của nguồn.",
    tipTone:
      "Sử dụng ngôi thứ ba và giọng văn học thuật xuyên suốt các chú giải của bạn. Tránh ngôn ngữ thông thường hoặc suy nghĩ ở ngôi thứ nhất trừ khi giảng viên yêu cầu.",
    tipLength:
      "Giữ mỗi chú giải trong khoảng 100 đến 200 từ. Hãy súc tích và tập trung vào những khía cạnh quan trọng nhất của nguồn.",
    tipRelevance:
      "Giải thích nguồn này phù hợp với nghiên cứu tổng thể của bạn như thế nào. Mô tả góc nhìn hoặc bằng chứng độc đáo mà nó đóng góp.",
    tipCitation:
      "Đảm bảo phần trích dẫn của mỗi mục tuân theo chính xác quy tắc định dạng của {fullName} trước khi viết chú giải.",
    ctaHeading: "Xây dựng Thư mục Có chú giải của Bạn Tự động",
    ctaBody:
      "Sử dụng Công cụ Tạo Thư mục Có chú giải của CitationEasy để tạo trích dẫn {style} được định dạng đúng, sau đó thêm chú giải của bạn.",
    ctaButton: "Mở Công cụ Tạo Thư mục Có chú giải →",
    faqWhatQ: "Thư mục có chú giải theo {style} là gì?",
    faqWhatA:
      "Thư mục có chú giải theo {style} ({edition}) là danh sách các trích dẫn được định dạng theo kiểu {fullName}, mỗi trích dẫn kèm theo một đoạn văn ngắn tóm tắt, đánh giá hoặc nhận xét về nguồn. Nó giúp người đọc hiểu được mức độ liên quan và chất lượng của từng nguồn.",
    faqLengthQ: "Chú giải nên dài bao nhiêu?",
    faqLengthA:
      "Chú giải thường dài từ 100 đến 200 từ. Một số bài tập có thể yêu cầu chú giải ngắn hơn hoặc dài hơn tùy vào mức độ phân tích được yêu cầu. Luôn kiểm tra hướng dẫn của giảng viên để biết yêu cầu cụ thể về độ dài.",
    faqIncludeQ: "Một chú giải nên bao gồm những gì?",
    faqIncludeA:
      "Một chú giải nên bao gồm phần tóm tắt ngắn gọn luận điểm chính hoặc phát hiện của nguồn, đánh giá về độ tin cậy và tính hữu ích của nguồn, và nhận xét về việc nguồn đó phù hợp với nghiên cứu của bạn như thế nào. Một số chú giải chỉ mang tính mô tả, trong khi số khác bao gồm phân tích phê phán.",
  },

  guidePage: {
    byline: "Biên soạn: {author}",
    published: "Xuất bản {date}",
    updated: "Cập nhật {date}",
    readingTime: "other:{count} phút đọc",
    wordCount: "other:{count} từ",
  },

  // /guides hub, /guides/<category> index pages, and the chrome around each guide
  guideLibrary: {
    eyebrow: "Thư viện hướng dẫn",
    browseByCategory: "Duyệt theo danh mục",
    recentlyUpdated: "Mới cập nhật",
    allGuides: "Tất cả hướng dẫn",
    guideCount: "other:{count} hướng dẫn",
    updatedOn: "Cập nhật {date}",
    minRead: "other:{count} phút đọc",
    onThisPage: "Trên trang này",
    viewAllInCategory: "Tất cả hướng dẫn {category}",
    moreInCategory: "Thêm trong {category}",
    aboutThisGuide: "Về hướng dẫn này",
    provenance:
      "Biên soạn bởi {author}. Xuất bản {published}; cập nhật lần cuối {updated}.",
    categoryIntroSuffix:
      "Mọi hướng dẫn đều miễn phí, viết cho sinh viên và nhà nghiên cứu, và có ghi ngày để bạn biết lần kiểm tra gần nhất.",
    photoCredit: "Ảnh: {author}, {source} ({license})",
    imageAlt: "Ảnh minh họa cho các hướng dẫn {category}",
    imageSourceCommons: "Wikimedia Commons",
    apaStyleName: "Kiểu APA",
    apaStyleDescription:
      "Cách trích dẫn trang web, bài báo tạp chí, sách, video và nhiều nguồn khác theo APA phiên bản 7, kèm ví dụ danh mục tham khảo và trích dẫn trong văn bản.",
    mlaStyleName: "Kiểu MLA",
    mlaStyleDescription:
      "Cách trích dẫn mọi nguồn phổ biến theo MLA phiên bản 9, từ trang web và bài báo đến thơ, kịch, phim và tài liệu học tập.",
    chicagoStyleName: "Kiểu Chicago",
    chicagoStyleDescription:
      "Hướng dẫn Chicago Manual of Style về trích dẫn chú thích-thư mục và tác giả-năm cho sách, bài báo, tài liệu lưu trữ, văn bản chính phủ và truyền thông.",
    styleComparisonsName: "So sánh kiểu trích dẫn",
    styleComparisonsDescription:
      "So sánh trực tiếp APA, MLA, Chicago, Harvard, Vancouver, IEEE và nhiều kiểu khác, kèm lời khuyên về kiểu mà ngành của bạn yêu cầu.",
    researchMethodsName: "Phương pháp nghiên cứu",
    researchMethodsDescription:
      "Cách lập kế hoạch bài nghiên cứu, tổng quan tài liệu, ghi chép, đánh giá nguồn, tránh đạo văn và xây dựng thư mục.",
    academicWritingName: "Viết học thuật",
    academicWritingDescription:
      "Hướng dẫn viết tóm tắt, mở đầu, kết luận, luận điểm, phần phương pháp và văn phong học thuật rõ ràng.",
    fieldSpecificName: "Theo chuyên ngành",
    fieldSpecificDescription:
      "Hướng dẫn trích dẫn cho từng ngành, từ tâm lý học, lịch sử, văn học đến y học, kỹ thuật, luật và điều dưỡng.",
    sourceEvaluationName: "Đánh giá nguồn",
    sourceEvaluationDescription:
      "Cách đánh giá độ tin cậy, phân biệt nguồn học thuật và đại chúng, dùng Google Scholar và cơ sở dữ liệu thư viện, và nhận ra thiên kiến.",
    citationHelpName: "Trợ giúp trích dẫn",
    citationHelpDescription:
      "Giải đáp các trường hợp khó: thiếu tác giả hoặc ngày, nhiều tác giả, PDF, công cụ AI, án lệ, và nhập hoặc xuất trích dẫn.",
  },

  common: {
    backToGuides: "← Quay lại hướng dẫn",
    free: "Miễn phí",
    noSignup: "Không cần đăng ký",
    backToHome: "Quay lại công cụ tạo trích dẫn",
    inEnglish: "Bằng tiếng Anh",
    viewInEnglish: "Xem bằng tiếng Anh",
    availableInEnglish: "Trang này có bản tiếng Anh với nội dung chi tiết hơn.",
    otherLanguages: "Ngôn ngữ khác",
    skipToContent: "Chuyển đến nội dung",
    cookieNotice:
      "Chúng tôi dùng cookie cho phân tích và quảng cáo để giữ CitationEasy miễn phí.",
    privacyPolicy: "Chính sách quyền riêng tư",
    accept: "Chấp nhận",
    decline: "Từ chối",
    advertisement: "Quảng cáo",
  },
  legalPage: {
    backLink: "← Quay lại Công cụ Tạo",
    effective: "Ngày có hiệu lực:",
    updated: "Cập nhật lần cuối:",
  },
};

export default vi;
